/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
  APILevelT,
  AcceptLegalAgreementsRequestT,
  AddAdditionalAccessRequestT,
  AddAllergyToPatientByUserIdBody,
  AddPatientPharmacyRequestT,
  AllBankLinksResponseT,
  AllergySearchPagedListResponseT,
  AllergySearchResultT,
  ApplyPlanModificationsRequestT,
  ApplyPlanModificationsResponseT,
  ApproveRefillRequestT,
  ApproveRxChangeRequestT,
  ArchiveSurvey200,
  AssignRecipientIdRequestT,
  BankLinkT,
  CareHydratePatientsRequestT,
  CareHydratePatientsResponseT,
  CareSearchPatientsRequestT,
  CareSearchPatientsResponseT,
  ChangePrescriptionPharmacyRequestT,
  ChangeRxChangePatientRequestT,
  ClinicianActivityEventsResponseT,
  ClinicianApplicationT,
  ClinicianBankDetailsResponseT,
  ClinicianBankLinkInfoT,
  ClinicianPayoutDashboardResponseT,
  CreateDosespotClinicianRequestT,
  CreateLabTestRequestT,
  CreateLabTestResponseT,
  CreateOwnPhrSurvey200,
  CreatePrescriptionRequestT,
  DeletePriorAuthAttachment200,
  DenyRefillRequestT,
  DenyRxChangeRequestT,
  DoseSpotClinicianAgreementT,
  DoseSpotClinicianInfoT,
  DoseSpotPatientSyncResultT,
  DosespotClinicianRecordT,
  DosespotIDPRecordT,
  EditPatientAllergyRequestT,
  EditPrescriptionRequestT,
  ErxRegistrationStatusTypeT,
  ExchangeDosespotPatientInfoForRxchangeRxrenewalrequest200,
  FetchAttachmentVariantRequestT,
  FetchAvailableSourcesResponseT,
  FetchBankingDetailsResponseT,
  FetchChatParams,
  FetchChatResponseT,
  FetchClinicianApplicationsReplyT,
  FetchConversationsResponseT,
  FetchCurrentClinicianOnboardingStepReplyT,
  FetchEmployeeRecordReplyT,
  FetchEmployeeRollReplyT,
  FetchIdentificationReplyT,
  FetchLabOrdersParams,
  FetchLabOrdersResponseT,
  FetchPHRResponseT,
  FetchPatientInfoResponseT,
  FetchPrimaryChatParams,
  FetchStateResponseT,
  FetchTimelineParams,
  FetchTimelineResponseT,
  FetchViewUrlForVariantReplyT,
  FetchViewersForPatientResponseT,
  GetClinicianActivityEventsParams,
  GetClinicianBankDetailsParams,
  GetDosespotClinicianInfoByUserId200,
  GetDosespotPatientInfo200,
  GetKarmaChartParams,
  GetKarmaTotalParams,
  GetMedicationMonographParams,
  GetMyDosespotClinicianInfo200,
  GetMyDosespotPatientInfo200,
  GetMyIdpStatus200,
  GetMyNotificationCountsParams,
  GetMyTransmissionErrorsParams,
  GetPatientByDosespotId200,
  GetPatientFormularyForDrugParams,
  GetPendingRefillsDetailedParams,
  GetPendingRefillsParams,
  GetPendingRxChangesDetailedParams,
  GetPrescription200,
  GetPrescriptionByDosespotId200,
  GetPrescriptionsForPatientParams,
  GetSurvey200,
  HTTPValidationError,
  HostageStagingInputT,
  IdentifierResponseT,
  IdpDisclaimerT,
  KarmaChartResponseT,
  KarmaPayoutHistoryResponseT,
  KarmaTotalResponseT,
  LinkBankAccountRequestT,
  ListResultT,
  ListSurveysReplyT,
  LoadResultT,
  MarkExecutedRequestT,
  MarkExecutedResponseT,
  MedicationSearchResultT,
  MedicationSelectResultT,
  PaginatedPrescriptionsResponseT,
  PatientAllergyT,
  PatientEligibilitiesResponseT,
  PatientFormularyResponseT,
  PatientKarmaOffersResponseT,
  PatientPharmacyT,
  PharmacyPagedListResponseT,
  PharmacyT,
  PrescriberNotificationCountsT,
  PrescriptionLogT,
  PrescriptionMessageT,
  PrescriptionT,
  PreviewPriorAuthRequestT,
  PreviewPriorAuthResponseT,
  PriorAuthActionBody,
  PriorAuthActionResponseT,
  PriorAuthCaseDetailsT,
  PriorAuthSummaryT,
  PriorAuthSyncResponseT,
  ReconcileRxChangeRequestT,
  RefillActionBody,
  RefillDetailedPagedListResponseT,
  RefillPagedListResponseT,
  RejectWithRevisionRequestT,
  RejectWithRevisionResponseT,
  ReplaceRefillRequestT,
  ResolveICD10RequestT,
  ResolveICD10ResponseT,
  ResponseT,
  RunPayoutSweepResponseT,
  RxChangeAction200,
  RxChangeActionBody,
  RxChangeDetailedPagedListResponseT,
  SearchAllergensParams,
  SearchBiomarkersRequestT,
  SearchBiomarkersResponseT,
  SearchICD10RequestT,
  SearchICD10ResponseT,
  SearchLabTestsRequestT,
  SearchLabTestsResponseT,
  SearchMedicationsParams,
  SearchPharmaciesBody,
  SearchPharmaciesParams,
  SearchStockPayersArgsT,
  SearchStockPayersResultT,
  SearchSuppliesParams,
  SelectMedicationParams,
  SendPrescriptionsRequestT,
  SendPrescriptionsResponseT,
  ServerStatusResponseT,
  SetPrescriptionsReadyToSignRequestT,
  ShelfLoadParams,
  StandardDispenseUnitTypeT,
  StoreArgsT,
  StreamStateEvents200Item,
  StreamStateEventsParams,
  SubmitAnswers200,
  SubmitAnswersRequestT,
  SubmitCredentialing200,
  SubmitCredentialingRequestT,
  SubmitDemographicInfoRequestT,
  SubmitIDPAnswersRequestT,
  SubmitIDPOTPRequestT,
  SubmitLabOrderRequestT,
  SubmitLabOrderResponseT,
  SubmitNativeApplication200,
  SubmitNativeApplicationRequestT,
  SuggestPatientResponseT,
  SupplySearchResultT,
  SwitchToAlternativeRequestT,
  SwitchToAlternativeResponseT,
  TransmissionErrorsPagedListResponseT,
  UnifiedSearchRequestT,
  UnifiedSearchResponseT,
  UpdateBankingDetailsRequestT,
  UpdateDosespotClinicianRequestT,
  UpdateEmployeeFromRollReplyT,
  UpdateEmployeeFromRollRequestT,
  UpdateEmployeeRecordReplyT,
  UpdateEmployeeRecordRequestT,
  UpdateStateRequestT,
  UpdateStateResponseT,
  UserWithoutDosespotRecordT,
  WorkflowsAvailableT,
} from "../schemas";

/**
 * @summary Fetch Server Status
 */
export const fetchServerStatus = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ServerStatusResponseT>> => {
  return axios.default.get(`/greenfield/server_status`, options);
};

export const getFetchServerStatusQueryKey = () => {
  return [`/greenfield/server_status`] as const;
};

export const getFetchServerStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchServerStatus>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchServerStatus>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFetchServerStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchServerStatus>>
  > = ({ signal }) => fetchServerStatus({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchServerStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchServerStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchServerStatus>>
>;
export type FetchServerStatusQueryError = AxiosError<unknown>;

export function useFetchServerStatus<
  TData = Awaited<ReturnType<typeof fetchServerStatus>>,
  TError = AxiosError<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchServerStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchServerStatus>>,
          TError,
          Awaited<ReturnType<typeof fetchServerStatus>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchServerStatus<
  TData = Awaited<ReturnType<typeof fetchServerStatus>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchServerStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchServerStatus>>,
          TError,
          Awaited<ReturnType<typeof fetchServerStatus>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchServerStatus<
  TData = Awaited<ReturnType<typeof fetchServerStatus>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchServerStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Server Status
 */

export function useFetchServerStatus<
  TData = Awaited<ReturnType<typeof fetchServerStatus>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchServerStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchServerStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add Additional Access
 */
export const addAdditionalAccess = (
  level: APILevelT,
  addAdditionalAccessRequestT: AddAdditionalAccessRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.post(
    `/greenfield/${level}/me/additional_access`,
    addAdditionalAccessRequestT,
    options,
  );
};

export const getAddAdditionalAccessMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addAdditionalAccess>>,
    TError,
    { level: APILevelT; data: AddAdditionalAccessRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addAdditionalAccess>>,
  TError,
  { level: APILevelT; data: AddAdditionalAccessRequestT },
  TContext
> => {
  const mutationKey = ["addAdditionalAccess"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addAdditionalAccess>>,
    { level: APILevelT; data: AddAdditionalAccessRequestT }
  > = (props) => {
    const { level, data } = props ?? {};

    return addAdditionalAccess(level, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddAdditionalAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof addAdditionalAccess>>
>;
export type AddAdditionalAccessMutationBody = AddAdditionalAccessRequestT;
export type AddAdditionalAccessMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Add Additional Access
 */
export const useAddAdditionalAccess = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addAdditionalAccess>>,
      TError,
      { level: APILevelT; data: AddAdditionalAccessRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addAdditionalAccess>>,
  TError,
  { level: APILevelT; data: AddAdditionalAccessRequestT },
  TContext
> => {
  const mutationOptions = getAddAdditionalAccessMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Submit Native Application
 */
export const submitNativeApplication = (
  submitNativeApplicationRequestT: SubmitNativeApplicationRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SubmitNativeApplication200>> => {
  return axios.default.post(
    `/greenfield/clinician-application/me/submit-native`,
    submitNativeApplicationRequestT,
    options,
  );
};

export const getSubmitNativeApplicationMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitNativeApplication>>,
    TError,
    { data: SubmitNativeApplicationRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitNativeApplication>>,
  TError,
  { data: SubmitNativeApplicationRequestT },
  TContext
> => {
  const mutationKey = ["submitNativeApplication"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitNativeApplication>>,
    { data: SubmitNativeApplicationRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return submitNativeApplication(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitNativeApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitNativeApplication>>
>;
export type SubmitNativeApplicationMutationBody =
  SubmitNativeApplicationRequestT;
export type SubmitNativeApplicationMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Submit Native Application
 */
export const useSubmitNativeApplication = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitNativeApplication>>,
      TError,
      { data: SubmitNativeApplicationRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitNativeApplication>>,
  TError,
  { data: SubmitNativeApplicationRequestT },
  TContext
> => {
  const mutationOptions = getSubmitNativeApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Submit Credentialing
 */
export const submitCredentialing = (
  submitCredentialingRequestT: SubmitCredentialingRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SubmitCredentialing200>> => {
  return axios.default.post(
    `/greenfield/clinician-application/me/submit-credentialing`,
    submitCredentialingRequestT,
    options,
  );
};

export const getSubmitCredentialingMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitCredentialing>>,
    TError,
    { data: SubmitCredentialingRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitCredentialing>>,
  TError,
  { data: SubmitCredentialingRequestT },
  TContext
> => {
  const mutationKey = ["submitCredentialing"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitCredentialing>>,
    { data: SubmitCredentialingRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return submitCredentialing(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitCredentialingMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitCredentialing>>
>;
export type SubmitCredentialingMutationBody = SubmitCredentialingRequestT;
export type SubmitCredentialingMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Submit Credentialing
 */
export const useSubmitCredentialing = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitCredentialing>>,
      TError,
      { data: SubmitCredentialingRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitCredentialing>>,
  TError,
  { data: SubmitCredentialingRequestT },
  TContext
> => {
  const mutationOptions = getSubmitCredentialingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Fetch Clinician Applications Admin
 */
export const fetchClinicianApplicationsAdmin = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchClinicianApplicationsReplyT>> => {
  return axios.default.get(`/greenfield/clinician-application/admin`, options);
};

export const getFetchClinicianApplicationsAdminQueryKey = () => {
  return [`/greenfield/clinician-application/admin`] as const;
};

export const getFetchClinicianApplicationsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchClinicianApplicationsAdminQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>
  > = ({ signal }) =>
    fetchClinicianApplicationsAdmin({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchClinicianApplicationsAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>
>;
export type FetchClinicianApplicationsAdminQueryError =
  AxiosError<HTTPValidationError>;

export function useFetchClinicianApplicationsAdmin<
  TData = Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
          TError,
          Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchClinicianApplicationsAdmin<
  TData = Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
          TError,
          Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchClinicianApplicationsAdmin<
  TData = Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Clinician Applications Admin
 */

export function useFetchClinicianApplicationsAdmin<
  TData = Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchClinicianApplicationsAdmin>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchClinicianApplicationsAdminQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Clinician Application Admin
 */
export const updateClinicianApplicationAdmin = (
  applicationId: string,
  clinicianApplicationT: ClinicianApplicationT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ClinicianApplicationT>> => {
  return axios.default.put(
    `/greenfield/clinician-application/admin/${applicationId}`,
    clinicianApplicationT,
    options,
  );
};

export const getUpdateClinicianApplicationAdminMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClinicianApplicationAdmin>>,
    TError,
    { applicationId: string; data: ClinicianApplicationT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClinicianApplicationAdmin>>,
  TError,
  { applicationId: string; data: ClinicianApplicationT },
  TContext
> => {
  const mutationKey = ["updateClinicianApplicationAdmin"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClinicianApplicationAdmin>>,
    { applicationId: string; data: ClinicianApplicationT }
  > = (props) => {
    const { applicationId, data } = props ?? {};

    return updateClinicianApplicationAdmin(applicationId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClinicianApplicationAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClinicianApplicationAdmin>>
>;
export type UpdateClinicianApplicationAdminMutationBody = ClinicianApplicationT;
export type UpdateClinicianApplicationAdminMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Update Clinician Application Admin
 */
export const useUpdateClinicianApplicationAdmin = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateClinicianApplicationAdmin>>,
      TError,
      { applicationId: string; data: ClinicianApplicationT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateClinicianApplicationAdmin>>,
  TError,
  { applicationId: string; data: ClinicianApplicationT },
  TContext
> => {
  const mutationOptions =
    getUpdateClinicianApplicationAdminMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Fetch Current Clinician Onboarding Step
 */
export const fetchCurrentClinicianOnboardingStep = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchCurrentClinicianOnboardingStepReplyT>> => {
  return axios.default.get(
    `/greenfield/clinician_onboarding/me/current_step`,
    options,
  );
};

export const getFetchCurrentClinicianOnboardingStepQueryKey = () => {
  return [`/greenfield/clinician_onboarding/me/current_step`] as const;
};

export const getFetchCurrentClinicianOnboardingStepQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchCurrentClinicianOnboardingStepQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>
  > = ({ signal }) =>
    fetchCurrentClinicianOnboardingStep({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchCurrentClinicianOnboardingStepQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>
>;
export type FetchCurrentClinicianOnboardingStepQueryError =
  AxiosError<HTTPValidationError>;

export function useFetchCurrentClinicianOnboardingStep<
  TData = Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
          TError,
          Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchCurrentClinicianOnboardingStep<
  TData = Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
          TError,
          Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchCurrentClinicianOnboardingStep<
  TData = Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Current Clinician Onboarding Step
 */

export function useFetchCurrentClinicianOnboardingStep<
  TData = Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchCurrentClinicianOnboardingStep>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getFetchCurrentClinicianOnboardingStepQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new DoseSpot clinician record for a user.

This endpoint creates a DoseSpot clinician account for the specified user,
validates that they are an employee, and ensures no duplicate records.

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the target user is not an employee or already has a record
 * @summary Create Dosespot Clinician
 */
export const createDosespotClinician = (
  createDosespotClinicianRequestT: CreateDosespotClinicianRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DosespotClinicianRecordT>> => {
  return axios.default.post(
    `/greenfield/dosespot/clinician/create`,
    createDosespotClinicianRequestT,
    options,
  );
};

export const getCreateDosespotClinicianMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDosespotClinician>>,
    TError,
    { data: CreateDosespotClinicianRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDosespotClinician>>,
  TError,
  { data: CreateDosespotClinicianRequestT },
  TContext
> => {
  const mutationKey = ["createDosespotClinician"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDosespotClinician>>,
    { data: CreateDosespotClinicianRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return createDosespotClinician(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDosespotClinicianMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDosespotClinician>>
>;
export type CreateDosespotClinicianMutationBody =
  CreateDosespotClinicianRequestT;
export type CreateDosespotClinicianMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Create Dosespot Clinician
 */
export const useCreateDosespotClinician = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDosespotClinician>>,
      TError,
      { data: CreateDosespotClinicianRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDosespotClinician>>,
  TError,
  { data: CreateDosespotClinicianRequestT },
  TContext
> => {
  const mutationOptions = getCreateDosespotClinicianMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List all employee users who don't have DoseSpot clinician records.

This endpoint returns all users who have employee records but no associated
DoseSpot clinician records, useful for identifying who can be onboarded.

Raises:
    AuthException: If the user lacks required privileges
 * @summary List Users Without Dosespot Records
 */
export const listUsersWithoutDosespotRecords = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserWithoutDosespotRecordT[]>> => {
  return axios.default.get(
    `/greenfield/dosespot/clinician/users/without_records`,
    options,
  );
};

export const getListUsersWithoutDosespotRecordsQueryKey = () => {
  return [`/greenfield/dosespot/clinician/users/without_records`] as const;
};

export const getListUsersWithoutDosespotRecordsQueryOptions = <
  TData = Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListUsersWithoutDosespotRecordsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>
  > = ({ signal }) =>
    listUsersWithoutDosespotRecords({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUsersWithoutDosespotRecordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>
>;
export type ListUsersWithoutDosespotRecordsQueryError =
  AxiosError<HTTPValidationError>;

export function useListUsersWithoutDosespotRecords<
  TData = Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
          TError,
          Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUsersWithoutDosespotRecords<
  TData = Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
          TError,
          Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUsersWithoutDosespotRecords<
  TData = Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Users Without Dosespot Records
 */

export function useListUsersWithoutDosespotRecords<
  TData = Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersWithoutDosespotRecords>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListUsersWithoutDosespotRecordsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all users who have DoseSpot clinician records.

This endpoint returns all existing DoseSpot clinician records,
useful for administrative oversight.

Raises:
    AuthException: If the user lacks required privileges
 * @summary List Users With Dosespot Records
 */
export const listUsersWithDosespotRecords = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DosespotClinicianRecordT[]>> => {
  return axios.default.get(
    `/greenfield/dosespot/clinician/users/with_records`,
    options,
  );
};

export const getListUsersWithDosespotRecordsQueryKey = () => {
  return [`/greenfield/dosespot/clinician/users/with_records`] as const;
};

export const getListUsersWithDosespotRecordsQueryOptions = <
  TData = Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListUsersWithDosespotRecordsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUsersWithDosespotRecords>>
  > = ({ signal }) => listUsersWithDosespotRecords({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUsersWithDosespotRecordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUsersWithDosespotRecords>>
>;
export type ListUsersWithDosespotRecordsQueryError =
  AxiosError<HTTPValidationError>;

export function useListUsersWithDosespotRecords<
  TData = Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
          TError,
          Awaited<ReturnType<typeof listUsersWithDosespotRecords>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUsersWithDosespotRecords<
  TData = Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
          TError,
          Awaited<ReturnType<typeof listUsersWithDosespotRecords>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUsersWithDosespotRecords<
  TData = Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Users With Dosespot Records
 */

export function useListUsersWithDosespotRecords<
  TData = Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersWithDosespotRecords>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListUsersWithDosespotRecordsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get current DoseSpot clinician information for a specific user.

This endpoint retrieves the stored clinician information for the specified user.

Args:
    user_id: The user ID to fetch clinician info for

Returns:
    Current DoseSpot clinician information, or None if no record exists

Raises:
    AuthException: If the user lacks required privileges
 * @summary Get Dosespot Clinician Info By User Id
 */
export const getDosespotClinicianInfoByUserId = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetDosespotClinicianInfoByUserId200>> => {
  return axios.default.get(
    `/greenfield/dosespot/clinician/info/${userId}`,
    options,
  );
};

export const getGetDosespotClinicianInfoByUserIdQueryKey = (
  userId?: string,
) => {
  return [`/greenfield/dosespot/clinician/info/${userId}`] as const;
};

export const getGetDosespotClinicianInfoByUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDosespotClinicianInfoByUserIdQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>
  > = ({ signal }) =>
    getDosespotClinicianInfoByUserId(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDosespotClinicianInfoByUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>
>;
export type GetDosespotClinicianInfoByUserIdQueryError =
  AxiosError<HTTPValidationError>;

export function useGetDosespotClinicianInfoByUserId<
  TData = Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
          TError,
          Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDosespotClinicianInfoByUserId<
  TData = Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
          TError,
          Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDosespotClinicianInfoByUserId<
  TData = Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Dosespot Clinician Info By User Id
 */

export function useGetDosespotClinicianInfoByUserId<
  TData = Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDosespotClinicianInfoByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDosespotClinicianInfoByUserIdQueryOptions(
    userId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get current DoseSpot clinician information for the authenticated user.

This endpoint retrieves the stored clinician information for the authenticated user.

Returns:
    Current DoseSpot clinician information, or None if no record exists

Raises:
    AuthException: If the user lacks required privileges
 * @summary Get My Dosespot Clinician Info
 */
export const getMyDosespotClinicianInfo = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetMyDosespotClinicianInfo200>> => {
  return axios.default.get(`/greenfield/dosespot/clinician/me`, options);
};

export const getGetMyDosespotClinicianInfoQueryKey = () => {
  return [`/greenfield/dosespot/clinician/me`] as const;
};

export const getGetMyDosespotClinicianInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyDosespotClinicianInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>
  > = ({ signal }) => getMyDosespotClinicianInfo({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyDosespotClinicianInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>
>;
export type GetMyDosespotClinicianInfoQueryError =
  AxiosError<HTTPValidationError>;

export function useGetMyDosespotClinicianInfo<
  TData = Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
          TError,
          Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyDosespotClinicianInfo<
  TData = Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
          TError,
          Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyDosespotClinicianInfo<
  TData = Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Dosespot Clinician Info
 */

export function useGetMyDosespotClinicianInfo<
  TData = Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyDosespotClinicianInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyDosespotClinicianInfoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an existing DoseSpot clinician record.

This endpoint updates the DoseSpot clinician information for the specified user.

Args:
    user_id: The user ID of the clinician to update
    request: The updated clinician information

Returns:
    The updated DoseSpot clinician record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the user
 * @summary Update Dosespot Clinician
 */
export const updateDosespotClinician = (
  userId: string,
  updateDosespotClinicianRequestT: UpdateDosespotClinicianRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DosespotClinicianRecordT>> => {
  return axios.default.post(
    `/greenfield/dosespot/clinician/update/${userId}`,
    updateDosespotClinicianRequestT,
    options,
  );
};

export const getUpdateDosespotClinicianMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDosespotClinician>>,
    TError,
    { userId: string; data: UpdateDosespotClinicianRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDosespotClinician>>,
  TError,
  { userId: string; data: UpdateDosespotClinicianRequestT },
  TContext
> => {
  const mutationKey = ["updateDosespotClinician"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDosespotClinician>>,
    { userId: string; data: UpdateDosespotClinicianRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateDosespotClinician(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDosespotClinicianMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDosespotClinician>>
>;
export type UpdateDosespotClinicianMutationBody =
  UpdateDosespotClinicianRequestT;
export type UpdateDosespotClinicianMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Update Dosespot Clinician
 */
export const useUpdateDosespotClinician = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDosespotClinician>>,
      TError,
      { userId: string; data: UpdateDosespotClinicianRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateDosespotClinician>>,
  TError,
  { userId: string; data: UpdateDosespotClinicianRequestT },
  TContext
> => {
  const mutationOptions = getUpdateDosespotClinicianMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Update the authenticated user's DoseSpot clinician record.

This endpoint updates the DoseSpot clinician information for the authenticated user.

Args:
    request: The updated clinician information

Returns:
    The updated DoseSpot clinician record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the authenticated user
 * @summary Update My Dosespot Clinician
 */
export const updateMyDosespotClinician = (
  updateDosespotClinicianRequestT: UpdateDosespotClinicianRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DosespotClinicianRecordT>> => {
  return axios.default.post(
    `/greenfield/dosespot/clinician/update/me`,
    updateDosespotClinicianRequestT,
    options,
  );
};

export const getUpdateMyDosespotClinicianMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyDosespotClinician>>,
    TError,
    { data: UpdateDosespotClinicianRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyDosespotClinician>>,
  TError,
  { data: UpdateDosespotClinicianRequestT },
  TContext
> => {
  const mutationKey = ["updateMyDosespotClinician"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyDosespotClinician>>,
    { data: UpdateDosespotClinicianRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyDosespotClinician(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyDosespotClinicianMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyDosespotClinician>>
>;
export type UpdateMyDosespotClinicianMutationBody =
  UpdateDosespotClinicianRequestT;
export type UpdateMyDosespotClinicianMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Update My Dosespot Clinician
 */
export const useUpdateMyDosespotClinician = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyDosespotClinician>>,
      TError,
      { data: UpdateDosespotClinicianRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyDosespotClinician>>,
  TError,
  { data: UpdateDosespotClinicianRequestT },
  TContext
> => {
  const mutationOptions = getUpdateMyDosespotClinicianMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get registration status for the authenticated user.

Returns:
    ErxRegistrationStatusTypeT: The current registration status

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get My Registration Status
 */
export const getMyRegistrationStatus = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ErxRegistrationStatusTypeT>> => {
  return axios.default.get(
    `/greenfield/dosespot/clinician/registration_status/me`,
    options,
  );
};

export const getGetMyRegistrationStatusQueryKey = () => {
  return [`/greenfield/dosespot/clinician/registration_status/me`] as const;
};

export const getGetMyRegistrationStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyRegistrationStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMyRegistrationStatus>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyRegistrationStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyRegistrationStatus>>
  > = ({ signal }) => getMyRegistrationStatus({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyRegistrationStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyRegistrationStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyRegistrationStatus>>
>;
export type GetMyRegistrationStatusQueryError = AxiosError<HTTPValidationError>;

export function useGetMyRegistrationStatus<
  TData = Awaited<ReturnType<typeof getMyRegistrationStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyRegistrationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRegistrationStatus>>,
          TError,
          Awaited<ReturnType<typeof getMyRegistrationStatus>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyRegistrationStatus<
  TData = Awaited<ReturnType<typeof getMyRegistrationStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyRegistrationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRegistrationStatus>>,
          TError,
          Awaited<ReturnType<typeof getMyRegistrationStatus>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyRegistrationStatus<
  TData = Awaited<ReturnType<typeof getMyRegistrationStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyRegistrationStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Registration Status
 */

export function useGetMyRegistrationStatus<
  TData = Awaited<ReturnType<typeof getMyRegistrationStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyRegistrationStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyRegistrationStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get registration status for a specific user.

Args:
    user_id: The user ID to get registration status for

Returns:
    ErxRegistrationStatusTypeT: The current registration status

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Registration Status By User Id
 */
export const getRegistrationStatusByUserId = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ErxRegistrationStatusTypeT>> => {
  return axios.default.get(
    `/greenfield/dosespot/clinician/registration_status/${userId}`,
    options,
  );
};

export const getGetRegistrationStatusByUserIdQueryKey = (userId?: string) => {
  return [
    `/greenfield/dosespot/clinician/registration_status/${userId}`,
  ] as const;
};

export const getGetRegistrationStatusByUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRegistrationStatusByUserIdQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRegistrationStatusByUserId>>
  > = ({ signal }) =>
    getRegistrationStatusByUserId(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRegistrationStatusByUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegistrationStatusByUserId>>
>;
export type GetRegistrationStatusByUserIdQueryError =
  AxiosError<HTTPValidationError>;

export function useGetRegistrationStatusByUserId<
  TData = Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
          TError,
          Awaited<ReturnType<typeof getRegistrationStatusByUserId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegistrationStatusByUserId<
  TData = Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
          TError,
          Awaited<ReturnType<typeof getRegistrationStatusByUserId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegistrationStatusByUserId<
  TData = Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Registration Status By User Id
 */

export function useGetRegistrationStatusByUserId<
  TData = Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRegistrationStatusByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRegistrationStatusByUserIdQueryOptions(
    userId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Refresh the authenticated user's DoseSpot clinician information from the API.

This endpoint fetches the latest clinician information from DoseSpot API
and updates the stored record with the current data for the authenticated user.

Returns:
    The updated DoseSpot clinician information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the authenticated user
 * @summary Refresh My Dosespot Clinician Info
 */
export const refreshMyDosespotClinicianInfo = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DoseSpotClinicianInfoT>> => {
  return axios.default.post(
    `/greenfield/dosespot/clinician/refresh/me`,
    undefined,
    options,
  );
};

export const getRefreshMyDosespotClinicianInfoMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshMyDosespotClinicianInfo>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshMyDosespotClinicianInfo>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["refreshMyDosespotClinicianInfo"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshMyDosespotClinicianInfo>>,
    void
  > = () => {
    return refreshMyDosespotClinicianInfo(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshMyDosespotClinicianInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshMyDosespotClinicianInfo>>
>;

export type RefreshMyDosespotClinicianInfoMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Refresh My Dosespot Clinician Info
 */
export const useRefreshMyDosespotClinicianInfo = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshMyDosespotClinicianInfo>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshMyDosespotClinicianInfo>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getRefreshMyDosespotClinicianInfoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Refresh DoseSpot clinician information from the API.

This endpoint fetches the latest clinician information from DoseSpot API
and updates the stored record with the current data.

Args:
    user_id: The user ID of the clinician to refresh

Returns:
    The updated DoseSpot clinician information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the user
 * @summary Refresh Dosespot Clinician Info
 */
export const refreshDosespotClinicianInfo = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DoseSpotClinicianInfoT>> => {
  return axios.default.post(
    `/greenfield/dosespot/clinician/refresh/${userId}`,
    undefined,
    options,
  );
};

export const getRefreshDosespotClinicianInfoMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshDosespotClinicianInfo>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshDosespotClinicianInfo>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ["refreshDosespotClinicianInfo"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshDosespotClinicianInfo>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return refreshDosespotClinicianInfo(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshDosespotClinicianInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshDosespotClinicianInfo>>
>;

export type RefreshDosespotClinicianInfoMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Refresh Dosespot Clinician Info
 */
export const useRefreshDosespotClinicianInfo = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshDosespotClinicianInfo>>,
      TError,
      { userId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshDosespotClinicianInfo>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions =
    getRefreshDosespotClinicianInfoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get IDP status for the authenticated user.

Returns:
    DosespotIDPRecordT: Current IDP record, or None if no IDP process started

Raises:
    AuthException: If the user lacks required privileges
 * @summary Get My Idp Status
 */
export const getMyIdpStatus = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetMyIdpStatus200>> => {
  return axios.default.get(`/greenfield/dosespot/idp/status/me`, options);
};

export const getGetMyIdpStatusQueryKey = () => {
  return [`/greenfield/dosespot/idp/status/me`] as const;
};

export const getGetMyIdpStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyIdpStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMyIdpStatus>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyIdpStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyIdpStatus>>> = ({
    signal,
  }) => getMyIdpStatus({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyIdpStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyIdpStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyIdpStatus>>
>;
export type GetMyIdpStatusQueryError = AxiosError<HTTPValidationError>;

export function useGetMyIdpStatus<
  TData = Awaited<ReturnType<typeof getMyIdpStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyIdpStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyIdpStatus>>,
          TError,
          Awaited<ReturnType<typeof getMyIdpStatus>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyIdpStatus<
  TData = Awaited<ReturnType<typeof getMyIdpStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyIdpStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyIdpStatus>>,
          TError,
          Awaited<ReturnType<typeof getMyIdpStatus>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyIdpStatus<
  TData = Awaited<ReturnType<typeof getMyIdpStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyIdpStatus>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Idp Status
 */

export function useGetMyIdpStatus<
  TData = Awaited<ReturnType<typeof getMyIdpStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyIdpStatus>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyIdpStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the IDP disclaimer for the authenticated user.

Returns:
    IdpDisclaimerT: The IDP disclaimer information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Idp Disclaimer
 */
export const getIdpDisclaimer = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IdpDisclaimerT>> => {
  return axios.default.get(`/greenfield/dosespot/idp/disclaimer`, options);
};

export const getGetIdpDisclaimerQueryKey = () => {
  return [`/greenfield/dosespot/idp/disclaimer`] as const;
};

export const getGetIdpDisclaimerQueryOptions = <
  TData = Awaited<ReturnType<typeof getIdpDisclaimer>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getIdpDisclaimer>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIdpDisclaimerQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIdpDisclaimer>>
  > = ({ signal }) => getIdpDisclaimer({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIdpDisclaimer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIdpDisclaimerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIdpDisclaimer>>
>;
export type GetIdpDisclaimerQueryError = AxiosError<HTTPValidationError>;

export function useGetIdpDisclaimer<
  TData = Awaited<ReturnType<typeof getIdpDisclaimer>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIdpDisclaimer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIdpDisclaimer>>,
          TError,
          Awaited<ReturnType<typeof getIdpDisclaimer>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIdpDisclaimer<
  TData = Awaited<ReturnType<typeof getIdpDisclaimer>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIdpDisclaimer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIdpDisclaimer>>,
          TError,
          Awaited<ReturnType<typeof getIdpDisclaimer>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIdpDisclaimer<
  TData = Awaited<ReturnType<typeof getIdpDisclaimer>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIdpDisclaimer>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Idp Disclaimer
 */

export function useGetIdpDisclaimer<
  TData = Awaited<ReturnType<typeof getIdpDisclaimer>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIdpDisclaimer>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetIdpDisclaimerQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the legal agreements for the authenticated user.

Returns:
    List[DoseSpotClinicianAgreementT]: The legal agreements that need to be accepted

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Idp Legal Agreements
 */
export const getIdpLegalAgreements = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DoseSpotClinicianAgreementT[]>> => {
  return axios.default.get(
    `/greenfield/dosespot/idp/legal_agreements`,
    options,
  );
};

export const getGetIdpLegalAgreementsQueryKey = () => {
  return [`/greenfield/dosespot/idp/legal_agreements`] as const;
};

export const getGetIdpLegalAgreementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getIdpLegalAgreements>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getIdpLegalAgreements>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIdpLegalAgreementsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIdpLegalAgreements>>
  > = ({ signal }) => getIdpLegalAgreements({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIdpLegalAgreements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIdpLegalAgreementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIdpLegalAgreements>>
>;
export type GetIdpLegalAgreementsQueryError = AxiosError<HTTPValidationError>;

export function useGetIdpLegalAgreements<
  TData = Awaited<ReturnType<typeof getIdpLegalAgreements>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIdpLegalAgreements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIdpLegalAgreements>>,
          TError,
          Awaited<ReturnType<typeof getIdpLegalAgreements>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIdpLegalAgreements<
  TData = Awaited<ReturnType<typeof getIdpLegalAgreements>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIdpLegalAgreements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIdpLegalAgreements>>,
          TError,
          Awaited<ReturnType<typeof getIdpLegalAgreements>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIdpLegalAgreements<
  TData = Awaited<ReturnType<typeof getIdpLegalAgreements>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIdpLegalAgreements>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Idp Legal Agreements
 */

export function useGetIdpLegalAgreements<
  TData = Awaited<ReturnType<typeof getIdpLegalAgreements>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIdpLegalAgreements>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetIdpLegalAgreementsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Start the IDP process for the authenticated user.

Returns:
    DosespotIDPRecordT: The created/updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Start Idp Process
 */
export const startIdpProcess = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DosespotIDPRecordT>> => {
  return axios.default.post(
    `/greenfield/dosespot/idp/start`,
    undefined,
    options,
  );
};

export const getStartIdpProcessMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startIdpProcess>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startIdpProcess>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["startIdpProcess"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startIdpProcess>>,
    void
  > = () => {
    return startIdpProcess(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartIdpProcessMutationResult = NonNullable<
  Awaited<ReturnType<typeof startIdpProcess>>
>;

export type StartIdpProcessMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Start Idp Process
 */
export const useStartIdpProcess = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startIdpProcess>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startIdpProcess>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getStartIdpProcessMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Accept the IDP disclaimer for the authenticated user.

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no active IDP process or disclaimer already accepted
 * @summary Accept Idp Disclaimer
 */
export const acceptIdpDisclaimer = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DosespotIDPRecordT>> => {
  return axios.default.post(
    `/greenfield/dosespot/idp/accept_disclaimer`,
    undefined,
    options,
  );
};

export const getAcceptIdpDisclaimerMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptIdpDisclaimer>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptIdpDisclaimer>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["acceptIdpDisclaimer"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptIdpDisclaimer>>,
    void
  > = () => {
    return acceptIdpDisclaimer(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptIdpDisclaimerMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptIdpDisclaimer>>
>;

export type AcceptIdpDisclaimerMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Accept Idp Disclaimer
 */
export const useAcceptIdpDisclaimer = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acceptIdpDisclaimer>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acceptIdpDisclaimer>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAcceptIdpDisclaimerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Accept all pending legal agreements for the authenticated user.

Args:
    request: The signature name to use for accepting agreements

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no active IDP process or agreements already accepted
 * @summary Accept Legal Agreements
 */
export const acceptLegalAgreements = (
  acceptLegalAgreementsRequestT: AcceptLegalAgreementsRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DosespotIDPRecordT>> => {
  return axios.default.post(
    `/greenfield/dosespot/idp/accept_legal_agreements`,
    acceptLegalAgreementsRequestT,
    options,
  );
};

export const getAcceptLegalAgreementsMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptLegalAgreements>>,
    TError,
    { data: AcceptLegalAgreementsRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptLegalAgreements>>,
  TError,
  { data: AcceptLegalAgreementsRequestT },
  TContext
> => {
  const mutationKey = ["acceptLegalAgreements"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptLegalAgreements>>,
    { data: AcceptLegalAgreementsRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return acceptLegalAgreements(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptLegalAgreementsMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptLegalAgreements>>
>;
export type AcceptLegalAgreementsMutationBody = AcceptLegalAgreementsRequestT;
export type AcceptLegalAgreementsMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Accept Legal Agreements
 */
export const useAcceptLegalAgreements = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acceptLegalAgreements>>,
      TError,
      { data: AcceptLegalAgreementsRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acceptLegalAgreements>>,
  TError,
  { data: AcceptLegalAgreementsRequestT },
  TContext
> => {
  const mutationOptions = getAcceptLegalAgreementsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Submit demographic information for IDP.

Args:
    request: The demographic information to submit

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no active IDP process or demographic info already submitted
 * @summary Submit Demographic Info
 */
export const submitDemographicInfo = (
  submitDemographicInfoRequestT: SubmitDemographicInfoRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DosespotIDPRecordT>> => {
  return axios.default.post(
    `/greenfield/dosespot/idp/submit_demographic_info`,
    submitDemographicInfoRequestT,
    options,
  );
};

export const getSubmitDemographicInfoMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitDemographicInfo>>,
    TError,
    { data: SubmitDemographicInfoRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitDemographicInfo>>,
  TError,
  { data: SubmitDemographicInfoRequestT },
  TContext
> => {
  const mutationKey = ["submitDemographicInfo"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitDemographicInfo>>,
    { data: SubmitDemographicInfoRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return submitDemographicInfo(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitDemographicInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitDemographicInfo>>
>;
export type SubmitDemographicInfoMutationBody = SubmitDemographicInfoRequestT;
export type SubmitDemographicInfoMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Submit Demographic Info
 */
export const useSubmitDemographicInfo = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitDemographicInfo>>,
      TError,
      { data: SubmitDemographicInfoRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitDemographicInfo>>,
  TError,
  { data: SubmitDemographicInfoRequestT },
  TContext
> => {
  const mutationOptions = getSubmitDemographicInfoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Submit answers to IDP questions.

Args:
    request: The answers to IDP questions

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    fastapi.HTTPException: 422 when the request is client-correctable
        (e.g. no active IDP session, or DoseSpot's own structured
        rejection of the call). 500 for unexpected errors.
 * @summary Submit Idp Answers
 */
export const submitIdpAnswers = (
  submitIDPAnswersRequestT: SubmitIDPAnswersRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DosespotIDPRecordT>> => {
  return axios.default.post(
    `/greenfield/dosespot/idp/submit_answers`,
    submitIDPAnswersRequestT,
    options,
  );
};

export const getSubmitIdpAnswersMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitIdpAnswers>>,
    TError,
    { data: SubmitIDPAnswersRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitIdpAnswers>>,
  TError,
  { data: SubmitIDPAnswersRequestT },
  TContext
> => {
  const mutationKey = ["submitIdpAnswers"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitIdpAnswers>>,
    { data: SubmitIDPAnswersRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return submitIdpAnswers(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitIdpAnswersMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitIdpAnswers>>
>;
export type SubmitIdpAnswersMutationBody = SubmitIDPAnswersRequestT;
export type SubmitIdpAnswersMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Submit Idp Answers
 */
export const useSubmitIdpAnswers = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitIdpAnswers>>,
      TError,
      { data: SubmitIDPAnswersRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitIdpAnswers>>,
  TError,
  { data: SubmitIDPAnswersRequestT },
  TContext
> => {
  const mutationOptions = getSubmitIdpAnswersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deprecated no-op: identity verification no longer uses an OTP code.

DoseSpot has marked the upstream `idpOtp` endpoint obsolete. Identity
capture now completes out-of-band via the SMS link Experian sends
after `POST /idp` (or `POST /idpAnswers`) returns `IDCapture = true`.
The frontend renders an Experian-wait view for the `submit_otp` state
and polls `registrationStatus` until the upstream `IDPSuccess` is
observed -- no manual code entry exists in our UI anymore.

The response is whatever IDP record we already have on file. Clients
should rely on `GET /dosespot/idp/me` polling for state advancement.

Returns:
    DosespotIDPRecordT: The current persisted IDP record for the user.

Raises:
    AuthException: If the user lacks required privileges.
    fastapi.HTTPException: 404 when no IDP record exists for the user
        (i.e. they are calling this before any IDP step has run).
 * @summary Submit Idp Otp
 */
export const submitIdpOtp = (
  submitIDPOTPRequestT: SubmitIDPOTPRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DosespotIDPRecordT>> => {
  return axios.default.post(
    `/greenfield/dosespot/idp/submit_otp`,
    submitIDPOTPRequestT,
    options,
  );
};

export const getSubmitIdpOtpMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitIdpOtp>>,
    TError,
    { data: SubmitIDPOTPRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitIdpOtp>>,
  TError,
  { data: SubmitIDPOTPRequestT },
  TContext
> => {
  const mutationKey = ["submitIdpOtp"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitIdpOtp>>,
    { data: SubmitIDPOTPRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return submitIdpOtp(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitIdpOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitIdpOtp>>
>;
export type SubmitIdpOtpMutationBody = SubmitIDPOTPRequestT;
export type SubmitIdpOtpMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Submit Idp Otp
 */
export const useSubmitIdpOtp = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitIdpOtp>>,
      TError,
      { data: SubmitIDPOTPRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitIdpOtp>>,
  TError,
  { data: SubmitIDPOTPRequestT },
  TContext
> => {
  const mutationOptions = getSubmitIdpOtpMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Sync the authenticated user's patient information to DoseSpot.

This endpoint creates or updates a DoseSpot patient record for the authenticated user
by calling the sync_and_fetch method from the patient model.

Returns:
    DoseSpotPatientSyncResultT: The sync result with patient record and info

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user info is insufficient for sync
 * @summary Sync My Dosespot Patient
 */
export const syncMyDosespotPatient = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DoseSpotPatientSyncResultT>> => {
  return axios.default.post(
    `/greenfield/dosespot/patient/sync/me`,
    undefined,
    options,
  );
};

export const getSyncMyDosespotPatientMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncMyDosespotPatient>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncMyDosespotPatient>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["syncMyDosespotPatient"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncMyDosespotPatient>>,
    void
  > = () => {
    return syncMyDosespotPatient(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncMyDosespotPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncMyDosespotPatient>>
>;

export type SyncMyDosespotPatientMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Sync My Dosespot Patient
 */
export const useSyncMyDosespotPatient = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof syncMyDosespotPatient>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof syncMyDosespotPatient>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSyncMyDosespotPatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Sync a user's patient information to DoseSpot.

This endpoint creates or updates a DoseSpot patient record for the specified user
by calling the sync_and_fetch method from the patient model.

Args:
    user_id: The user ID to sync to DoseSpot

Returns:
    DoseSpotPatientSyncResultT: The sync result with patient record and info

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user info is insufficient for sync
 * @summary Sync Dosespot Patient
 */
export const syncDosespotPatient = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DoseSpotPatientSyncResultT>> => {
  return axios.default.post(
    `/greenfield/dosespot/patient/sync/${userId}`,
    undefined,
    options,
  );
};

export const getSyncDosespotPatientMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncDosespotPatient>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncDosespotPatient>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ["syncDosespotPatient"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncDosespotPatient>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return syncDosespotPatient(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncDosespotPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncDosespotPatient>>
>;

export type SyncDosespotPatientMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Sync Dosespot Patient
 */
export const useSyncDosespotPatient = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof syncDosespotPatient>>,
      TError,
      { userId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof syncDosespotPatient>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getSyncDosespotPatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get the authenticated user's DoseSpot patient information.

This endpoint fetches the current patient information from DoseSpot API
for the authenticated user.

Returns:
    PatientT or None: The patient information if available

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists for the user
 * @summary Get My Dosespot Patient Info
 */
export const getMyDosespotPatientInfo = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetMyDosespotPatientInfo200>> => {
  return axios.default.get(`/greenfield/dosespot/patient/info/me`, options);
};

export const getGetMyDosespotPatientInfoQueryKey = () => {
  return [`/greenfield/dosespot/patient/info/me`] as const;
};

export const getGetMyDosespotPatientInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyDosespotPatientInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyDosespotPatientInfo>>
  > = ({ signal }) => getMyDosespotPatientInfo({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyDosespotPatientInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyDosespotPatientInfo>>
>;
export type GetMyDosespotPatientInfoQueryError =
  AxiosError<HTTPValidationError>;

export function useGetMyDosespotPatientInfo<
  TData = Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
          TError,
          Awaited<ReturnType<typeof getMyDosespotPatientInfo>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyDosespotPatientInfo<
  TData = Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
          TError,
          Awaited<ReturnType<typeof getMyDosespotPatientInfo>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyDosespotPatientInfo<
  TData = Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Dosespot Patient Info
 */

export function useGetMyDosespotPatientInfo<
  TData = Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyDosespotPatientInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyDosespotPatientInfoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get DoseSpot patient information for a specific user.

This endpoint fetches the current patient information from DoseSpot API
for the specified user.

Args:
    user_id: The user ID to fetch patient info for

Returns:
    PatientT or None: The patient information if available

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists for the user
 * @summary Get Dosespot Patient Info
 */
export const getDosespotPatientInfo = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetDosespotPatientInfo200>> => {
  return axios.default.get(
    `/greenfield/dosespot/patient/info/${userId}`,
    options,
  );
};

export const getGetDosespotPatientInfoQueryKey = (userId?: string) => {
  return [`/greenfield/dosespot/patient/info/${userId}`] as const;
};

export const getGetDosespotPatientInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getDosespotPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDosespotPatientInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDosespotPatientInfoQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDosespotPatientInfo>>
  > = ({ signal }) =>
    getDosespotPatientInfo(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDosespotPatientInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDosespotPatientInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDosespotPatientInfo>>
>;
export type GetDosespotPatientInfoQueryError = AxiosError<HTTPValidationError>;

export function useGetDosespotPatientInfo<
  TData = Awaited<ReturnType<typeof getDosespotPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDosespotPatientInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDosespotPatientInfo>>,
          TError,
          Awaited<ReturnType<typeof getDosespotPatientInfo>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDosespotPatientInfo<
  TData = Awaited<ReturnType<typeof getDosespotPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDosespotPatientInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDosespotPatientInfo>>,
          TError,
          Awaited<ReturnType<typeof getDosespotPatientInfo>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDosespotPatientInfo<
  TData = Awaited<ReturnType<typeof getDosespotPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDosespotPatientInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Dosespot Patient Info
 */

export function useGetDosespotPatientInfo<
  TData = Awaited<ReturnType<typeof getDosespotPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDosespotPatientInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDosespotPatientInfoQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get DoseSpot patient information for a specific user.

This endpoint fetches the current patient information from DoseSpot API
for the specified user.

Args:
    dosespot_patient_id: The DoseSpot patient ID to fetch patient info for

Returns:
    PatientT or None: The patient information if available

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists for the user
 * @summary Exchange Dosespot Patient Info For Rxchange Rxrenewalrequest
 */
export const exchangeDosespotPatientInfoForRxchangeRxrenewalrequest = (
  dosespotPatientId: string,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<ExchangeDosespotPatientInfoForRxchangeRxrenewalrequest200>
> => {
  return axios.default.get(
    `/greenfield/dosespot/patient/exchange/${dosespotPatientId}`,
    options,
  );
};

export const getExchangeDosespotPatientInfoForRxchangeRxrenewalrequestQueryKey =
  (dosespotPatientId?: string) => {
    return [
      `/greenfield/dosespot/patient/exchange/${dosespotPatientId}`,
    ] as const;
  };

export const getExchangeDosespotPatientInfoForRxchangeRxrenewalrequestQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest>
    >,
    TError = AxiosError<HTTPValidationError>,
  >(
    dosespotPatientId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
            >
          >,
          TError,
          TData
        >
      >;
      axios?: AxiosRequestConfig;
    },
  ) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExchangeDosespotPatientInfoForRxchangeRxrenewalrequestQueryKey(
        dosespotPatientId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
        >
      >
    > = ({ signal }) =>
      exchangeDosespotPatientInfoForRxchangeRxrenewalrequest(
        dosespotPatientId,
        { signal, ...axiosOptions },
      );

    return {
      queryKey,
      queryFn,
      enabled: !!dosespotPatientId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExchangeDosespotPatientInfoForRxchangeRxrenewalrequestQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest>
    >
  >;
export type ExchangeDosespotPatientInfoForRxchangeRxrenewalrequestQueryError =
  AxiosError<HTTPValidationError>;

export function useExchangeDosespotPatientInfoForRxchangeRxrenewalrequest<
  TData = Awaited<
    ReturnType<typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest>
  >,
  TError = AxiosError<HTTPValidationError>,
>(
  dosespotPatientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
            >
          >
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExchangeDosespotPatientInfoForRxchangeRxrenewalrequest<
  TData = Awaited<
    ReturnType<typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest>
  >,
  TError = AxiosError<HTTPValidationError>,
>(
  dosespotPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
            >
          >
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExchangeDosespotPatientInfoForRxchangeRxrenewalrequest<
  TData = Awaited<
    ReturnType<typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest>
  >,
  TError = AxiosError<HTTPValidationError>,
>(
  dosespotPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Exchange Dosespot Patient Info For Rxchange Rxrenewalrequest
 */

export function useExchangeDosespotPatientInfoForRxchangeRxrenewalrequest<
  TData = Awaited<
    ReturnType<typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest>
  >,
  TError = AxiosError<HTTPValidationError>,
>(
  dosespotPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exchangeDosespotPatientInfoForRxchangeRxrenewalrequest
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExchangeDosespotPatientInfoForRxchangeRxrenewalrequestQueryOptions(
      dosespotPatientId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for pharmacies using various criteria.

This endpoint searches the DoseSpot pharmacy database using the provided criteria
and returns a paginated list of matching pharmacies.

Args:
    name: Pharmacy name to search for
    city: Pharmacy city
    state: Pharmacy state (2-letter code)
    zip: Pharmacy ZIP code
    address: Pharmacy street address
    phoneOrFax: Pharmacy phone or fax number
    specialty: List of pharmacy specialties to filter by
    ncpdpID: Pharmacy NCPDP ID
    pageNumber: Page number for pagination (default: 1)

Returns:
    PharmacyPagedListResponseT: Paginated list of pharmacies matching criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails
 * @summary Search Pharmacies
 */
export const searchPharmacies = (
  searchPharmaciesBody: SearchPharmaciesBody,
  params?: SearchPharmaciesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PharmacyPagedListResponseT>> => {
  return axios.default.get(`/greenfield/dosespot/pharmacy/search`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSearchPharmaciesQueryKey = (
  searchPharmaciesBody?: SearchPharmaciesBody,
  params?: SearchPharmaciesParams,
) => {
  return [
    `/greenfield/dosespot/pharmacy/search`,
    ...(params ? [params] : []),
    searchPharmaciesBody,
  ] as const;
};

export const getSearchPharmaciesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchPharmacies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  searchPharmaciesBody: SearchPharmaciesBody,
  params?: SearchPharmaciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchPharmacies>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchPharmaciesQueryKey(searchPharmaciesBody, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchPharmacies>>
  > = ({ signal }) =>
    searchPharmacies(searchPharmaciesBody, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchPharmacies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchPharmaciesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchPharmacies>>
>;
export type SearchPharmaciesQueryError = AxiosError<HTTPValidationError>;

export function useSearchPharmacies<
  TData = Awaited<ReturnType<typeof searchPharmacies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  searchPharmaciesBody: SearchPharmaciesBody,
  params: undefined | SearchPharmaciesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchPharmacies>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchPharmacies>>,
          TError,
          Awaited<ReturnType<typeof searchPharmacies>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchPharmacies<
  TData = Awaited<ReturnType<typeof searchPharmacies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  searchPharmaciesBody: SearchPharmaciesBody,
  params?: SearchPharmaciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchPharmacies>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchPharmacies>>,
          TError,
          Awaited<ReturnType<typeof searchPharmacies>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchPharmacies<
  TData = Awaited<ReturnType<typeof searchPharmacies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  searchPharmaciesBody: SearchPharmaciesBody,
  params?: SearchPharmaciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchPharmacies>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Pharmacies
 */

export function useSearchPharmacies<
  TData = Awaited<ReturnType<typeof searchPharmacies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  searchPharmaciesBody: SearchPharmaciesBody,
  params?: SearchPharmaciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchPharmacies>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchPharmaciesQueryOptions(
    searchPharmaciesBody,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get pharmacy details by ID.

This endpoint retrieves detailed information about a specific pharmacy
from the DoseSpot database.

Args:
    pharmacy_id: The pharmacy ID to retrieve

Returns:
    PharmacyT: Detailed pharmacy information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy is not found or request fails
 * @summary Get Pharmacy By Id
 */
export const getPharmacyById = (
  pharmacyId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PharmacyT>> => {
  return axios.default.get(
    `/greenfield/dosespot/pharmacy/${pharmacyId}`,
    options,
  );
};

export const getGetPharmacyByIdQueryKey = (pharmacyId?: string) => {
  return [`/greenfield/dosespot/pharmacy/${pharmacyId}`] as const;
};

export const getGetPharmacyByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPharmacyById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  pharmacyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPharmacyById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPharmacyByIdQueryKey(pharmacyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacyById>>> = ({
    signal,
  }) => getPharmacyById(pharmacyId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!pharmacyId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPharmacyById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPharmacyByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPharmacyById>>
>;
export type GetPharmacyByIdQueryError = AxiosError<HTTPValidationError>;

export function useGetPharmacyById<
  TData = Awaited<ReturnType<typeof getPharmacyById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  pharmacyId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPharmacyById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyById>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPharmacyById<
  TData = Awaited<ReturnType<typeof getPharmacyById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  pharmacyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPharmacyById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyById>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPharmacyById<
  TData = Awaited<ReturnType<typeof getPharmacyById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  pharmacyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPharmacyById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Pharmacy By Id
 */

export function useGetPharmacyById<
  TData = Awaited<ReturnType<typeof getPharmacyById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  pharmacyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPharmacyById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPharmacyByIdQueryOptions(pharmacyId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the authenticated user's preferred pharmacies.

This endpoint retrieves all pharmacies assigned to the authenticated user's
DoseSpot patient record.

Returns:
    List[PatientPharmacyT]: List of patient's preferred pharmacies

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists or request fails
 * @summary Get My Patient Pharmacies
 */
export const getMyPatientPharmacies = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PatientPharmacyT[]>> => {
  return axios.default.get(
    `/greenfield/dosespot/patient/me/pharmacies`,
    options,
  );
};

export const getGetMyPatientPharmaciesQueryKey = () => {
  return [`/greenfield/dosespot/patient/me/pharmacies`] as const;
};

export const getGetMyPatientPharmaciesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPatientPharmacies>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMyPatientPharmacies>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyPatientPharmaciesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyPatientPharmacies>>
  > = ({ signal }) => getMyPatientPharmacies({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyPatientPharmacies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyPatientPharmaciesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyPatientPharmacies>>
>;
export type GetMyPatientPharmaciesQueryError = AxiosError<HTTPValidationError>;

export function useGetMyPatientPharmacies<
  TData = Awaited<ReturnType<typeof getMyPatientPharmacies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyPatientPharmacies>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyPatientPharmacies>>,
          TError,
          Awaited<ReturnType<typeof getMyPatientPharmacies>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyPatientPharmacies<
  TData = Awaited<ReturnType<typeof getMyPatientPharmacies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyPatientPharmacies>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyPatientPharmacies>>,
          TError,
          Awaited<ReturnType<typeof getMyPatientPharmacies>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyPatientPharmacies<
  TData = Awaited<ReturnType<typeof getMyPatientPharmacies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyPatientPharmacies>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Patient Pharmacies
 */

export function useGetMyPatientPharmacies<
  TData = Awaited<ReturnType<typeof getMyPatientPharmacies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyPatientPharmacies>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyPatientPharmaciesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a pharmacy to the authenticated user's preferred pharmacies.

This endpoint adds a pharmacy to the authenticated user's DoseSpot patient record
and optionally sets it as the primary pharmacy.

Args:
    request: The pharmacy ID and primary setting

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be added or request fails
 * @summary Add Pharmacy To My Patient
 */
export const addPharmacyToMyPatient = (
  addPatientPharmacyRequestT: AddPatientPharmacyRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.post(
    `/greenfield/dosespot/patient/me/pharmacies`,
    addPatientPharmacyRequestT,
    options,
  );
};

export const getAddPharmacyToMyPatientMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addPharmacyToMyPatient>>,
    TError,
    { data: AddPatientPharmacyRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addPharmacyToMyPatient>>,
  TError,
  { data: AddPatientPharmacyRequestT },
  TContext
> => {
  const mutationKey = ["addPharmacyToMyPatient"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addPharmacyToMyPatient>>,
    { data: AddPatientPharmacyRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return addPharmacyToMyPatient(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddPharmacyToMyPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof addPharmacyToMyPatient>>
>;
export type AddPharmacyToMyPatientMutationBody = AddPatientPharmacyRequestT;
export type AddPharmacyToMyPatientMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Add Pharmacy To My Patient
 */
export const useAddPharmacyToMyPatient = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addPharmacyToMyPatient>>,
      TError,
      { data: AddPatientPharmacyRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addPharmacyToMyPatient>>,
  TError,
  { data: AddPatientPharmacyRequestT },
  TContext
> => {
  const mutationOptions = getAddPharmacyToMyPatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a specific user's preferred pharmacies.

This endpoint retrieves all pharmacies assigned to the specified user's
DoseSpot patient record.

Args:
    user_id: The user ID to get pharmacies for

Returns:
    List[PatientPharmacyT]: List of patient's preferred pharmacies

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists or request fails
 * @summary Get Patient Pharmacies By User Id
 */
export const getPatientPharmaciesByUserId = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PatientPharmacyT[]>> => {
  return axios.default.get(
    `/greenfield/dosespot/patient/${userId}/pharmacies`,
    options,
  );
};

export const getGetPatientPharmaciesByUserIdQueryKey = (userId?: string) => {
  return [`/greenfield/dosespot/patient/${userId}/pharmacies`] as const;
};

export const getGetPatientPharmaciesByUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientPharmaciesByUserIdQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>
  > = ({ signal }) =>
    getPatientPharmaciesByUserId(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientPharmaciesByUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>
>;
export type GetPatientPharmaciesByUserIdQueryError =
  AxiosError<HTTPValidationError>;

export function useGetPatientPharmaciesByUserId<
  TData = Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
          TError,
          Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientPharmaciesByUserId<
  TData = Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
          TError,
          Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientPharmaciesByUserId<
  TData = Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient Pharmacies By User Id
 */

export function useGetPatientPharmaciesByUserId<
  TData = Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientPharmaciesByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientPharmaciesByUserIdQueryOptions(
    userId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a pharmacy to a specific user's preferred pharmacies.

This endpoint adds a pharmacy to the specified user's DoseSpot patient record
and optionally sets it as the primary pharmacy.

Args:
    user_id: The user ID to add the pharmacy to
    request: The pharmacy ID and primary setting

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be added or request fails
 * @summary Add Pharmacy To Patient By User Id
 */
export const addPharmacyToPatientByUserId = (
  userId: string,
  addPatientPharmacyRequestT: AddPatientPharmacyRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.post(
    `/greenfield/dosespot/patient/${userId}/pharmacies`,
    addPatientPharmacyRequestT,
    options,
  );
};

export const getAddPharmacyToPatientByUserIdMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addPharmacyToPatientByUserId>>,
    TError,
    { userId: string; data: AddPatientPharmacyRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addPharmacyToPatientByUserId>>,
  TError,
  { userId: string; data: AddPatientPharmacyRequestT },
  TContext
> => {
  const mutationKey = ["addPharmacyToPatientByUserId"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addPharmacyToPatientByUserId>>,
    { userId: string; data: AddPatientPharmacyRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return addPharmacyToPatientByUserId(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddPharmacyToPatientByUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof addPharmacyToPatientByUserId>>
>;
export type AddPharmacyToPatientByUserIdMutationBody =
  AddPatientPharmacyRequestT;
export type AddPharmacyToPatientByUserIdMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Add Pharmacy To Patient By User Id
 */
export const useAddPharmacyToPatientByUserId = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addPharmacyToPatientByUserId>>,
      TError,
      { userId: string; data: AddPatientPharmacyRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addPharmacyToPatientByUserId>>,
  TError,
  { userId: string; data: AddPatientPharmacyRequestT },
  TContext
> => {
  const mutationOptions =
    getAddPharmacyToPatientByUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Remove a pharmacy from the authenticated user's preferred pharmacies.

This endpoint removes a pharmacy from the authenticated user's DoseSpot patient record.

Args:
    pharmacy_id: The pharmacy ID to remove

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be removed or request fails
 * @summary Remove Pharmacy From My Patient
 */
export const removePharmacyFromMyPatient = (
  pharmacyId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.delete(
    `/greenfield/dosespot/patient/me/pharmacies/${pharmacyId}`,
    options,
  );
};

export const getRemovePharmacyFromMyPatientMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removePharmacyFromMyPatient>>,
    TError,
    { pharmacyId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removePharmacyFromMyPatient>>,
  TError,
  { pharmacyId: string },
  TContext
> => {
  const mutationKey = ["removePharmacyFromMyPatient"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removePharmacyFromMyPatient>>,
    { pharmacyId: string }
  > = (props) => {
    const { pharmacyId } = props ?? {};

    return removePharmacyFromMyPatient(pharmacyId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemovePharmacyFromMyPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof removePharmacyFromMyPatient>>
>;

export type RemovePharmacyFromMyPatientMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Remove Pharmacy From My Patient
 */
export const useRemovePharmacyFromMyPatient = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removePharmacyFromMyPatient>>,
      TError,
      { pharmacyId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removePharmacyFromMyPatient>>,
  TError,
  { pharmacyId: string },
  TContext
> => {
  const mutationOptions =
    getRemovePharmacyFromMyPatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Remove a pharmacy from a specific user's preferred pharmacies.

This endpoint removes a pharmacy from the specified user's DoseSpot patient record.

Args:
    user_id: The user ID to remove the pharmacy from
    pharmacy_id: The pharmacy ID to remove

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be removed or request fails
 * @summary Remove Pharmacy From Patient By User Id
 */
export const removePharmacyFromPatientByUserId = (
  userId: string,
  pharmacyId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.delete(
    `/greenfield/dosespot/patient/${userId}/pharmacies/${pharmacyId}`,
    options,
  );
};

export const getRemovePharmacyFromPatientByUserIdMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removePharmacyFromPatientByUserId>>,
    TError,
    { userId: string; pharmacyId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removePharmacyFromPatientByUserId>>,
  TError,
  { userId: string; pharmacyId: string },
  TContext
> => {
  const mutationKey = ["removePharmacyFromPatientByUserId"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removePharmacyFromPatientByUserId>>,
    { userId: string; pharmacyId: string }
  > = (props) => {
    const { userId, pharmacyId } = props ?? {};

    return removePharmacyFromPatientByUserId(userId, pharmacyId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemovePharmacyFromPatientByUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof removePharmacyFromPatientByUserId>>
>;

export type RemovePharmacyFromPatientByUserIdMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Remove Pharmacy From Patient By User Id
 */
export const useRemovePharmacyFromPatientByUserId = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removePharmacyFromPatientByUserId>>,
      TError,
      { userId: string; pharmacyId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removePharmacyFromPatientByUserId>>,
  TError,
  { userId: string; pharmacyId: string },
  TContext
> => {
  const mutationOptions =
    getRemovePharmacyFromPatientByUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a specific user's allergies.

This endpoint retrieves all allergies recorded for the specified user's
DoseSpot patient record.

Args:
    user_id: The user ID to get allergies for

Returns:
    List[PatientAllergyT]: List of patient's allergies

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists or request fails
 * @summary Get Patient Allergies By User Id
 */
export const getPatientAllergiesByUserId = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PatientAllergyT[]>> => {
  return axios.default.get(
    `/greenfield/dosespot/patient/${userId}/allergies`,
    options,
  );
};

export const getGetPatientAllergiesByUserIdQueryKey = (userId?: string) => {
  return [`/greenfield/dosespot/patient/${userId}/allergies`] as const;
};

export const getGetPatientAllergiesByUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientAllergiesByUserIdQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientAllergiesByUserId>>
  > = ({ signal }) =>
    getPatientAllergiesByUserId(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientAllergiesByUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientAllergiesByUserId>>
>;
export type GetPatientAllergiesByUserIdQueryError =
  AxiosError<HTTPValidationError>;

export function useGetPatientAllergiesByUserId<
  TData = Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
          TError,
          Awaited<ReturnType<typeof getPatientAllergiesByUserId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientAllergiesByUserId<
  TData = Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
          TError,
          Awaited<ReturnType<typeof getPatientAllergiesByUserId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientAllergiesByUserId<
  TData = Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient Allergies By User Id
 */

export function useGetPatientAllergiesByUserId<
  TData = Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientAllergiesByUserId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientAllergiesByUserIdQueryOptions(
    userId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add an allergy to a specific user's patient record.

This endpoint adds an allergy to the specified user's DoseSpot patient record.
The allergy can be either coded (with AllergenId) or freetext.

Args:
    user_id: The user ID to add the allergy to
    request: The allergy information (coded or freetext)

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the allergy cannot be added or request fails
 * @summary Add Allergy To Patient By User Id
 */
export const addAllergyToPatientByUserId = (
  userId: string,
  addAllergyToPatientByUserIdBody: AddAllergyToPatientByUserIdBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.post(
    `/greenfield/dosespot/patient/${userId}/allergies`,
    addAllergyToPatientByUserIdBody,
    options,
  );
};

export const getAddAllergyToPatientByUserIdMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addAllergyToPatientByUserId>>,
    TError,
    { userId: string; data: AddAllergyToPatientByUserIdBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addAllergyToPatientByUserId>>,
  TError,
  { userId: string; data: AddAllergyToPatientByUserIdBody },
  TContext
> => {
  const mutationKey = ["addAllergyToPatientByUserId"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addAllergyToPatientByUserId>>,
    { userId: string; data: AddAllergyToPatientByUserIdBody }
  > = (props) => {
    const { userId, data } = props ?? {};

    return addAllergyToPatientByUserId(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddAllergyToPatientByUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof addAllergyToPatientByUserId>>
>;
export type AddAllergyToPatientByUserIdMutationBody =
  AddAllergyToPatientByUserIdBody;
export type AddAllergyToPatientByUserIdMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Add Allergy To Patient By User Id
 */
export const useAddAllergyToPatientByUserId = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addAllergyToPatientByUserId>>,
      TError,
      { userId: string; data: AddAllergyToPatientByUserIdBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addAllergyToPatientByUserId>>,
  TError,
  { userId: string; data: AddAllergyToPatientByUserIdBody },
  TContext
> => {
  const mutationOptions =
    getAddAllergyToPatientByUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Edit an allergy in a specific user's patient record.

This endpoint updates an existing allergy in the specified user's DoseSpot patient record.

Args:
    user_id: The user ID to edit the allergy for
    allergy_id: The allergy ID to edit
    request: The updated allergy information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the allergy cannot be edited or request fails
 * @summary Edit Patient Allergy By User Id
 */
export const editPatientAllergyByUserId = (
  userId: string,
  allergyId: string,
  editPatientAllergyRequestT: EditPatientAllergyRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.post(
    `/greenfield/dosespot/patient/${userId}/allergies/${allergyId}`,
    editPatientAllergyRequestT,
    options,
  );
};

export const getEditPatientAllergyByUserIdMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editPatientAllergyByUserId>>,
    TError,
    { userId: string; allergyId: string; data: EditPatientAllergyRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editPatientAllergyByUserId>>,
  TError,
  { userId: string; allergyId: string; data: EditPatientAllergyRequestT },
  TContext
> => {
  const mutationKey = ["editPatientAllergyByUserId"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editPatientAllergyByUserId>>,
    { userId: string; allergyId: string; data: EditPatientAllergyRequestT }
  > = (props) => {
    const { userId, allergyId, data } = props ?? {};

    return editPatientAllergyByUserId(userId, allergyId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditPatientAllergyByUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof editPatientAllergyByUserId>>
>;
export type EditPatientAllergyByUserIdMutationBody = EditPatientAllergyRequestT;
export type EditPatientAllergyByUserIdMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Edit Patient Allergy By User Id
 */
export const useEditPatientAllergyByUserId = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof editPatientAllergyByUserId>>,
      TError,
      { userId: string; allergyId: string; data: EditPatientAllergyRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof editPatientAllergyByUserId>>,
  TError,
  { userId: string; allergyId: string; data: EditPatientAllergyRequestT },
  TContext
> => {
  const mutationOptions = getEditPatientAllergyByUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Search for allergens by name.

This endpoint searches the DoseSpot allergen database for matching allergens.
Requires at least 3 characters in the search term.

Args:
    name: Allergen name to search for (minimum 3 characters)
    page_number: Page number for pagination (optional)

Returns:
    AllergyPagedListResponseT: Paginated list of allergens matching the search criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails or name is too short
 * @summary Search Allergens
 */
export const searchAllergens = (
  params: SearchAllergensParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AllergySearchPagedListResponseT>> => {
  return axios.default.get(`/greenfield/dosespot/allergens/search`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSearchAllergensQueryKey = (params?: SearchAllergensParams) => {
  return [
    `/greenfield/dosespot/allergens/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchAllergensQueryOptions = <
  TData = Awaited<ReturnType<typeof searchAllergens>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: SearchAllergensParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchAllergens>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchAllergensQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAllergens>>> = ({
    signal,
  }) => searchAllergens(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchAllergens>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchAllergensQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchAllergens>>
>;
export type SearchAllergensQueryError = AxiosError<HTTPValidationError>;

export function useSearchAllergens<
  TData = Awaited<ReturnType<typeof searchAllergens>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: SearchAllergensParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchAllergens>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAllergens>>,
          TError,
          Awaited<ReturnType<typeof searchAllergens>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchAllergens<
  TData = Awaited<ReturnType<typeof searchAllergens>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: SearchAllergensParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchAllergens>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAllergens>>,
          TError,
          Awaited<ReturnType<typeof searchAllergens>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchAllergens<
  TData = Awaited<ReturnType<typeof searchAllergens>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: SearchAllergensParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchAllergens>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Allergens
 */

export function useSearchAllergens<
  TData = Awaited<ReturnType<typeof searchAllergens>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: SearchAllergensParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchAllergens>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchAllergensQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get allergen details by ID.

This endpoint retrieves detailed information about a specific allergen
from the DoseSpot database.

Args:
    allergen_id: The allergen ID to retrieve

Returns:
    AllergySearchResultT: Detailed allergen information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the allergen is not found or request fails
 * @summary Get Allergen By Id
 */
export const getAllergenById = (
  allergenId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AllergySearchResultT>> => {
  return axios.default.get(
    `/greenfield/dosespot/allergens/${allergenId}`,
    options,
  );
};

export const getGetAllergenByIdQueryKey = (allergenId?: string) => {
  return [`/greenfield/dosespot/allergens/${allergenId}`] as const;
};

export const getGetAllergenByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllergenById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  allergenId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllergenById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllergenByIdQueryKey(allergenId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllergenById>>> = ({
    signal,
  }) => getAllergenById(allergenId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!allergenId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllergenById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllergenByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllergenById>>
>;
export type GetAllergenByIdQueryError = AxiosError<HTTPValidationError>;

export function useGetAllergenById<
  TData = Awaited<ReturnType<typeof getAllergenById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  allergenId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllergenById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllergenById>>,
          TError,
          Awaited<ReturnType<typeof getAllergenById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllergenById<
  TData = Awaited<ReturnType<typeof getAllergenById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  allergenId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllergenById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllergenById>>,
          TError,
          Awaited<ReturnType<typeof getAllergenById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllergenById<
  TData = Awaited<ReturnType<typeof getAllergenById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  allergenId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllergenById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Allergen By Id
 */

export function useGetAllergenById<
  TData = Awaited<ReturnType<typeof getAllergenById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  allergenId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllergenById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllergenByIdQueryOptions(allergenId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for medications by name.

This endpoint searches the DoseSpot medication database for drugs matching the provided name.
Requires at least 3 characters in the search term.

Args:
    name: Medication name to search for (minimum 3 characters)
    page_number: Page number for pagination (optional)
    drug_status: Filter by drug status (optional)

Returns:
    List[MedicationSearchResultT]: List of medications matching the search criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails or name is too short
 * @summary Search Medications
 */
export const searchMedications = (
  params: SearchMedicationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MedicationSearchResultT[]>> => {
  return axios.default.get(`/greenfield/dosespot/medications/search`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSearchMedicationsQueryKey = (
  params?: SearchMedicationsParams,
) => {
  return [
    `/greenfield/dosespot/medications/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchMedicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchMedications>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: SearchMedicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchMedications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchMedicationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchMedications>>
  > = ({ signal }) => searchMedications(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchMedications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchMedicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchMedications>>
>;
export type SearchMedicationsQueryError = AxiosError<HTTPValidationError>;

export function useSearchMedications<
  TData = Awaited<ReturnType<typeof searchMedications>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: SearchMedicationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchMedications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchMedications>>,
          TError,
          Awaited<ReturnType<typeof searchMedications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchMedications<
  TData = Awaited<ReturnType<typeof searchMedications>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: SearchMedicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchMedications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchMedications>>,
          TError,
          Awaited<ReturnType<typeof searchMedications>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchMedications<
  TData = Awaited<ReturnType<typeof searchMedications>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: SearchMedicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchMedications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Medications
 */

export function useSearchMedications<
  TData = Awaited<ReturnType<typeof searchMedications>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: SearchMedicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchMedications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchMedicationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for medications by rxCUI.

This endpoint searches for dispensable drugs by rxCUI identifier.

Args:
    rxcui: The rxCUI identifier to search by

Returns:
    List[MedicationSelectResultT]: List of medications matching the rxCUI

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails
 * @summary Search Medications By Rxcui
 */
export const searchMedicationsByRxcui = (
  rxcui: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MedicationSelectResultT[]>> => {
  return axios.default.get(
    `/greenfield/dosespot/medications/search_by_rxcui/${rxcui}`,
    options,
  );
};

export const getSearchMedicationsByRxcuiQueryKey = (rxcui?: string) => {
  return [`/greenfield/dosespot/medications/search_by_rxcui/${rxcui}`] as const;
};

export const getSearchMedicationsByRxcuiQueryOptions = <
  TData = Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
  TError = AxiosError<HTTPValidationError>,
>(
  rxcui: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchMedicationsByRxcuiQueryKey(rxcui);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchMedicationsByRxcui>>
  > = ({ signal }) =>
    searchMedicationsByRxcui(rxcui, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!rxcui,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchMedicationsByRxcuiQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchMedicationsByRxcui>>
>;
export type SearchMedicationsByRxcuiQueryError =
  AxiosError<HTTPValidationError>;

export function useSearchMedicationsByRxcui<
  TData = Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
  TError = AxiosError<HTTPValidationError>,
>(
  rxcui: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
          TError,
          Awaited<ReturnType<typeof searchMedicationsByRxcui>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchMedicationsByRxcui<
  TData = Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
  TError = AxiosError<HTTPValidationError>,
>(
  rxcui: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
          TError,
          Awaited<ReturnType<typeof searchMedicationsByRxcui>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchMedicationsByRxcui<
  TData = Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
  TError = AxiosError<HTTPValidationError>,
>(
  rxcui: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Medications By Rxcui
 */

export function useSearchMedicationsByRxcui<
  TData = Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
  TError = AxiosError<HTTPValidationError>,
>(
  rxcui: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchMedicationsByRxcui>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchMedicationsByRxcuiQueryOptions(rxcui, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get detailed medication information by ID, NDC, or rxCUI.

This endpoint retrieves detailed information about a specific medication.
At least one identifier parameter must be provided.

Args:
    dispensable_drug_id: The dispensable drug ID (optional)
    ndc: The NDC number (optional)
    rxcui: The rxCUI identifier (optional)

Returns:
    MedicationSelectResultT: Detailed medication information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no identifier is provided or medication not found
 * @summary Select Medication
 */
export const selectMedication = (
  params?: SelectMedicationParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MedicationSelectResultT>> => {
  return axios.default.get(`/greenfield/dosespot/medications/select`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSelectMedicationQueryKey = (
  params?: SelectMedicationParams,
) => {
  return [
    `/greenfield/dosespot/medications/select`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSelectMedicationQueryOptions = <
  TData = Awaited<ReturnType<typeof selectMedication>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: SelectMedicationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof selectMedication>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSelectMedicationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof selectMedication>>
  > = ({ signal }) => selectMedication(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof selectMedication>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SelectMedicationQueryResult = NonNullable<
  Awaited<ReturnType<typeof selectMedication>>
>;
export type SelectMedicationQueryError = AxiosError<HTTPValidationError>;

export function useSelectMedication<
  TData = Awaited<ReturnType<typeof selectMedication>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | SelectMedicationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof selectMedication>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof selectMedication>>,
          TError,
          Awaited<ReturnType<typeof selectMedication>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSelectMedication<
  TData = Awaited<ReturnType<typeof selectMedication>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: SelectMedicationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof selectMedication>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof selectMedication>>,
          TError,
          Awaited<ReturnType<typeof selectMedication>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSelectMedication<
  TData = Awaited<ReturnType<typeof selectMedication>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: SelectMedicationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof selectMedication>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Select Medication
 */

export function useSelectMedication<
  TData = Awaited<ReturnType<typeof selectMedication>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: SelectMedicationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof selectMedication>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSelectMedicationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get medication monograph by ID or NDC.

This endpoint retrieves the drug monograph information for patient education.

Args:
    dispensable_drug_id: The dispensable drug ID (optional)
    ndc: The NDC number (optional)
    monograph_format: Format for monograph ("HTML" or "XML"), defaults to "HTML"

Returns:
    str: HTML or XML content of the drug monograph

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no identifier is provided or monograph not found
 * @summary Get Medication Monograph
 */
export const getMedicationMonograph = (
  params?: GetMedicationMonographParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.get(`/greenfield/dosespot/medications/monograph`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetMedicationMonographQueryKey = (
  params?: GetMedicationMonographParams,
) => {
  return [
    `/greenfield/dosespot/medications/monograph`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMedicationMonographQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedicationMonograph>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMedicationMonographParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMedicationMonograph>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMedicationMonographQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMedicationMonograph>>
  > = ({ signal }) =>
    getMedicationMonograph(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedicationMonograph>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedicationMonographQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMedicationMonograph>>
>;
export type GetMedicationMonographQueryError = AxiosError<HTTPValidationError>;

export function useGetMedicationMonograph<
  TData = Awaited<ReturnType<typeof getMedicationMonograph>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | GetMedicationMonographParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMedicationMonograph>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedicationMonograph>>,
          TError,
          Awaited<ReturnType<typeof getMedicationMonograph>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMedicationMonograph<
  TData = Awaited<ReturnType<typeof getMedicationMonograph>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMedicationMonographParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMedicationMonograph>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedicationMonograph>>,
          TError,
          Awaited<ReturnType<typeof getMedicationMonograph>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMedicationMonograph<
  TData = Awaited<ReturnType<typeof getMedicationMonograph>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMedicationMonographParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMedicationMonograph>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Medication Monograph
 */

export function useGetMedicationMonograph<
  TData = Awaited<ReturnType<typeof getMedicationMonograph>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMedicationMonographParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMedicationMonograph>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMedicationMonographQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all available dispense units.

This endpoint returns all available dispense unit types for use in prescriptions.

Returns:
    List[StandardDispenseUnitTypeT]: List of all dispense unit types

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the request fails
 * @summary Get Dispense Units
 */
export const getDispenseUnits = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StandardDispenseUnitTypeT[]>> => {
  return axios.default.get(`/greenfield/dosespot/dispense_units`, options);
};

export const getGetDispenseUnitsQueryKey = () => {
  return [`/greenfield/dosespot/dispense_units`] as const;
};

export const getGetDispenseUnitsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDispenseUnits>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDispenseUnits>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDispenseUnitsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDispenseUnits>>
  > = ({ signal }) => getDispenseUnits({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDispenseUnits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDispenseUnitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDispenseUnits>>
>;
export type GetDispenseUnitsQueryError = AxiosError<HTTPValidationError>;

export function useGetDispenseUnits<
  TData = Awaited<ReturnType<typeof getDispenseUnits>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDispenseUnits>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDispenseUnits>>,
          TError,
          Awaited<ReturnType<typeof getDispenseUnits>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDispenseUnits<
  TData = Awaited<ReturnType<typeof getDispenseUnits>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDispenseUnits>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDispenseUnits>>,
          TError,
          Awaited<ReturnType<typeof getDispenseUnits>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDispenseUnits<
  TData = Awaited<ReturnType<typeof getDispenseUnits>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDispenseUnits>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Dispense Units
 */

export function useGetDispenseUnits<
  TData = Awaited<ReturnType<typeof getDispenseUnits>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDispenseUnits>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDispenseUnitsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get dispense unit details by ID.

This endpoint retrieves detailed information about a specific dispense unit.

Args:
    unit_id: The dispense unit ID

Returns:
    StandardDispenseUnitTypeT: Dispense unit details

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the dispense unit is not found
 * @summary Get Dispense Unit By Id
 */
export const getDispenseUnitById = (
  unitId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StandardDispenseUnitTypeT>> => {
  return axios.default.get(
    `/greenfield/dosespot/dispense_units/${unitId}`,
    options,
  );
};

export const getGetDispenseUnitByIdQueryKey = (unitId?: number) => {
  return [`/greenfield/dosespot/dispense_units/${unitId}`] as const;
};

export const getGetDispenseUnitByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDispenseUnitById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  unitId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDispenseUnitById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDispenseUnitByIdQueryKey(unitId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDispenseUnitById>>
  > = ({ signal }) => getDispenseUnitById(unitId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!unitId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDispenseUnitById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDispenseUnitByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDispenseUnitById>>
>;
export type GetDispenseUnitByIdQueryError = AxiosError<HTTPValidationError>;

export function useGetDispenseUnitById<
  TData = Awaited<ReturnType<typeof getDispenseUnitById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  unitId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDispenseUnitById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDispenseUnitById>>,
          TError,
          Awaited<ReturnType<typeof getDispenseUnitById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDispenseUnitById<
  TData = Awaited<ReturnType<typeof getDispenseUnitById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  unitId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDispenseUnitById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDispenseUnitById>>,
          TError,
          Awaited<ReturnType<typeof getDispenseUnitById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDispenseUnitById<
  TData = Awaited<ReturnType<typeof getDispenseUnitById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  unitId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDispenseUnitById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Dispense Unit By Id
 */

export function useGetDispenseUnitById<
  TData = Awaited<ReturnType<typeof getDispenseUnitById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  unitId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDispenseUnitById>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDispenseUnitByIdQueryOptions(unitId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for supplies by name, NDC, or UPC.

This endpoint searches the DoseSpot supply database. You can search by:
- Supply name (minimum 3 characters)
- Exact NDC (National Drug Code)
- Exact UPC (Universal Packaging Code)

At least one search parameter must be provided.

Args:
    name: Supply name to search for (minimum 3 characters, optional)
    ndc: National Drug Code (exact match, optional)
    upc: Universal Packaging Code (exact match, optional)
    page_number: Page number for pagination (optional)
    supply_status: Filter by supply status (optional)

Returns:
    List[SupplySearchResultT]: List of supplies matching the search criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails or no search parameters provided
 * @summary Search Supplies
 */
export const searchSupplies = (
  params?: SearchSuppliesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SupplySearchResultT[]>> => {
  return axios.default.get(`/greenfield/dosespot/supplies/search`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSearchSuppliesQueryKey = (params?: SearchSuppliesParams) => {
  return [
    `/greenfield/dosespot/supplies/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchSuppliesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchSupplies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: SearchSuppliesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchSupplies>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchSuppliesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchSupplies>>> = ({
    signal,
  }) => searchSupplies(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchSupplies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchSuppliesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchSupplies>>
>;
export type SearchSuppliesQueryError = AxiosError<HTTPValidationError>;

export function useSearchSupplies<
  TData = Awaited<ReturnType<typeof searchSupplies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | SearchSuppliesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchSupplies>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchSupplies>>,
          TError,
          Awaited<ReturnType<typeof searchSupplies>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchSupplies<
  TData = Awaited<ReturnType<typeof searchSupplies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: SearchSuppliesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchSupplies>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchSupplies>>,
          TError,
          Awaited<ReturnType<typeof searchSupplies>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchSupplies<
  TData = Awaited<ReturnType<typeof searchSupplies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: SearchSuppliesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchSupplies>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Supplies
 */

export function useSearchSupplies<
  TData = Awaited<ReturnType<typeof searchSupplies>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: SearchSuppliesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchSupplies>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchSuppliesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get supply details by ID.

This endpoint retrieves detailed information about a specific supply
from the DoseSpot database.

Args:
    supply_id: The supply ID to retrieve

Returns:
    SupplySearchResultT: Detailed supply information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the supply is not found or request fails
 * @summary Get Supply By Id
 */
export const getSupplyById = (
  supplyId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SupplySearchResultT>> => {
  return axios.default.get(
    `/greenfield/dosespot/supplies/${supplyId}`,
    options,
  );
};

export const getGetSupplyByIdQueryKey = (supplyId?: number) => {
  return [`/greenfield/dosespot/supplies/${supplyId}`] as const;
};

export const getGetSupplyByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupplyById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  supplyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplyById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupplyByIdQueryKey(supplyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplyById>>> = ({
    signal,
  }) => getSupplyById(supplyId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!supplyId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupplyById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSupplyByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupplyById>>
>;
export type GetSupplyByIdQueryError = AxiosError<HTTPValidationError>;

export function useGetSupplyById<
  TData = Awaited<ReturnType<typeof getSupplyById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  supplyId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplyById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplyById>>,
          TError,
          Awaited<ReturnType<typeof getSupplyById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSupplyById<
  TData = Awaited<ReturnType<typeof getSupplyById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  supplyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplyById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplyById>>,
          TError,
          Awaited<ReturnType<typeof getSupplyById>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSupplyById<
  TData = Awaited<ReturnType<typeof getSupplyById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  supplyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplyById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Supply By Id
 */

export function useGetSupplyById<
  TData = Awaited<ReturnType<typeof getSupplyById>>,
  TError = AxiosError<HTTPValidationError>,
>(
  supplyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplyById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSupplyByIdQueryOptions(supplyId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new prescription for a patient.

This endpoint creates a new prescription in DoseSpot for the specified patient.
The prescription type is automatically determined from the request data structure.

Args:
    user_id: The patient's user ID
    request: The prescription data (coded, freetext, supply, or compound) and optional clinician request ticket

Returns:
    PrescriptionT: The newly created prescription information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record or prescription creation fails
 * @summary Create Prescription
 */
export const createPrescription = (
  userId: string,
  createPrescriptionRequestT: CreatePrescriptionRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PrescriptionT>> => {
  return axios.default.post(
    `/greenfield/dosespot/prescriptions/create/${userId}`,
    createPrescriptionRequestT,
    options,
  );
};

export const getCreatePrescriptionMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPrescription>>,
    TError,
    { userId: string; data: CreatePrescriptionRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPrescription>>,
  TError,
  { userId: string; data: CreatePrescriptionRequestT },
  TContext
> => {
  const mutationKey = ["createPrescription"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPrescription>>,
    { userId: string; data: CreatePrescriptionRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return createPrescription(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePrescriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPrescription>>
>;
export type CreatePrescriptionMutationBody = CreatePrescriptionRequestT;
export type CreatePrescriptionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Create Prescription
 */
export const useCreatePrescription = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPrescription>>,
      TError,
      { userId: string; data: CreatePrescriptionRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPrescription>>,
  TError,
  { userId: string; data: CreatePrescriptionRequestT },
  TContext
> => {
  const mutationOptions = getCreatePrescriptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Edit an existing prescription.

This endpoint updates an existing prescription in DoseSpot.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID to edit
    request: The updated prescription data

Returns:
    PrescriptionT: The updated prescription information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found or update fails
 * @summary Edit Prescription
 */
export const editPrescription = (
  dosespotPrescriptionId: string,
  editPrescriptionRequestT: EditPrescriptionRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PrescriptionT>> => {
  return axios.default.put(
    `/greenfield/dosespot/prescriptions/${dosespotPrescriptionId}`,
    editPrescriptionRequestT,
    options,
  );
};

export const getEditPrescriptionMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editPrescription>>,
    TError,
    { dosespotPrescriptionId: string; data: EditPrescriptionRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editPrescription>>,
  TError,
  { dosespotPrescriptionId: string; data: EditPrescriptionRequestT },
  TContext
> => {
  const mutationKey = ["editPrescription"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editPrescription>>,
    { dosespotPrescriptionId: string; data: EditPrescriptionRequestT }
  > = (props) => {
    const { dosespotPrescriptionId, data } = props ?? {};

    return editPrescription(dosespotPrescriptionId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditPrescriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof editPrescription>>
>;
export type EditPrescriptionMutationBody = EditPrescriptionRequestT;
export type EditPrescriptionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Edit Prescription
 */
export const useEditPrescription = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof editPrescription>>,
      TError,
      { dosespotPrescriptionId: string; data: EditPrescriptionRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof editPrescription>>,
  TError,
  { dosespotPrescriptionId: string; data: EditPrescriptionRequestT },
  TContext
> => {
  const mutationOptions = getEditPrescriptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a prescription.

This endpoint cancels a prescription in DoseSpot and deletes the local record.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID to delete

Returns:
    PrescriptionMessageT: Message indicating success or failure with error details

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found
 * @summary Delete Prescription
 */
export const deletePrescription = (
  dosespotPrescriptionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PrescriptionMessageT>> => {
  return axios.default.delete(
    `/greenfield/dosespot/prescriptions/${dosespotPrescriptionId}`,
    options,
  );
};

export const getDeletePrescriptionMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePrescription>>,
    TError,
    { dosespotPrescriptionId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePrescription>>,
  TError,
  { dosespotPrescriptionId: string },
  TContext
> => {
  const mutationKey = ["deletePrescription"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePrescription>>,
    { dosespotPrescriptionId: string }
  > = (props) => {
    const { dosespotPrescriptionId } = props ?? {};

    return deletePrescription(dosespotPrescriptionId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePrescriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePrescription>>
>;

export type DeletePrescriptionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Prescription
 */
export const useDeletePrescription = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePrescription>>,
      TError,
      { dosespotPrescriptionId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePrescription>>,
  TError,
  { dosespotPrescriptionId: string },
  TContext
> => {
  const mutationOptions = getDeletePrescriptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get prescriptions for a patient with optional pagination.

This endpoint retrieves prescriptions for the specified patient with optional pagination support.

Args:
    user_id: The patient's user ID
    limit: Maximum number of prescriptions to return (None for no limit)
    offset: Number of prescriptions to skip
    synchronize: Whether to synchronize with DoseSpot before answering
Returns:
    PaginatedPrescriptionsResponseT: Paginated list of prescriptions for the patient

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record
 * @summary Get Prescriptions For Patient
 */
export const getPrescriptionsForPatient = (
  userId: string,
  params?: GetPrescriptionsForPatientParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PaginatedPrescriptionsResponseT>> => {
  return axios.default.get(
    `/greenfield/dosespot/prescriptions/patient/${userId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetPrescriptionsForPatientQueryKey = (
  userId?: string,
  params?: GetPrescriptionsForPatientParams,
) => {
  return [
    `/greenfield/dosespot/prescriptions/patient/${userId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPrescriptionsForPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: GetPrescriptionsForPatientParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPrescriptionsForPatientQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPrescriptionsForPatient>>
  > = ({ signal }) =>
    getPrescriptionsForPatient(userId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPrescriptionsForPatientQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPrescriptionsForPatient>>
>;
export type GetPrescriptionsForPatientQueryError =
  AxiosError<HTTPValidationError>;

export function useGetPrescriptionsForPatient<
  TData = Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params: undefined | GetPrescriptionsForPatientParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
          TError,
          Awaited<ReturnType<typeof getPrescriptionsForPatient>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrescriptionsForPatient<
  TData = Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: GetPrescriptionsForPatientParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
          TError,
          Awaited<ReturnType<typeof getPrescriptionsForPatient>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrescriptionsForPatient<
  TData = Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: GetPrescriptionsForPatientParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Prescriptions For Patient
 */

export function useGetPrescriptionsForPatient<
  TData = Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: GetPrescriptionsForPatientParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionsForPatient>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPrescriptionsForPatientQueryOptions(
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a specific prescription for a patient.

This endpoint retrieves a specific prescription for the specified patient.

Args:
    user_id: The patient's user ID
    dosespot_prescription_id: The DoseSpot prescription ID

Returns:
    PrescriptionT or None: The prescription information if found

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record
 * @summary Get Prescription
 */
export const getPrescription = (
  userId: string,
  dosespotPrescriptionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetPrescription200>> => {
  return axios.default.get(
    `/greenfield/dosespot/prescriptions/patient/${userId}/prescription/${dosespotPrescriptionId}`,
    options,
  );
};

export const getGetPrescriptionQueryKey = (
  userId?: string,
  dosespotPrescriptionId?: string,
) => {
  return [
    `/greenfield/dosespot/prescriptions/patient/${userId}/prescription/${dosespotPrescriptionId}`,
  ] as const;
};

export const getGetPrescriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getPrescription>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescription>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPrescriptionQueryKey(userId, dosespotPrescriptionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrescription>>> = ({
    signal,
  }) =>
    getPrescription(userId, dosespotPrescriptionId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && dosespotPrescriptionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPrescription>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPrescriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPrescription>>
>;
export type GetPrescriptionQueryError = AxiosError<HTTPValidationError>;

export function useGetPrescription<
  TData = Awaited<ReturnType<typeof getPrescription>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  dosespotPrescriptionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescription>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrescription>>,
          TError,
          Awaited<ReturnType<typeof getPrescription>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrescription<
  TData = Awaited<ReturnType<typeof getPrescription>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescription>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrescription>>,
          TError,
          Awaited<ReturnType<typeof getPrescription>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrescription<
  TData = Awaited<ReturnType<typeof getPrescription>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescription>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Prescription
 */

export function useGetPrescription<
  TData = Awaited<ReturnType<typeof getPrescription>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescription>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPrescriptionQueryOptions(
    userId,
    dosespotPrescriptionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Change the pharmacy for an existing prescription.

This endpoint updates the pharmacy for a specific prescription in DoseSpot.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID to update
    request: The new pharmacy information

Returns:
    PrescriptionT: The updated prescription information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found or pharmacy change fails
 * @summary Change Prescription Pharmacy
 */
export const changePrescriptionPharmacy = (
  dosespotPrescriptionId: string,
  changePrescriptionPharmacyRequestT: ChangePrescriptionPharmacyRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PrescriptionT>> => {
  return axios.default.patch(
    `/greenfield/dosespot/prescriptions/${dosespotPrescriptionId}/pharmacy`,
    changePrescriptionPharmacyRequestT,
    options,
  );
};

export const getChangePrescriptionPharmacyMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePrescriptionPharmacy>>,
    TError,
    {
      dosespotPrescriptionId: string;
      data: ChangePrescriptionPharmacyRequestT;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePrescriptionPharmacy>>,
  TError,
  { dosespotPrescriptionId: string; data: ChangePrescriptionPharmacyRequestT },
  TContext
> => {
  const mutationKey = ["changePrescriptionPharmacy"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePrescriptionPharmacy>>,
    { dosespotPrescriptionId: string; data: ChangePrescriptionPharmacyRequestT }
  > = (props) => {
    const { dosespotPrescriptionId, data } = props ?? {};

    return changePrescriptionPharmacy(
      dosespotPrescriptionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePrescriptionPharmacyMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePrescriptionPharmacy>>
>;
export type ChangePrescriptionPharmacyMutationBody =
  ChangePrescriptionPharmacyRequestT;
export type ChangePrescriptionPharmacyMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Change Prescription Pharmacy
 */
export const useChangePrescriptionPharmacy = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changePrescriptionPharmacy>>,
      TError,
      {
        dosespotPrescriptionId: string;
        data: ChangePrescriptionPharmacyRequestT;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changePrescriptionPharmacy>>,
  TError,
  { dosespotPrescriptionId: string; data: ChangePrescriptionPharmacyRequestT },
  TContext
> => {
  const mutationOptions = getChangePrescriptionPharmacyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Set one or more prescriptions as ready to sign.

This endpoint marks prescriptions as ready to sign in DoseSpot for the specified patient.

Args:
    user_id: The patient's user ID
    request: The prescriptions to set ready to sign with optional DEA overrides

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If any prescription record is not found or operation fails
 * @summary Set Prescriptions Ready To Sign
 */
export const setPrescriptionsReadyToSign = (
  userId: string,
  setPrescriptionsReadyToSignRequestT: SetPrescriptionsReadyToSignRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.post(
    `/greenfield/dosespot/prescriptions/ready_to_sign/${userId}`,
    setPrescriptionsReadyToSignRequestT,
    options,
  );
};

export const getSetPrescriptionsReadyToSignMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPrescriptionsReadyToSign>>,
    TError,
    { userId: string; data: SetPrescriptionsReadyToSignRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setPrescriptionsReadyToSign>>,
  TError,
  { userId: string; data: SetPrescriptionsReadyToSignRequestT },
  TContext
> => {
  const mutationKey = ["setPrescriptionsReadyToSign"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setPrescriptionsReadyToSign>>,
    { userId: string; data: SetPrescriptionsReadyToSignRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return setPrescriptionsReadyToSign(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetPrescriptionsReadyToSignMutationResult = NonNullable<
  Awaited<ReturnType<typeof setPrescriptionsReadyToSign>>
>;
export type SetPrescriptionsReadyToSignMutationBody =
  SetPrescriptionsReadyToSignRequestT;
export type SetPrescriptionsReadyToSignMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Set Prescriptions Ready To Sign
 */
export const useSetPrescriptionsReadyToSign = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setPrescriptionsReadyToSign>>,
      TError,
      { userId: string; data: SetPrescriptionsReadyToSignRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setPrescriptionsReadyToSign>>,
  TError,
  { userId: string; data: SetPrescriptionsReadyToSignRequestT },
  TContext
> => {
  const mutationOptions =
    getSetPrescriptionsReadyToSignMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Send one or more prescriptions to designated pharmacies.

This endpoint sends prescriptions to their designated pharmacies via
DoseSpot, after running each one through the Rx-time prior-auth
gate. Returns a :class:`SendPrescriptionsResponseT` describing what
happened per-prescription — some ids may have been sent to the
pharmacy while others were diverted into PA cases.

Args:
    user_id: The patient's user ID
    request: The prescriptions to send with optional PIN and pharmacy override

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If any prescription record is not found or sending fails
 * @summary Send Prescriptions To Pharmacy
 */
export const sendPrescriptionsToPharmacy = (
  userId: string,
  sendPrescriptionsRequestT: SendPrescriptionsRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SendPrescriptionsResponseT>> => {
  return axios.default.post(
    `/greenfield/dosespot/prescriptions/send/${userId}`,
    sendPrescriptionsRequestT,
    options,
  );
};

export const getSendPrescriptionsToPharmacyMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendPrescriptionsToPharmacy>>,
    TError,
    { userId: string; data: SendPrescriptionsRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendPrescriptionsToPharmacy>>,
  TError,
  { userId: string; data: SendPrescriptionsRequestT },
  TContext
> => {
  const mutationKey = ["sendPrescriptionsToPharmacy"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendPrescriptionsToPharmacy>>,
    { userId: string; data: SendPrescriptionsRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return sendPrescriptionsToPharmacy(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendPrescriptionsToPharmacyMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendPrescriptionsToPharmacy>>
>;
export type SendPrescriptionsToPharmacyMutationBody = SendPrescriptionsRequestT;
export type SendPrescriptionsToPharmacyMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Send Prescriptions To Pharmacy
 */
export const useSendPrescriptionsToPharmacy = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendPrescriptionsToPharmacy>>,
      TError,
      { userId: string; data: SendPrescriptionsRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendPrescriptionsToPharmacy>>,
  TError,
  { userId: string; data: SendPrescriptionsRequestT },
  TContext
> => {
  const mutationOptions =
    getSendPrescriptionsToPharmacyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Live ``GET /api/patients/{id}/formulary`` against DoseSpot.

Lookup is scoped to one NDC under one coverage. Drives the formulary
section of the Rx wizard so the clinician can see formulary status,
copay tiers, payer-preferred alternatives, and therapeutic alternatives
*before* settling on a final draft.

Inputs are deliberately permissive so the wizard can fire as soon as a
medication is selected:

- ``dispensable_drug_id`` xor ``ndc`` — at least one must be provided.
  When only ``dispensable_drug_id`` is given, the NDC is resolved via
  ``select_medication``.
- ``pharmacy_id`` is optional. When provided, the eligibility channel
  (Retail / MailOrder / Specialty / LTC) is derived from the pharmacy's
  specialties; otherwise we default to Retail (the most common channel
  and the one the patient's primary coverage typically backs).
- ``patient_eligibility_id`` is optional. When omitted, we resolve the
  first active coverage that covers the channel — same selection logic
  the gate uses.

Returns ``formulary=None`` (rather than 4xx-ing) when DoseSpot returns
no data or the patient has no coverage for the channel; the UI shows a
"no formulary data available" message in that case.
 * @summary Get Patient Formulary For Drug
 */
export const getPatientFormularyForDrug = (
  userId: string,
  params?: GetPatientFormularyForDrugParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PatientFormularyResponseT>> => {
  return axios.default.get(
    `/greenfield/dosespot/patients/${userId}/formulary`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetPatientFormularyForDrugQueryKey = (
  userId?: string,
  params?: GetPatientFormularyForDrugParams,
) => {
  return [
    `/greenfield/dosespot/patients/${userId}/formulary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPatientFormularyForDrugQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: GetPatientFormularyForDrugParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPatientFormularyForDrugQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientFormularyForDrug>>
  > = ({ signal }) =>
    getPatientFormularyForDrug(userId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientFormularyForDrugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientFormularyForDrug>>
>;
export type GetPatientFormularyForDrugQueryError =
  AxiosError<HTTPValidationError>;

export function useGetPatientFormularyForDrug<
  TData = Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params: undefined | GetPatientFormularyForDrugParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
          TError,
          Awaited<ReturnType<typeof getPatientFormularyForDrug>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientFormularyForDrug<
  TData = Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: GetPatientFormularyForDrugParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
          TError,
          Awaited<ReturnType<typeof getPatientFormularyForDrug>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientFormularyForDrug<
  TData = Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: GetPatientFormularyForDrugParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient Formulary For Drug
 */

export function useGetPatientFormularyForDrug<
  TData = Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: GetPatientFormularyForDrugParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientFormularyForDrug>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientFormularyForDrugQueryOptions(
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Predict the post-sign prior-auth gate outcome for an in-flight Rx draft.

Shares its full decision path with
:mod:`lotushealth.dosespot.prescription_pa_gate` — the same NDC
resolution, pharmacy-channel mapping, coverage lookup, and
realtime-benefits / formulary classifier that run after
``set_prescriptions_ready_to_sign`` runs here too. That shared path
is why a pre-sign preview matches the post-sign decision
deterministically: there is no second "likely PA?" classifier to
keep in sync.

Missing or unresolved inputs collapse to ``UNKNOWN`` /
``NO_COVERAGE`` rather than 4xx'ing, so the client can safely poll
this endpoint as the wizard fills and only render an indicator once
the outcome firms up.
 * @summary Preview Prior Auth For Rx Draft
 */
export const previewPriorAuthForRxDraft = (
  userId: string,
  previewPriorAuthRequestT: PreviewPriorAuthRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PreviewPriorAuthResponseT>> => {
  return axios.default.post(
    `/greenfield/dosespot/prescriptions/preview_prior_auth/${userId}`,
    previewPriorAuthRequestT,
    options,
  );
};

export const getPreviewPriorAuthForRxDraftMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewPriorAuthForRxDraft>>,
    TError,
    { userId: string; data: PreviewPriorAuthRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewPriorAuthForRxDraft>>,
  TError,
  { userId: string; data: PreviewPriorAuthRequestT },
  TContext
> => {
  const mutationKey = ["previewPriorAuthForRxDraft"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewPriorAuthForRxDraft>>,
    { userId: string; data: PreviewPriorAuthRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return previewPriorAuthForRxDraft(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewPriorAuthForRxDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewPriorAuthForRxDraft>>
>;
export type PreviewPriorAuthForRxDraftMutationBody = PreviewPriorAuthRequestT;
export type PreviewPriorAuthForRxDraftMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Preview Prior Auth For Rx Draft
 */
export const usePreviewPriorAuthForRxDraft = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewPriorAuthForRxDraft>>,
      TError,
      { userId: string; data: PreviewPriorAuthRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof previewPriorAuthForRxDraft>>,
  TError,
  { userId: string; data: PreviewPriorAuthRequestT },
  TContext
> => {
  const mutationOptions = getPreviewPriorAuthForRxDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get transmission errors for the authenticated user's associated clinic(s).

This endpoint retrieves transmission errors for prescriptions from the clinician's
associated clinic(s), with optional pagination support.

Args:
    page_number: The page number to retrieve (1-based, optional)
    clinic: The clinic to filter by (optional)

Returns:
    TransmissionErrorsPagedListResponseT: Paged list of transmission errors

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get My Transmission Errors
 */
export const getMyTransmissionErrors = (
  params?: GetMyTransmissionErrorsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TransmissionErrorsPagedListResponseT>> => {
  return axios.default.get(`/greenfield/dosespot/notifications/errors/me`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetMyTransmissionErrorsQueryKey = (
  params?: GetMyTransmissionErrorsParams,
) => {
  return [
    `/greenfield/dosespot/notifications/errors/me`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMyTransmissionErrorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyTransmissionErrors>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMyTransmissionErrorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyTransmissionErrors>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyTransmissionErrorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyTransmissionErrors>>
  > = ({ signal }) =>
    getMyTransmissionErrors(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyTransmissionErrors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyTransmissionErrorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyTransmissionErrors>>
>;
export type GetMyTransmissionErrorsQueryError = AxiosError<HTTPValidationError>;

export function useGetMyTransmissionErrors<
  TData = Awaited<ReturnType<typeof getMyTransmissionErrors>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | GetMyTransmissionErrorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyTransmissionErrors>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTransmissionErrors>>,
          TError,
          Awaited<ReturnType<typeof getMyTransmissionErrors>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyTransmissionErrors<
  TData = Awaited<ReturnType<typeof getMyTransmissionErrors>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMyTransmissionErrorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyTransmissionErrors>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTransmissionErrors>>,
          TError,
          Awaited<ReturnType<typeof getMyTransmissionErrors>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyTransmissionErrors<
  TData = Awaited<ReturnType<typeof getMyTransmissionErrors>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMyTransmissionErrorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyTransmissionErrors>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Transmission Errors
 */

export function useGetMyTransmissionErrors<
  TData = Awaited<ReturnType<typeof getMyTransmissionErrors>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMyTransmissionErrorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyTransmissionErrors>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyTransmissionErrorsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get notification counts for the authenticated user at a single clinic.

This endpoint retrieves the number of refill requests, transmission errors,
and pending prescriptions for the clinician at a single clinic.

Args:
    clinic: The clinic to get counts for (optional)

Returns:
    PrescriberNotificationCountsT: Notification counts

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get My Notification Counts
 */
export const getMyNotificationCounts = (
  params?: GetMyNotificationCountsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PrescriberNotificationCountsT>> => {
  return axios.default.get(`/greenfield/dosespot/notifications/counts/me`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetMyNotificationCountsQueryKey = (
  params?: GetMyNotificationCountsParams,
) => {
  return [
    `/greenfield/dosespot/notifications/counts/me`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMyNotificationCountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyNotificationCounts>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMyNotificationCountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyNotificationCounts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyNotificationCountsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyNotificationCounts>>
  > = ({ signal }) =>
    getMyNotificationCounts(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyNotificationCounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyNotificationCountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyNotificationCounts>>
>;
export type GetMyNotificationCountsQueryError = AxiosError<HTTPValidationError>;

export function useGetMyNotificationCounts<
  TData = Awaited<ReturnType<typeof getMyNotificationCounts>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | GetMyNotificationCountsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyNotificationCounts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyNotificationCounts>>,
          TError,
          Awaited<ReturnType<typeof getMyNotificationCounts>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyNotificationCounts<
  TData = Awaited<ReturnType<typeof getMyNotificationCounts>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMyNotificationCountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyNotificationCounts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyNotificationCounts>>,
          TError,
          Awaited<ReturnType<typeof getMyNotificationCounts>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyNotificationCounts<
  TData = Awaited<ReturnType<typeof getMyNotificationCounts>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMyNotificationCountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyNotificationCounts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Notification Counts
 */

export function useGetMyNotificationCounts<
  TData = Awaited<ReturnType<typeof getMyNotificationCounts>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetMyNotificationCountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyNotificationCounts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyNotificationCountsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get prescription information by DoseSpot prescription ID.

This endpoint fetches prescription details using the prescription model,
useful for displaying transmission error details.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID

Returns:
    PrescriptionT or None: The prescription information if found

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Prescription By Dosespot Id
 */
export const getPrescriptionByDosespotId = (
  patientId: string,
  dosespotPrescriptionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetPrescriptionByDosespotId200>> => {
  return axios.default.get(
    `/greenfield/dosespot/notifications/prescription/${patientId}/${dosespotPrescriptionId}`,
    options,
  );
};

export const getGetPrescriptionByDosespotIdQueryKey = (
  patientId?: string,
  dosespotPrescriptionId?: string,
) => {
  return [
    `/greenfield/dosespot/notifications/prescription/${patientId}/${dosespotPrescriptionId}`,
  ] as const;
};

export const getGetPrescriptionByDosespotIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPrescriptionByDosespotIdQueryKey(patientId, dosespotPrescriptionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPrescriptionByDosespotId>>
  > = ({ signal }) =>
    getPrescriptionByDosespotId(patientId, dosespotPrescriptionId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(patientId && dosespotPrescriptionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPrescriptionByDosespotIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPrescriptionByDosespotId>>
>;
export type GetPrescriptionByDosespotIdQueryError =
  AxiosError<HTTPValidationError>;

export function useGetPrescriptionByDosespotId<
  TData = Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  dosespotPrescriptionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
          TError,
          Awaited<ReturnType<typeof getPrescriptionByDosespotId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrescriptionByDosespotId<
  TData = Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
          TError,
          Awaited<ReturnType<typeof getPrescriptionByDosespotId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrescriptionByDosespotId<
  TData = Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Prescription By Dosespot Id
 */

export function useGetPrescriptionByDosespotId<
  TData = Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionByDosespotId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPrescriptionByDosespotIdQueryOptions(
    patientId,
    dosespotPrescriptionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get patient information by DoseSpot patient ID.

This endpoint fetches patient details directly from DoseSpot using the
patient ID, useful for displaying transmission error details.

Args:
    dosespot_patient_id: The DoseSpot patient ID

Returns:
    PatientT or None: The patient information if found

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Patient By Dosespot Id
 */
export const getPatientByDosespotId = (
  dosespotPatientId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetPatientByDosespotId200>> => {
  return axios.default.get(
    `/greenfield/dosespot/notifications/patient/${dosespotPatientId}`,
    options,
  );
};

export const getGetPatientByDosespotIdQueryKey = (
  dosespotPatientId?: string,
) => {
  return [
    `/greenfield/dosespot/notifications/patient/${dosespotPatientId}`,
  ] as const;
};

export const getGetPatientByDosespotIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientByDosespotId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  dosespotPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientByDosespotId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPatientByDosespotIdQueryKey(dosespotPatientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientByDosespotId>>
  > = ({ signal }) =>
    getPatientByDosespotId(dosespotPatientId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!dosespotPatientId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientByDosespotId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientByDosespotIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientByDosespotId>>
>;
export type GetPatientByDosespotIdQueryError = AxiosError<HTTPValidationError>;

export function useGetPatientByDosespotId<
  TData = Awaited<ReturnType<typeof getPatientByDosespotId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  dosespotPatientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientByDosespotId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientByDosespotId>>,
          TError,
          Awaited<ReturnType<typeof getPatientByDosespotId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientByDosespotId<
  TData = Awaited<ReturnType<typeof getPatientByDosespotId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  dosespotPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientByDosespotId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientByDosespotId>>,
          TError,
          Awaited<ReturnType<typeof getPatientByDosespotId>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientByDosespotId<
  TData = Awaited<ReturnType<typeof getPatientByDosespotId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  dosespotPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientByDosespotId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient By Dosespot Id
 */

export function useGetPatientByDosespotId<
  TData = Awaited<ReturnType<typeof getPatientByDosespotId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  dosespotPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientByDosespotId>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientByDosespotIdQueryOptions(
    dosespotPatientId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get prescription logs (full history) for a specific prescription.

This endpoint retrieves the complete history of a prescription including all
status changes and updates.

Args:
    user_id: The patient's user ID
    dosespot_prescription_id: The DoseSpot prescription ID

Returns:
    List[PrescriptionLogT]: List of prescription log entries

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found or request fails
 * @summary Get Prescription Logs
 */
export const getPrescriptionLogs = (
  userId: string,
  dosespotPrescriptionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PrescriptionLogT[]>> => {
  return axios.default.get(
    `/greenfield/dosespot/prescriptions/patient/${userId}/prescription/${dosespotPrescriptionId}/logs`,
    options,
  );
};

export const getGetPrescriptionLogsQueryKey = (
  userId?: string,
  dosespotPrescriptionId?: string,
) => {
  return [
    `/greenfield/dosespot/prescriptions/patient/${userId}/prescription/${dosespotPrescriptionId}/logs`,
  ] as const;
};

export const getGetPrescriptionLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPrescriptionLogs>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionLogs>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPrescriptionLogsQueryKey(userId, dosespotPrescriptionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPrescriptionLogs>>
  > = ({ signal }) =>
    getPrescriptionLogs(userId, dosespotPrescriptionId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && dosespotPrescriptionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPrescriptionLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPrescriptionLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPrescriptionLogs>>
>;
export type GetPrescriptionLogsQueryError = AxiosError<HTTPValidationError>;

export function useGetPrescriptionLogs<
  TData = Awaited<ReturnType<typeof getPrescriptionLogs>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  dosespotPrescriptionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrescriptionLogs>>,
          TError,
          Awaited<ReturnType<typeof getPrescriptionLogs>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrescriptionLogs<
  TData = Awaited<ReturnType<typeof getPrescriptionLogs>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrescriptionLogs>>,
          TError,
          Awaited<ReturnType<typeof getPrescriptionLogs>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrescriptionLogs<
  TData = Awaited<ReturnType<typeof getPrescriptionLogs>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionLogs>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Prescription Logs
 */

export function useGetPrescriptionLogs<
  TData = Awaited<ReturnType<typeof getPrescriptionLogs>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  dosespotPrescriptionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionLogs>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPrescriptionLogsQueryOptions(
    userId,
    dosespotPrescriptionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get pending refill requests for the authenticated user's associated clinic(s).

This endpoint retrieves basic refill request information with optional filtering
by clinic and patient, with pagination support.

Args:
    clinic: The clinic to filter by (optional)
    patientId: The patient ID to filter by (optional)
    pageNumber: The page number to retrieve (1-based, optional)

Returns:
    RefillPagedListResponseT: Paged list of pending refill requests

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Pending Refills
 */
export const getPendingRefills = (
  params?: GetPendingRefillsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RefillPagedListResponseT>> => {
  return axios.default.get(`/greenfield/dosespot/refills/pending`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetPendingRefillsQueryKey = (
  params?: GetPendingRefillsParams,
) => {
  return [
    `/greenfield/dosespot/refills/pending`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPendingRefillsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPendingRefills>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRefillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRefills>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPendingRefillsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPendingRefills>>
  > = ({ signal }) => getPendingRefills(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPendingRefills>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingRefillsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPendingRefills>>
>;
export type GetPendingRefillsQueryError = AxiosError<HTTPValidationError>;

export function useGetPendingRefills<
  TData = Awaited<ReturnType<typeof getPendingRefills>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | GetPendingRefillsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRefills>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRefills>>,
          TError,
          Awaited<ReturnType<typeof getPendingRefills>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingRefills<
  TData = Awaited<ReturnType<typeof getPendingRefills>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRefillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRefills>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRefills>>,
          TError,
          Awaited<ReturnType<typeof getPendingRefills>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingRefills<
  TData = Awaited<ReturnType<typeof getPendingRefills>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRefillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRefills>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Pending Refills
 */

export function useGetPendingRefills<
  TData = Awaited<ReturnType<typeof getPendingRefills>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRefillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRefills>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPendingRefillsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get detailed pending refill requests for the authenticated user's associated clinic(s).

This endpoint retrieves detailed refill request information including full prescription
details, with optional filtering by clinic and patient, and pagination support.

Args:
    clinic: The clinic to filter by (optional)
    patientId: The patient ID to filter by (optional)
    pageNumber: The page number to retrieve (1-based, optional)

Returns:
    RefillDetailedPagedListResponseT: Paged list of detailed pending refill requests

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Pending Refills Detailed
 */
export const getPendingRefillsDetailed = (
  params?: GetPendingRefillsDetailedParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RefillDetailedPagedListResponseT>> => {
  return axios.default.get(`/greenfield/dosespot/refills/pending/detailed`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetPendingRefillsDetailedQueryKey = (
  params?: GetPendingRefillsDetailedParams,
) => {
  return [
    `/greenfield/dosespot/refills/pending/detailed`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPendingRefillsDetailedQueryOptions = <
  TData = Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRefillsDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPendingRefillsDetailedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPendingRefillsDetailed>>
  > = ({ signal }) =>
    getPendingRefillsDetailed(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingRefillsDetailedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPendingRefillsDetailed>>
>;
export type GetPendingRefillsDetailedQueryError =
  AxiosError<HTTPValidationError>;

export function useGetPendingRefillsDetailed<
  TData = Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | GetPendingRefillsDetailedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
          TError,
          Awaited<ReturnType<typeof getPendingRefillsDetailed>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingRefillsDetailed<
  TData = Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRefillsDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
          TError,
          Awaited<ReturnType<typeof getPendingRefillsDetailed>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingRefillsDetailed<
  TData = Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRefillsDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Pending Refills Detailed
 */

export function useGetPendingRefillsDetailed<
  TData = Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRefillsDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRefillsDetailed>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPendingRefillsDetailedQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Approve a pending refill request.

This endpoint approves a refill request by providing the number of refills
and optional comment and effective date.

Args:
    refill_id: The refill ID to approve
    request: The approval request containing refills count and optional fields

Returns:
    IdentifierResponseT: Response from the approval operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or approval fails
 * @summary Approve Refill
 */
export const approveRefill = (
  refillId: number,
  approveRefillRequestT: ApproveRefillRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IdentifierResponseT>> => {
  return axios.default.post(
    `/greenfield/dosespot/refills/${refillId}/approve`,
    approveRefillRequestT,
    options,
  );
};

export const getApproveRefillMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveRefill>>,
    TError,
    { refillId: number; data: ApproveRefillRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveRefill>>,
  TError,
  { refillId: number; data: ApproveRefillRequestT },
  TContext
> => {
  const mutationKey = ["approveRefill"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveRefill>>,
    { refillId: number; data: ApproveRefillRequestT }
  > = (props) => {
    const { refillId, data } = props ?? {};

    return approveRefill(refillId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveRefillMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveRefill>>
>;
export type ApproveRefillMutationBody = ApproveRefillRequestT;
export type ApproveRefillMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Approve Refill
 */
export const useApproveRefill = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveRefill>>,
      TError,
      { refillId: number; data: ApproveRefillRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveRefill>>,
  TError,
  { refillId: number; data: ApproveRefillRequestT },
  TContext
> => {
  const mutationOptions = getApproveRefillMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deny a pending refill request.

This endpoint denies a refill request by providing the denial reason
and optional note.

Args:
    refill_id: The refill ID to deny
    request: The denial request containing denial reason and optional note

Returns:
    IdentifierResponseT: Response from the denial operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or denial fails
 * @summary Deny Refill
 */
export const denyRefill = (
  refillId: number,
  denyRefillRequestT: DenyRefillRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IdentifierResponseT>> => {
  return axios.default.post(
    `/greenfield/dosespot/refills/${refillId}/deny`,
    denyRefillRequestT,
    options,
  );
};

export const getDenyRefillMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof denyRefill>>,
    TError,
    { refillId: number; data: DenyRefillRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof denyRefill>>,
  TError,
  { refillId: number; data: DenyRefillRequestT },
  TContext
> => {
  const mutationKey = ["denyRefill"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof denyRefill>>,
    { refillId: number; data: DenyRefillRequestT }
  > = (props) => {
    const { refillId, data } = props ?? {};

    return denyRefill(refillId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DenyRefillMutationResult = NonNullable<
  Awaited<ReturnType<typeof denyRefill>>
>;
export type DenyRefillMutationBody = DenyRefillRequestT;
export type DenyRefillMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Deny Refill
 */
export const useDenyRefill = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof denyRefill>>,
      TError,
      { refillId: number; data: DenyRefillRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof denyRefill>>,
  TError,
  { refillId: number; data: DenyRefillRequestT },
  TContext
> => {
  const mutationOptions = getDenyRefillMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Replace a refill request with a new prescription.

This endpoint replaces a refill request with a different prescription.
Only one of NewPrescription, NewSupplyPrescription, NewCompoundPrescription,
or NewFreeTextPrescription should be provided.

Args:
    refill_id: The refill ID to replace
    request: The replacement request containing patient ID and new prescription details

Returns:
    IdentifierResponseT: Response from the replacement operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or replacement fails
 * @summary Replace Refill
 */
export const replaceRefill = (
  refillId: number,
  replaceRefillRequestT: ReplaceRefillRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IdentifierResponseT>> => {
  return axios.default.post(
    `/greenfield/dosespot/refills/${refillId}/replace`,
    replaceRefillRequestT,
    options,
  );
};

export const getReplaceRefillMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceRefill>>,
    TError,
    { refillId: number; data: ReplaceRefillRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replaceRefill>>,
  TError,
  { refillId: number; data: ReplaceRefillRequestT },
  TContext
> => {
  const mutationKey = ["replaceRefill"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replaceRefill>>,
    { refillId: number; data: ReplaceRefillRequestT }
  > = (props) => {
    const { refillId, data } = props ?? {};

    return replaceRefill(refillId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplaceRefillMutationResult = NonNullable<
  Awaited<ReturnType<typeof replaceRefill>>
>;
export type ReplaceRefillMutationBody = ReplaceRefillRequestT;
export type ReplaceRefillMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Replace Refill
 */
export const useReplaceRefill = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof replaceRefill>>,
      TError,
      { refillId: number; data: ReplaceRefillRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof replaceRefill>>,
  TError,
  { refillId: number; data: ReplaceRefillRequestT },
  TContext
> => {
  const mutationOptions = getReplaceRefillMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Perform an action on a pending refill request.

Accepts a discriminated-union body whose ``action`` field selects
approve, deny, or replace.  Used by the copilot proposed-action
form so the clinician can review and submit in one step.
 * @summary Refill Action
 */
export const refillAction = (
  refillId: number,
  refillActionBody: RefillActionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IdentifierResponseT>> => {
  return axios.default.post(
    `/greenfield/dosespot/refills/${refillId}/action`,
    refillActionBody,
    options,
  );
};

export const getRefillActionMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refillAction>>,
    TError,
    { refillId: number; data: RefillActionBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refillAction>>,
  TError,
  { refillId: number; data: RefillActionBody },
  TContext
> => {
  const mutationKey = ["refillAction"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refillAction>>,
    { refillId: number; data: RefillActionBody }
  > = (props) => {
    const { refillId, data } = props ?? {};

    return refillAction(refillId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefillActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof refillAction>>
>;
export type RefillActionMutationBody = RefillActionBody;
export type RefillActionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Refill Action
 */
export const useRefillAction = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refillAction>>,
      TError,
      { refillId: number; data: RefillActionBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refillAction>>,
  TError,
  { refillId: number; data: RefillActionBody },
  TContext
> => {
  const mutationOptions = getRefillActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get detailed pending RxChange requests for the authenticated user's associated clinic(s).

This endpoint retrieves detailed RxChange request information including full prescription
details, with optional filtering by clinic and patient, and pagination support.

Args:
    clinic: The clinic to filter by (optional)
    patientId: The patient ID to filter by (optional)
    pageNumber: The page number to retrieve (1-based, optional)

Returns:
    RxChangeDetailedPagedListResponseT: Paged list of detailed pending RxChange requests

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Pending Rx Changes Detailed
 */
export const getPendingRxChangesDetailed = (
  params?: GetPendingRxChangesDetailedParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RxChangeDetailedPagedListResponseT>> => {
  return axios.default.get(`/greenfield/dosespot/rxchanges/pending/detailed`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetPendingRxChangesDetailedQueryKey = (
  params?: GetPendingRxChangesDetailedParams,
) => {
  return [
    `/greenfield/dosespot/rxchanges/pending/detailed`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPendingRxChangesDetailedQueryOptions = <
  TData = Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRxChangesDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPendingRxChangesDetailedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPendingRxChangesDetailed>>
  > = ({ signal }) =>
    getPendingRxChangesDetailed(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingRxChangesDetailedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPendingRxChangesDetailed>>
>;
export type GetPendingRxChangesDetailedQueryError =
  AxiosError<HTTPValidationError>;

export function useGetPendingRxChangesDetailed<
  TData = Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | GetPendingRxChangesDetailedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
          TError,
          Awaited<ReturnType<typeof getPendingRxChangesDetailed>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingRxChangesDetailed<
  TData = Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRxChangesDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
          TError,
          Awaited<ReturnType<typeof getPendingRxChangesDetailed>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingRxChangesDetailed<
  TData = Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRxChangesDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Pending Rx Changes Detailed
 */

export function useGetPendingRxChangesDetailed<
  TData = Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetPendingRxChangesDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingRxChangesDetailed>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPendingRxChangesDetailedQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Approve a pending RxChange request.

This endpoint approves an RxChange request, optionally providing a new prescription
or selecting from the requested medications.

Args:
    rx_change_id: The RxChange ID to approve
    request: The approval request containing optional new prescription details

Returns:
    IdentifierResponseT: Response from the approval operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or approval fails
 * @summary Approve Rx Change
 */
export const approveRxChange = (
  rxChangeId: number,
  approveRxChangeRequestT: ApproveRxChangeRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IdentifierResponseT>> => {
  return axios.default.post(
    `/greenfield/dosespot/rxchanges/${rxChangeId}/approve`,
    approveRxChangeRequestT,
    options,
  );
};

export const getApproveRxChangeMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveRxChange>>,
    TError,
    { rxChangeId: number; data: ApproveRxChangeRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveRxChange>>,
  TError,
  { rxChangeId: number; data: ApproveRxChangeRequestT },
  TContext
> => {
  const mutationKey = ["approveRxChange"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveRxChange>>,
    { rxChangeId: number; data: ApproveRxChangeRequestT }
  > = (props) => {
    const { rxChangeId, data } = props ?? {};

    return approveRxChange(rxChangeId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveRxChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveRxChange>>
>;
export type ApproveRxChangeMutationBody = ApproveRxChangeRequestT;
export type ApproveRxChangeMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Approve Rx Change
 */
export const useApproveRxChange = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveRxChange>>,
      TError,
      { rxChangeId: number; data: ApproveRxChangeRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveRxChange>>,
  TError,
  { rxChangeId: number; data: ApproveRxChangeRequestT },
  TContext
> => {
  const mutationOptions = getApproveRxChangeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deny a pending RxChange request.

This endpoint denies an RxChange request by providing the denial reason
and optional comment.

Args:
    rx_change_id: The RxChange ID to deny
    request: The denial request containing denial reason and optional comment

Returns:
    ResponseT: Response from the denial operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or denial fails
 * @summary Deny Rx Change
 */
export const denyRxChange = (
  rxChangeId: number,
  denyRxChangeRequestT: DenyRxChangeRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ResponseT>> => {
  return axios.default.post(
    `/greenfield/dosespot/rxchanges/${rxChangeId}/deny`,
    denyRxChangeRequestT,
    options,
  );
};

export const getDenyRxChangeMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof denyRxChange>>,
    TError,
    { rxChangeId: number; data: DenyRxChangeRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof denyRxChange>>,
  TError,
  { rxChangeId: number; data: DenyRxChangeRequestT },
  TContext
> => {
  const mutationKey = ["denyRxChange"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof denyRxChange>>,
    { rxChangeId: number; data: DenyRxChangeRequestT }
  > = (props) => {
    const { rxChangeId, data } = props ?? {};

    return denyRxChange(rxChangeId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DenyRxChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof denyRxChange>>
>;
export type DenyRxChangeMutationBody = DenyRxChangeRequestT;
export type DenyRxChangeMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Deny Rx Change
 */
export const useDenyRxChange = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof denyRxChange>>,
      TError,
      { rxChangeId: number; data: DenyRxChangeRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof denyRxChange>>,
  TError,
  { rxChangeId: number; data: DenyRxChangeRequestT },
  TContext
> => {
  const mutationOptions = getDenyRxChangeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Perform an action on a pending RxChange request.

Accepts a discriminated-union body whose ``action`` field selects
approve, deny, or approve_with_changes.  Used by the copilot
proposed-action form so the clinician can review and submit in one step.
 * @summary Rx Change Action
 */
export const rxChangeAction = (
  rxChangeId: number,
  rxChangeActionBody: RxChangeActionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RxChangeAction200>> => {
  return axios.default.post(
    `/greenfield/dosespot/rxchanges/${rxChangeId}/action`,
    rxChangeActionBody,
    options,
  );
};

export const getRxChangeActionMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rxChangeAction>>,
    TError,
    { rxChangeId: number; data: RxChangeActionBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rxChangeAction>>,
  TError,
  { rxChangeId: number; data: RxChangeActionBody },
  TContext
> => {
  const mutationKey = ["rxChangeAction"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rxChangeAction>>,
    { rxChangeId: number; data: RxChangeActionBody }
  > = (props) => {
    const { rxChangeId, data } = props ?? {};

    return rxChangeAction(rxChangeId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RxChangeActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof rxChangeAction>>
>;
export type RxChangeActionMutationBody = RxChangeActionBody;
export type RxChangeActionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Rx Change Action
 */
export const useRxChangeAction = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rxChangeAction>>,
      TError,
      { rxChangeId: number; data: RxChangeActionBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rxChangeAction>>,
  TError,
  { rxChangeId: number; data: RxChangeActionBody },
  TContext
> => {
  const mutationOptions = getRxChangeActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Reconcile an RxChange request by linking it to a patient record.

This endpoint links an existing RxChange request to a patient record
and associates it with a referenced prescription.

Args:
    rx_change_id: The RxChange ID to reconcile
    user_id: The patient's user ID
    request: The reconciliation request containing the referenced prescription ID

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record or reconciliation fails
 * @summary Reconcile Rx Change
 */
export const reconcileRxChange = (
  rxChangeId: number,
  userId: string,
  reconcileRxChangeRequestT: ReconcileRxChangeRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.post(
    `/greenfield/dosespot/rxchanges/${rxChangeId}/patients/${userId}/reconcile`,
    reconcileRxChangeRequestT,
    options,
  );
};

export const getReconcileRxChangeMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reconcileRxChange>>,
    TError,
    { rxChangeId: number; userId: string; data: ReconcileRxChangeRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reconcileRxChange>>,
  TError,
  { rxChangeId: number; userId: string; data: ReconcileRxChangeRequestT },
  TContext
> => {
  const mutationKey = ["reconcileRxChange"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reconcileRxChange>>,
    { rxChangeId: number; userId: string; data: ReconcileRxChangeRequestT }
  > = (props) => {
    const { rxChangeId, userId, data } = props ?? {};

    return reconcileRxChange(rxChangeId, userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReconcileRxChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof reconcileRxChange>>
>;
export type ReconcileRxChangeMutationBody = ReconcileRxChangeRequestT;
export type ReconcileRxChangeMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Reconcile Rx Change
 */
export const useReconcileRxChange = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reconcileRxChange>>,
      TError,
      { rxChangeId: number; userId: string; data: ReconcileRxChangeRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reconcileRxChange>>,
  TError,
  { rxChangeId: number; userId: string; data: ReconcileRxChangeRequestT },
  TContext
> => {
  const mutationOptions = getReconcileRxChangeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Change the patient linked to an RxChange request.

This endpoint links the RxChange request to a different, existing patient
in the same clinic.

Args:
    rx_change_id: The RxChange ID to update
    request: The request containing the new patient's user ID

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record or change fails
 * @summary Change Rx Change Patient
 */
export const changeRxChangePatient = (
  rxChangeId: number,
  changeRxChangePatientRequestT: ChangeRxChangePatientRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.patch(
    `/greenfield/dosespot/rxchanges/${rxChangeId}/changePatient`,
    changeRxChangePatientRequestT,
    options,
  );
};

export const getChangeRxChangePatientMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeRxChangePatient>>,
    TError,
    { rxChangeId: number; data: ChangeRxChangePatientRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeRxChangePatient>>,
  TError,
  { rxChangeId: number; data: ChangeRxChangePatientRequestT },
  TContext
> => {
  const mutationKey = ["changeRxChangePatient"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeRxChangePatient>>,
    { rxChangeId: number; data: ChangeRxChangePatientRequestT }
  > = (props) => {
    const { rxChangeId, data } = props ?? {};

    return changeRxChangePatient(rxChangeId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeRxChangePatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeRxChangePatient>>
>;
export type ChangeRxChangePatientMutationBody = ChangeRxChangePatientRequestT;
export type ChangeRxChangePatientMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Change Rx Change Patient
 */
export const useChangeRxChangePatient = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeRxChangePatient>>,
      TError,
      { rxChangeId: number; data: ChangeRxChangePatientRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeRxChangePatient>>,
  TError,
  { rxChangeId: number; data: ChangeRxChangePatientRequestT },
  TContext
> => {
  const mutationOptions = getChangeRxChangePatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List all prior authorization cases for a given patient.

Drives the Prior Auths tab in the copilot patient workspace. Results
are served from our SQL mirror (``DosespotPriorAuthRecord``), not live
DoseSpot, so the list stays consistent with the clinician inbox even
when DoseSpot is slow.
 * @summary List Patient Prior Auths
 */
export const listPatientPriorAuths = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PriorAuthSummaryT[]>> => {
  return axios.default.get(
    `/greenfield/dosespot/patients/${userId}/prior_auths`,
    options,
  );
};

export const getListPatientPriorAuthsQueryKey = (userId?: string) => {
  return [`/greenfield/dosespot/patients/${userId}/prior_auths`] as const;
};

export const getListPatientPriorAuthsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPatientPriorAuths>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPatientPriorAuths>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPatientPriorAuthsQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPatientPriorAuths>>
  > = ({ signal }) =>
    listPatientPriorAuths(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPatientPriorAuths>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPatientPriorAuthsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPatientPriorAuths>>
>;
export type ListPatientPriorAuthsQueryError = AxiosError<HTTPValidationError>;

export function useListPatientPriorAuths<
  TData = Awaited<ReturnType<typeof listPatientPriorAuths>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPatientPriorAuths>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPatientPriorAuths>>,
          TError,
          Awaited<ReturnType<typeof listPatientPriorAuths>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPatientPriorAuths<
  TData = Awaited<ReturnType<typeof listPatientPriorAuths>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPatientPriorAuths>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPatientPriorAuths>>,
          TError,
          Awaited<ReturnType<typeof listPatientPriorAuths>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPatientPriorAuths<
  TData = Awaited<ReturnType<typeof listPatientPriorAuths>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPatientPriorAuths>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Patient Prior Auths
 */

export function useListPatientPriorAuths<
  TData = Awaited<ReturnType<typeof listPatientPriorAuths>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPatientPriorAuths>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListPatientPriorAuthsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Live ``GET /api/patients/{id}/eligibilities`` against DoseSpot.

Drives the Eligibilities sub-section under the Prior Auths tab in
the copilot patient workspace. Unlike the prior-auth list, this is
*live* against DoseSpot — coverages can change as PBM data updates
and we don't mirror them locally. The fake DoseSpot answers from its
in-memory ``CoverageEntry`` table; staging answers from real PBM
data.

Authenticates as the requesting clinician so the audit trail
attributes the eligibility lookup correctly. Falls back to the
clinic admin user when the requesting user has no DoseSpot
clinician record (so non-prescriber roles can still read coverages).
 * @summary List Patient Eligibilities
 */
export const listPatientEligibilities = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PatientEligibilitiesResponseT>> => {
  return axios.default.get(
    `/greenfield/dosespot/patients/${userId}/eligibilities`,
    options,
  );
};

export const getListPatientEligibilitiesQueryKey = (userId?: string) => {
  return [`/greenfield/dosespot/patients/${userId}/eligibilities`] as const;
};

export const getListPatientEligibilitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPatientEligibilities>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPatientEligibilities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPatientEligibilitiesQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPatientEligibilities>>
  > = ({ signal }) =>
    listPatientEligibilities(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPatientEligibilities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPatientEligibilitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPatientEligibilities>>
>;
export type ListPatientEligibilitiesQueryError =
  AxiosError<HTTPValidationError>;

export function useListPatientEligibilities<
  TData = Awaited<ReturnType<typeof listPatientEligibilities>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPatientEligibilities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPatientEligibilities>>,
          TError,
          Awaited<ReturnType<typeof listPatientEligibilities>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPatientEligibilities<
  TData = Awaited<ReturnType<typeof listPatientEligibilities>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPatientEligibilities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPatientEligibilities>>,
          TError,
          Awaited<ReturnType<typeof listPatientEligibilities>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPatientEligibilities<
  TData = Awaited<ReturnType<typeof listPatientEligibilities>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPatientEligibilities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Patient Eligibilities
 */

export function useListPatientEligibilities<
  TData = Awaited<ReturnType<typeof listPatientEligibilities>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPatientEligibilities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListPatientEligibilitiesQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Full detail view of a PA case, including the pending question.

``record_id`` is our internal ``DosespotPriorAuthRecord.id`` (UUID7),
not DoseSpot's integer case id — this keeps the copilot URL scheme
stable across patient re-syncs. The handler resolves to the DoseSpot
case id on the server side. Every persisted record has a case
number, so that resolution never fails on an unset case id.

Returns 404 when the record is unknown.
 * @summary Get Prior Auth Details
 */
export const getPriorAuthDetails = (
  recordId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PriorAuthCaseDetailsT>> => {
  return axios.default.get(
    `/greenfield/dosespot/prior_auths/${recordId}/details`,
    options,
  );
};

export const getGetPriorAuthDetailsQueryKey = (recordId?: string) => {
  return [`/greenfield/dosespot/prior_auths/${recordId}/details`] as const;
};

export const getGetPriorAuthDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPriorAuthDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  recordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPriorAuthDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPriorAuthDetailsQueryKey(recordId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPriorAuthDetails>>
  > = ({ signal }) =>
    getPriorAuthDetails(recordId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!recordId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPriorAuthDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPriorAuthDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPriorAuthDetails>>
>;
export type GetPriorAuthDetailsQueryError = AxiosError<HTTPValidationError>;

export function useGetPriorAuthDetails<
  TData = Awaited<ReturnType<typeof getPriorAuthDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  recordId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPriorAuthDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriorAuthDetails>>,
          TError,
          Awaited<ReturnType<typeof getPriorAuthDetails>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPriorAuthDetails<
  TData = Awaited<ReturnType<typeof getPriorAuthDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  recordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPriorAuthDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriorAuthDetails>>,
          TError,
          Awaited<ReturnType<typeof getPriorAuthDetails>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPriorAuthDetails<
  TData = Awaited<ReturnType<typeof getPriorAuthDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  recordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPriorAuthDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Prior Auth Details
 */

export function useGetPriorAuthDetails<
  TData = Awaited<ReturnType<typeof getPriorAuthDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  recordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPriorAuthDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPriorAuthDetailsQueryOptions(recordId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Perform an action on a PA case.

Accepts a discriminated-union body whose ``action`` field selects one
of: ``answer_question``, ``submit``, ``upload_attachment``, ``cancel``,
``appeal``, ``deny``. Used by the copilot proposed-action form so the
clinician can review and submit in one step.

``case_id`` is the DoseSpot ``PriorAuthorizationCaseId`` (integer), not
our internal record UUID — the proposed-action payloads carry
``priorAuthId`` which is this DoseSpot case id, so the wire shape
matches what the tool-executor already has on hand.
 * @summary Prior Auth Action
 */
export const priorAuthAction = (
  caseId: number,
  priorAuthActionBody: PriorAuthActionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PriorAuthActionResponseT>> => {
  return axios.default.post(
    `/greenfield/dosespot/prior_auths/${caseId}/action`,
    priorAuthActionBody,
    options,
  );
};

export const getPriorAuthActionMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof priorAuthAction>>,
    TError,
    { caseId: number; data: PriorAuthActionBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof priorAuthAction>>,
  TError,
  { caseId: number; data: PriorAuthActionBody },
  TContext
> => {
  const mutationKey = ["priorAuthAction"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof priorAuthAction>>,
    { caseId: number; data: PriorAuthActionBody }
  > = (props) => {
    const { caseId, data } = props ?? {};

    return priorAuthAction(caseId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PriorAuthActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof priorAuthAction>>
>;
export type PriorAuthActionMutationBody = PriorAuthActionBody;
export type PriorAuthActionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Prior Auth Action
 */
export const usePriorAuthAction = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof priorAuthAction>>,
      TError,
      { caseId: number; data: PriorAuthActionBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof priorAuthAction>>,
  TError,
  { caseId: number; data: PriorAuthActionBody },
  TContext
> => {
  const mutationOptions = getPriorAuthActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Stream a PA attachment back to the browser as a file download.

Proxies DoseSpot's binary endpoint through cortex so the browser can
use our normal Firebase auth instead of needing a DoseSpot bearer
token. Returns ``application/octet-stream`` because DoseSpot doesn't
expose a content-type for attachments and we don't trust filenames
enough to guess; the caller already knows the filename from the
case detail and can pick the right MIME on the client side.

404 when the case or attachment is unknown to DoseSpot — surfaced as
a ``ValueError`` from ``download_attachment`` and translated below.
 * @summary Download Prior Auth Attachment
 */
export const downloadPriorAuthAttachment = (
  caseId: number,
  attachmentId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.get(
    `/greenfield/dosespot/prior_auths/${caseId}/attachments/${attachmentId}/download`,
    options,
  );
};

export const getDownloadPriorAuthAttachmentQueryKey = (
  caseId?: number,
  attachmentId?: number,
) => {
  return [
    `/greenfield/dosespot/prior_auths/${caseId}/attachments/${attachmentId}/download`,
  ] as const;
};

export const getDownloadPriorAuthAttachmentQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
  TError = AxiosError<HTTPValidationError>,
>(
  caseId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadPriorAuthAttachmentQueryKey(caseId, attachmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadPriorAuthAttachment>>
  > = ({ signal }) =>
    downloadPriorAuthAttachment(caseId, attachmentId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(caseId && attachmentId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadPriorAuthAttachmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadPriorAuthAttachment>>
>;
export type DownloadPriorAuthAttachmentQueryError =
  AxiosError<HTTPValidationError>;

export function useDownloadPriorAuthAttachment<
  TData = Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
  TError = AxiosError<HTTPValidationError>,
>(
  caseId: number,
  attachmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadPriorAuthAttachment>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadPriorAuthAttachment<
  TData = Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
  TError = AxiosError<HTTPValidationError>,
>(
  caseId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadPriorAuthAttachment>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadPriorAuthAttachment<
  TData = Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
  TError = AxiosError<HTTPValidationError>,
>(
  caseId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download Prior Auth Attachment
 */

export function useDownloadPriorAuthAttachment<
  TData = Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
  TError = AxiosError<HTTPValidationError>,
>(
  caseId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadPriorAuthAttachment>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadPriorAuthAttachmentQueryOptions(
    caseId,
    attachmentId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete a previously-uploaded PA attachment.

Real DoseSpot is hazy on whether DELETE is allowed once the case has
moved into a payer-owned status (e.g. ``Pending``). We just forward the
call and let DoseSpot decide; on a 4xx we surface a 422 to the browser
so the wizard can show a "couldn't remove this one" toast without
pretending the attachment is gone.
 * @summary Delete Prior Auth Attachment
 */
export const deletePriorAuthAttachment = (
  caseId: number,
  attachmentId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeletePriorAuthAttachment200>> => {
  return axios.default.delete(
    `/greenfield/dosespot/prior_auths/${caseId}/attachments/${attachmentId}`,
    options,
  );
};

export const getDeletePriorAuthAttachmentMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePriorAuthAttachment>>,
    TError,
    { caseId: number; attachmentId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePriorAuthAttachment>>,
  TError,
  { caseId: number; attachmentId: number },
  TContext
> => {
  const mutationKey = ["deletePriorAuthAttachment"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePriorAuthAttachment>>,
    { caseId: number; attachmentId: number }
  > = (props) => {
    const { caseId, attachmentId } = props ?? {};

    return deletePriorAuthAttachment(caseId, attachmentId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePriorAuthAttachmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePriorAuthAttachment>>
>;

export type DeletePriorAuthAttachmentMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Delete Prior Auth Attachment
 */
export const useDeletePriorAuthAttachment = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePriorAuthAttachment>>,
      TError,
      { caseId: number; attachmentId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePriorAuthAttachment>>,
  TError,
  { caseId: number; attachmentId: number },
  TContext
> => {
  const mutationOptions = getDeletePriorAuthAttachmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Force an immediate PA poll + processor pass.

This is the manual equivalent of the scheduled ``poll_pending_prior_auths``
+ ``process_all_dirty_rows`` jobs wired in ``proxy_main.py``. It exists
so a clinician (or a dev poking the fake DoseSpot) can click "Sync" on
the Prior Auths tab and see CareState reflect the latest case status
without waiting for the next scheduler tick.

Scope is global (not per-patient) for the same reason the scheduler is
global: the poller works from our SQL ``fetch_pending`` view, and the
processor drains every dirty row — limiting either to a single patient
would just move that filtering logic into the handler for no benefit.
The work is bounded by ``fetch_pending``'s 500-row ceiling.
 * @summary Sync Prior Auths
 */
export const syncPriorAuths = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PriorAuthSyncResponseT>> => {
  return axios.default.post(
    `/greenfield/dosespot/prior_auths/sync`,
    undefined,
    options,
  );
};

export const getSyncPriorAuthsMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncPriorAuths>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncPriorAuths>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["syncPriorAuths"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncPriorAuths>>,
    void
  > = () => {
    return syncPriorAuths(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncPriorAuthsMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncPriorAuths>>
>;

export type SyncPriorAuthsMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Sync Prior Auths
 */
export const useSyncPriorAuths = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof syncPriorAuths>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof syncPriorAuths>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSyncPriorAuthsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Fetch Employee Roll
 */
export const fetchEmployeeRoll = (
  level: APILevelT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchEmployeeRollReplyT>> => {
  return axios.default.get(`/greenfield/${level}/employees`, options);
};

export const getFetchEmployeeRollQueryKey = (level?: APILevelT) => {
  return [`/greenfield/${level}/employees`] as const;
};

export const getFetchEmployeeRollQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchEmployeeRoll>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmployeeRoll>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchEmployeeRollQueryKey(level);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchEmployeeRoll>>
  > = ({ signal }) => fetchEmployeeRoll(level, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!level,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchEmployeeRoll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchEmployeeRollQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchEmployeeRoll>>
>;
export type FetchEmployeeRollQueryError = AxiosError<HTTPValidationError>;

export function useFetchEmployeeRoll<
  TData = Awaited<ReturnType<typeof fetchEmployeeRoll>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmployeeRoll>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchEmployeeRoll>>,
          TError,
          Awaited<ReturnType<typeof fetchEmployeeRoll>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchEmployeeRoll<
  TData = Awaited<ReturnType<typeof fetchEmployeeRoll>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmployeeRoll>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchEmployeeRoll>>,
          TError,
          Awaited<ReturnType<typeof fetchEmployeeRoll>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchEmployeeRoll<
  TData = Awaited<ReturnType<typeof fetchEmployeeRoll>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmployeeRoll>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Employee Roll
 */

export function useFetchEmployeeRoll<
  TData = Awaited<ReturnType<typeof fetchEmployeeRoll>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmployeeRoll>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchEmployeeRollQueryOptions(level, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Employee From Roll
 */
export const updateEmployeeFromRoll = (
  level: APILevelT,
  userId: string,
  updateEmployeeFromRollRequestT: UpdateEmployeeFromRollRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UpdateEmployeeFromRollReplyT>> => {
  return axios.default.put(
    `/greenfield/${level}/employees/${userId}`,
    updateEmployeeFromRollRequestT,
    options,
  );
};

export const getUpdateEmployeeFromRollMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeeFromRoll>>,
    TError,
    { level: APILevelT; userId: string; data: UpdateEmployeeFromRollRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmployeeFromRoll>>,
  TError,
  { level: APILevelT; userId: string; data: UpdateEmployeeFromRollRequestT },
  TContext
> => {
  const mutationKey = ["updateEmployeeFromRoll"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmployeeFromRoll>>,
    { level: APILevelT; userId: string; data: UpdateEmployeeFromRollRequestT }
  > = (props) => {
    const { level, userId, data } = props ?? {};

    return updateEmployeeFromRoll(level, userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmployeeFromRollMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmployeeFromRoll>>
>;
export type UpdateEmployeeFromRollMutationBody = UpdateEmployeeFromRollRequestT;
export type UpdateEmployeeFromRollMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Update Employee From Roll
 */
export const useUpdateEmployeeFromRoll = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmployeeFromRoll>>,
      TError,
      {
        level: APILevelT;
        userId: string;
        data: UpdateEmployeeFromRollRequestT;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeeFromRoll>>,
  TError,
  { level: APILevelT; userId: string; data: UpdateEmployeeFromRollRequestT },
  TContext
> => {
  const mutationOptions = getUpdateEmployeeFromRollMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Fetch Identification
 */
export const fetchIdentification = (
  level: APILevelT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchIdentificationReplyT>> => {
  return axios.default.get(`/greenfield/${level}/me/identification`, options);
};

export const getFetchIdentificationQueryKey = (level?: APILevelT) => {
  return [`/greenfield/${level}/me/identification`] as const;
};

export const getFetchIdentificationQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchIdentification>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchIdentification>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchIdentificationQueryKey(level);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchIdentification>>
  > = ({ signal }) => fetchIdentification(level, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!level,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchIdentification>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchIdentificationQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchIdentification>>
>;
export type FetchIdentificationQueryError = AxiosError<HTTPValidationError>;

export function useFetchIdentification<
  TData = Awaited<ReturnType<typeof fetchIdentification>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchIdentification>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchIdentification>>,
          TError,
          Awaited<ReturnType<typeof fetchIdentification>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchIdentification<
  TData = Awaited<ReturnType<typeof fetchIdentification>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchIdentification>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchIdentification>>,
          TError,
          Awaited<ReturnType<typeof fetchIdentification>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchIdentification<
  TData = Awaited<ReturnType<typeof fetchIdentification>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchIdentification>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Identification
 */

export function useFetchIdentification<
  TData = Awaited<ReturnType<typeof fetchIdentification>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchIdentification>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchIdentificationQueryOptions(level, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetch Employee Record
 */
export const fetchEmployeeRecord = (
  level: APILevelT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchEmployeeRecordReplyT>> => {
  return axios.default.get(`/greenfield/${level}/me/employee_record`, options);
};

export const getFetchEmployeeRecordQueryKey = (level?: APILevelT) => {
  return [`/greenfield/${level}/me/employee_record`] as const;
};

export const getFetchEmployeeRecordQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchEmployeeRecord>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmployeeRecord>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchEmployeeRecordQueryKey(level);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchEmployeeRecord>>
  > = ({ signal }) => fetchEmployeeRecord(level, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!level,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchEmployeeRecord>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchEmployeeRecordQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchEmployeeRecord>>
>;
export type FetchEmployeeRecordQueryError = AxiosError<HTTPValidationError>;

export function useFetchEmployeeRecord<
  TData = Awaited<ReturnType<typeof fetchEmployeeRecord>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmployeeRecord>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchEmployeeRecord>>,
          TError,
          Awaited<ReturnType<typeof fetchEmployeeRecord>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchEmployeeRecord<
  TData = Awaited<ReturnType<typeof fetchEmployeeRecord>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmployeeRecord>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchEmployeeRecord>>,
          TError,
          Awaited<ReturnType<typeof fetchEmployeeRecord>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchEmployeeRecord<
  TData = Awaited<ReturnType<typeof fetchEmployeeRecord>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmployeeRecord>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Employee Record
 */

export function useFetchEmployeeRecord<
  TData = Awaited<ReturnType<typeof fetchEmployeeRecord>>,
  TError = AxiosError<HTTPValidationError>,
>(
  level: APILevelT,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEmployeeRecord>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchEmployeeRecordQueryOptions(level, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Employee Record
 */
export const updateEmployeeRecord = (
  level: APILevelT,
  updateEmployeeRecordRequestT: UpdateEmployeeRecordRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UpdateEmployeeRecordReplyT>> => {
  return axios.default.put(
    `/greenfield/${level}/me/employee_record`,
    updateEmployeeRecordRequestT,
    options,
  );
};

export const getUpdateEmployeeRecordMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeeRecord>>,
    TError,
    { level: APILevelT; data: UpdateEmployeeRecordRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmployeeRecord>>,
  TError,
  { level: APILevelT; data: UpdateEmployeeRecordRequestT },
  TContext
> => {
  const mutationKey = ["updateEmployeeRecord"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmployeeRecord>>,
    { level: APILevelT; data: UpdateEmployeeRecordRequestT }
  > = (props) => {
    const { level, data } = props ?? {};

    return updateEmployeeRecord(level, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmployeeRecordMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmployeeRecord>>
>;
export type UpdateEmployeeRecordMutationBody = UpdateEmployeeRecordRequestT;
export type UpdateEmployeeRecordMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Employee Record
 */
export const useUpdateEmployeeRecord = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmployeeRecord>>,
      TError,
      { level: APILevelT; data: UpdateEmployeeRecordRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeeRecord>>,
  TError,
  { level: APILevelT; data: UpdateEmployeeRecordRequestT },
  TContext
> => {
  const mutationOptions = getUpdateEmployeeRecordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Fetch the full Personal Health Record (PHR) for the current user.

Returns a structured representation of all PHR tables including:
- Medications
- Conditions
- Labs
# - Diagnostics (not a part of the PHR yet)
- Procedures
- Vitals
- Notes

Returns:
    FetchPHRResponseT containing the full FrontendPHRT
 * @summary Fetch Phr
 */
export const fetchPhr = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchPHRResponseT>> => {
  return axios.default.get(`/greenfield/care/${userId}/phr`, options);
};

export const getFetchPhrQueryKey = (userId?: string) => {
  return [`/greenfield/care/${userId}/phr`] as const;
};

export const getFetchPhrQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchPhr>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchPhr>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFetchPhrQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchPhr>>> = ({
    signal,
  }) => fetchPhr(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof fetchPhr>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type FetchPhrQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchPhr>>
>;
export type FetchPhrQueryError = AxiosError<HTTPValidationError>;

export function useFetchPhr<
  TData = Awaited<ReturnType<typeof fetchPhr>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchPhr>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchPhr>>,
          TError,
          Awaited<ReturnType<typeof fetchPhr>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchPhr<
  TData = Awaited<ReturnType<typeof fetchPhr>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchPhr>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchPhr>>,
          TError,
          Awaited<ReturnType<typeof fetchPhr>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchPhr<
  TData = Awaited<ReturnType<typeof fetchPhr>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchPhr>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Phr
 */

export function useFetchPhr<
  TData = Awaited<ReturnType<typeof fetchPhr>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchPhr>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchPhrQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Validate the staging input.

Providing this API makes sure the openapi schema includes a definition of HostageStagingInputT.
 * @summary Validate Staging Input
 */
export const validateStagingInput = (
  hostageStagingInputT: HostageStagingInputT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.post(
    `/greenfield/care/validate_staging_input`,
    hostageStagingInputT,
    {
      ...options,
    },
  );
};

export const getValidateStagingInputMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateStagingInput>>,
    TError,
    { data: HostageStagingInputT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateStagingInput>>,
  TError,
  { data: HostageStagingInputT },
  TContext
> => {
  const mutationKey = ["validateStagingInput"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateStagingInput>>,
    { data: HostageStagingInputT }
  > = (props) => {
    const { data } = props ?? {};

    return validateStagingInput(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateStagingInputMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateStagingInput>>
>;
export type ValidateStagingInputMutationBody = HostageStagingInputT;
export type ValidateStagingInputMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Validate Staging Input
 */
export const useValidateStagingInput = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateStagingInput>>,
      TError,
      { data: HostageStagingInputT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validateStagingInput>>,
  TError,
  { data: HostageStagingInputT },
  TContext
> => {
  const mutationOptions = getValidateStagingInputMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Host
 */
export const host = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.post(
    `/greenfield/care/${userId}/hostage/chat`,
    undefined,
    options,
  );
};

export const getHostMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof host>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof host>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ["host"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof host>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return host(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostMutationResult = NonNullable<Awaited<ReturnType<typeof host>>>;

export type HostMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Host
 */
export const useHost = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof host>>,
      TError,
      { userId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof host>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getHostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Fetch the list of conversations for a patient.

Returns all non-abandoned conversations for the specified user,
ordered by last interaction time (most recent first).

Args:
    user_id: The patient's user ID

Returns:
    FetchConversationsResponseT containing the list of conversations
 * @summary Fetch Conversations
 */
export const fetchConversations = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchConversationsResponseT>> => {
  return axios.default.get(
    `/greenfield/care/${userId}/chat/conversations`,
    options,
  );
};

export const getFetchConversationsQueryKey = (userId?: string) => {
  return [`/greenfield/care/${userId}/chat/conversations`] as const;
};

export const getFetchConversationsQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchConversations>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchConversations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchConversationsQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchConversations>>
  > = ({ signal }) => fetchConversations(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchConversations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchConversationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchConversations>>
>;
export type FetchConversationsQueryError = AxiosError<HTTPValidationError>;

export function useFetchConversations<
  TData = Awaited<ReturnType<typeof fetchConversations>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchConversations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchConversations>>,
          TError,
          Awaited<ReturnType<typeof fetchConversations>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchConversations<
  TData = Awaited<ReturnType<typeof fetchConversations>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchConversations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchConversations>>,
          TError,
          Awaited<ReturnType<typeof fetchConversations>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchConversations<
  TData = Awaited<ReturnType<typeof fetchConversations>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchConversations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Conversations
 */

export function useFetchConversations<
  TData = Awaited<ReturnType<typeof fetchConversations>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchConversations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchConversationsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetch chat messages for a specific conversation.

Supports pagination via before/after message IDs:
- Use `before` to fetch messages older than the specified message ID
- Use `after` to fetch messages newer than the specified message ID

Args:
    user_id: The patient's user ID
    conversation_id: The conversation ID to fetch messages from
    before: Optional message ID to fetch messages before (older than)
    after: Optional message ID to fetch messages after (newer than)

Returns:
    FetchChatResponseT containing the list of messages and conversation ID
 * @summary Fetch Chat
 */
export const fetchChat = (
  userId: string,
  conversationId: string,
  params?: FetchChatParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchChatResponseT>> => {
  return axios.default.get(
    `/greenfield/care/${userId}/chat/${conversationId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getFetchChatQueryKey = (
  userId?: string,
  conversationId?: string,
  params?: FetchChatParams,
) => {
  return [
    `/greenfield/care/${userId}/chat/${conversationId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFetchChatQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchChat>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  conversationId: string,
  params?: FetchChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchChat>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFetchChatQueryKey(userId, conversationId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchChat>>> = ({
    signal,
  }) => fetchChat(userId, conversationId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && conversationId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof fetchChat>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type FetchChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchChat>>
>;
export type FetchChatQueryError = AxiosError<HTTPValidationError>;

export function useFetchChat<
  TData = Awaited<ReturnType<typeof fetchChat>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  conversationId: string,
  params: undefined | FetchChatParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchChat>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchChat>>,
          TError,
          Awaited<ReturnType<typeof fetchChat>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchChat<
  TData = Awaited<ReturnType<typeof fetchChat>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  conversationId: string,
  params?: FetchChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchChat>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchChat>>,
          TError,
          Awaited<ReturnType<typeof fetchChat>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchChat<
  TData = Awaited<ReturnType<typeof fetchChat>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  conversationId: string,
  params?: FetchChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchChat>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Chat
 */

export function useFetchChat<
  TData = Awaited<ReturnType<typeof fetchChat>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  conversationId: string,
  params?: FetchChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchChat>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchChatQueryOptions(
    userId,
    conversationId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetch chat messages for the primary conversation.

If no conversation ID is specified, this endpoint returns messages from
the user's primary conversation.

Supports pagination via before/after message IDs:
- Use `before` to fetch messages older than the specified message ID
- Use `after` to fetch messages newer than the specified message ID

Args:
    user_id: The patient's user ID
    before: Optional message ID to fetch messages before (older than)
    after: Optional message ID to fetch messages after (newer than)

Returns:
    FetchChatResponseT containing the list of messages and conversation ID

Raises:
    ValueError: If the user has no primary conversation
 * @summary Fetch Primary Chat
 */
export const fetchPrimaryChat = (
  userId: string,
  params?: FetchPrimaryChatParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchChatResponseT>> => {
  return axios.default.get(`/greenfield/care/${userId}/chat`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getFetchPrimaryChatQueryKey = (
  userId?: string,
  params?: FetchPrimaryChatParams,
) => {
  return [
    `/greenfield/care/${userId}/chat`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFetchPrimaryChatQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchPrimaryChat>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchPrimaryChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchPrimaryChat>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchPrimaryChatQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchPrimaryChat>>
  > = ({ signal }) =>
    fetchPrimaryChat(userId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchPrimaryChat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchPrimaryChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchPrimaryChat>>
>;
export type FetchPrimaryChatQueryError = AxiosError<HTTPValidationError>;

export function useFetchPrimaryChat<
  TData = Awaited<ReturnType<typeof fetchPrimaryChat>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params: undefined | FetchPrimaryChatParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchPrimaryChat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchPrimaryChat>>,
          TError,
          Awaited<ReturnType<typeof fetchPrimaryChat>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchPrimaryChat<
  TData = Awaited<ReturnType<typeof fetchPrimaryChat>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchPrimaryChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchPrimaryChat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchPrimaryChat>>,
          TError,
          Awaited<ReturnType<typeof fetchPrimaryChat>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchPrimaryChat<
  TData = Awaited<ReturnType<typeof fetchPrimaryChat>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchPrimaryChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchPrimaryChat>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Primary Chat
 */

export function useFetchPrimaryChat<
  TData = Awaited<ReturnType<typeof fetchPrimaryChat>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchPrimaryChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchPrimaryChat>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchPrimaryChatQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetch a presigned S3 URL for a specific variant of a patient's file attachment.

Clinicians can request a specific variant (dimensions and zoom type for images,
page truncation for documents).
Returns null if the variant is not meaningful for the content or is unknown to Lotus.

Args:
    user_id: The patient's user ID
    attachment_id: The attachment ID
    args: The variant request

Returns:
    FetchViewUrlForVariantReplyT with the presigned URL if the variant
    is applicable, or with view_url=None if the variant is not meaningful
    for the content type.
 * @summary Fetch Attachment Variant
 */
export const fetchAttachmentVariant = (
  userId: string,
  attachmentId: string,
  fetchAttachmentVariantRequestT: FetchAttachmentVariantRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchViewUrlForVariantReplyT>> => {
  return axios.default.post(
    `/greenfield/care/${userId}/chat/attachment/${attachmentId}/variant`,
    fetchAttachmentVariantRequestT,
    options,
  );
};

export const getFetchAttachmentVariantMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof fetchAttachmentVariant>>,
    TError,
    {
      userId: string;
      attachmentId: string;
      data: FetchAttachmentVariantRequestT;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof fetchAttachmentVariant>>,
  TError,
  {
    userId: string;
    attachmentId: string;
    data: FetchAttachmentVariantRequestT;
  },
  TContext
> => {
  const mutationKey = ["fetchAttachmentVariant"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof fetchAttachmentVariant>>,
    {
      userId: string;
      attachmentId: string;
      data: FetchAttachmentVariantRequestT;
    }
  > = (props) => {
    const { userId, attachmentId, data } = props ?? {};

    return fetchAttachmentVariant(userId, attachmentId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FetchAttachmentVariantMutationResult = NonNullable<
  Awaited<ReturnType<typeof fetchAttachmentVariant>>
>;
export type FetchAttachmentVariantMutationBody = FetchAttachmentVariantRequestT;
export type FetchAttachmentVariantMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Fetch Attachment Variant
 */
export const useFetchAttachmentVariant = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof fetchAttachmentVariant>>,
      TError,
      {
        userId: string;
        attachmentId: string;
        data: FetchAttachmentVariantRequestT;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof fetchAttachmentVariant>>,
  TError,
  {
    userId: string;
    attachmentId: string;
    data: FetchAttachmentVariantRequestT;
  },
  TContext
> => {
  const mutationOptions = getFetchAttachmentVariantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Fetch patient demographic information for the specified user.

All fields are derived from the dossier — the single source of truth used
by insurance discovery, lab-order billing, and the rest of the care
pipeline.
 * @summary Fetch Patient Info
 */
export const fetchPatientInfo = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchPatientInfoResponseT>> => {
  return axios.default.get(`/greenfield/care/${userId}/patient`, options);
};

export const getFetchPatientInfoQueryKey = (userId?: string) => {
  return [`/greenfield/care/${userId}/patient`] as const;
};

export const getFetchPatientInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchPatientInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchPatientInfoQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchPatientInfo>>
  > = ({ signal }) => fetchPatientInfo(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchPatientInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchPatientInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchPatientInfo>>
>;
export type FetchPatientInfoQueryError = AxiosError<HTTPValidationError>;

export function useFetchPatientInfo<
  TData = Awaited<ReturnType<typeof fetchPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchPatientInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchPatientInfo>>,
          TError,
          Awaited<ReturnType<typeof fetchPatientInfo>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchPatientInfo<
  TData = Awaited<ReturnType<typeof fetchPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchPatientInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchPatientInfo>>,
          TError,
          Awaited<ReturnType<typeof fetchPatientInfo>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchPatientInfo<
  TData = Awaited<ReturnType<typeof fetchPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchPatientInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Patient Info
 */

export function useFetchPatientInfo<
  TData = Awaited<ReturnType<typeof fetchPatientInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchPatientInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchPatientInfoQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Patients
 */
export const searchPatients = (
  careSearchPatientsRequestT: CareSearchPatientsRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CareSearchPatientsResponseT>> => {
  return axios.default.post(
    `/greenfield/care/patients/search`,
    careSearchPatientsRequestT,
    options,
  );
};

export const getSearchPatientsMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchPatients>>,
    TError,
    { data: CareSearchPatientsRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchPatients>>,
  TError,
  { data: CareSearchPatientsRequestT },
  TContext
> => {
  const mutationKey = ["searchPatients"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchPatients>>,
    { data: CareSearchPatientsRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return searchPatients(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchPatientsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchPatients>>
>;
export type SearchPatientsMutationBody = CareSearchPatientsRequestT;
export type SearchPatientsMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Search Patients
 */
export const useSearchPatients = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchPatients>>,
      TError,
      { data: CareSearchPatientsRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchPatients>>,
  TError,
  { data: CareSearchPatientsRequestT },
  TContext
> => {
  const mutationOptions = getSearchPatientsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Hydrate Patients
 */
export const hydratePatients = (
  careHydratePatientsRequestT: CareHydratePatientsRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CareHydratePatientsResponseT>> => {
  return axios.default.post(
    `/greenfield/care/patients/search/hydrate`,
    careHydratePatientsRequestT,
    options,
  );
};

export const getHydratePatientsMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hydratePatients>>,
    TError,
    { data: CareHydratePatientsRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hydratePatients>>,
  TError,
  { data: CareHydratePatientsRequestT },
  TContext
> => {
  const mutationKey = ["hydratePatients"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hydratePatients>>,
    { data: CareHydratePatientsRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return hydratePatients(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HydratePatientsMutationResult = NonNullable<
  Awaited<ReturnType<typeof hydratePatients>>
>;
export type HydratePatientsMutationBody = CareHydratePatientsRequestT;
export type HydratePatientsMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Hydrate Patients
 */
export const useHydratePatients = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof hydratePatients>>,
      TError,
      { data: CareHydratePatientsRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof hydratePatients>>,
  TError,
  { data: CareHydratePatientsRequestT },
  TContext
> => {
  const mutationOptions = getHydratePatientsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Suggest the most urgent actionable patient that currently has no viewers.

This endpoint uses a mutex (ActiveLock) to ensure that two clinicians
cannot be suggested the same patient simultaneously. When a patient is
suggested, a "view claim" is automatically created for the requesting
clinician.

Returns None if no actionable patients are available (either there are
no actionable patients, or all actionable patients already have viewers).
 * @summary Suggest Patient Endpoint
 */
export const suggestPatientEndpoint = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SuggestPatientResponseT>> => {
  return axios.default.post(
    `/greenfield/care/patients/suggest`,
    undefined,
    options,
  );
};

export const getSuggestPatientEndpointMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof suggestPatientEndpoint>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof suggestPatientEndpoint>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["suggestPatientEndpoint"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof suggestPatientEndpoint>>,
    void
  > = () => {
    return suggestPatientEndpoint(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SuggestPatientEndpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof suggestPatientEndpoint>>
>;

export type SuggestPatientEndpointMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Suggest Patient Endpoint
 */
export const useSuggestPatientEndpoint = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof suggestPatientEndpoint>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof suggestPatientEndpoint>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSuggestPatientEndpointMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Fetch the current care state snapshot for a patient.

Returns the full care state including all tables (patients, problems,
requests, internal notes, follow-ups) along with a cursor for fetching
subsequent events.

Also records the clinician as a viewer of this patient.
 * @summary Fetch State
 */
export const fetchState = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchStateResponseT>> => {
  return axios.default.get(`/greenfield/care/${userId}/state`, options);
};

export const getFetchStateQueryKey = (userId?: string) => {
  return [`/greenfield/care/${userId}/state`] as const;
};

export const getFetchStateQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchState>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchState>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFetchStateQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchState>>> = ({
    signal,
  }) => fetchState(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchState>>
>;
export type FetchStateQueryError = AxiosError<HTTPValidationError>;

export function useFetchState<
  TData = Awaited<ReturnType<typeof fetchState>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchState>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchState>>,
          TError,
          Awaited<ReturnType<typeof fetchState>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchState<
  TData = Awaited<ReturnType<typeof fetchState>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchState>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchState>>,
          TError,
          Awaited<ReturnType<typeof fetchState>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchState<
  TData = Awaited<ReturnType<typeof fetchState>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchState>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch State
 */

export function useFetchState<
  TData = Awaited<ReturnType<typeof fetchState>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchState>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchStateQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Apply updates to the care state.

Accepts a dictionary of updates keyed by client-provided update IDs.
Returns a dictionary of replies indicating whether each update was
accepted or rejected.
 * @summary Update State
 */
export const updateState = (
  userId: string,
  updateStateRequestT: UpdateStateRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UpdateStateResponseT>> => {
  return axios.default.post(
    `/greenfield/care/${userId}/state/update`,
    updateStateRequestT,
    options,
  );
};

export const getUpdateStateMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateState>>,
    TError,
    { userId: string; data: UpdateStateRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateState>>,
  TError,
  { userId: string; data: UpdateStateRequestT },
  TContext
> => {
  const mutationKey = ["updateState"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateState>>,
    { userId: string; data: UpdateStateRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateState(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateState>>
>;
export type UpdateStateMutationBody = UpdateStateRequestT;
export type UpdateStateMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update State
 */
export const useUpdateState = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateState>>,
      TError,
      { userId: string; data: UpdateStateRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateState>>,
  TError,
  { userId: string; data: UpdateStateRequestT },
  TContext
> => {
  const mutationOptions = getUpdateStateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Stream care state events as they come down.

Returns ping events when no data is available, and a disconnect
event before closing.
 * @summary Stream State Events
 */
export const streamStateEvents = (
  userId: string,
  params: StreamStateEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StreamStateEvents200Item[]>> => {
  return axios.default.get(
    `/greenfield/care/${userId}/state/events/streaming`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getStreamStateEventsQueryKey = (
  userId?: string,
  params?: StreamStateEventsParams,
) => {
  return [
    `/greenfield/care/${userId}/state/events/streaming`,
    ...(params ? [params] : []),
  ] as const;
};

export const getStreamStateEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof streamStateEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params: StreamStateEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamStateEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStreamStateEventsQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof streamStateEvents>>
  > = ({ signal }) =>
    streamStateEvents(userId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof streamStateEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StreamStateEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamStateEvents>>
>;
export type StreamStateEventsQueryError = AxiosError<HTTPValidationError>;

export function useStreamStateEvents<
  TData = Awaited<ReturnType<typeof streamStateEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params: StreamStateEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamStateEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamStateEvents>>,
          TError,
          Awaited<ReturnType<typeof streamStateEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStreamStateEvents<
  TData = Awaited<ReturnType<typeof streamStateEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params: StreamStateEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamStateEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamStateEvents>>,
          TError,
          Awaited<ReturnType<typeof streamStateEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStreamStateEvents<
  TData = Awaited<ReturnType<typeof streamStateEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params: StreamStateEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamStateEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Stream State Events
 */

export function useStreamStateEvents<
  TData = Awaited<ReturnType<typeof streamStateEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params: StreamStateEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamStateEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getStreamStateEventsQueryOptions(
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetch the care state timeline for a patient.

Returns a paginated list of human-readable timeline events describing
changes to the care state, such as "<identity> updated <row> in <table>".
 * @summary Fetch Timeline
 */
export const fetchTimeline = (
  userId: string,
  params?: FetchTimelineParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchTimelineResponseT>> => {
  return axios.default.get(`/greenfield/care/${userId}/timeline`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getFetchTimelineQueryKey = (
  userId?: string,
  params?: FetchTimelineParams,
) => {
  return [
    `/greenfield/care/${userId}/timeline`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFetchTimelineQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchTimeline>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchTimelineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchTimeline>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchTimelineQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchTimeline>>> = ({
    signal,
  }) => fetchTimeline(userId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchTimeline>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchTimelineQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchTimeline>>
>;
export type FetchTimelineQueryError = AxiosError<HTTPValidationError>;

export function useFetchTimeline<
  TData = Awaited<ReturnType<typeof fetchTimeline>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params: undefined | FetchTimelineParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchTimeline>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchTimeline>>,
          TError,
          Awaited<ReturnType<typeof fetchTimeline>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchTimeline<
  TData = Awaited<ReturnType<typeof fetchTimeline>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchTimelineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchTimeline>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchTimeline>>,
          TError,
          Awaited<ReturnType<typeof fetchTimeline>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchTimeline<
  TData = Awaited<ReturnType<typeof fetchTimeline>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchTimelineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchTimeline>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Timeline
 */

export function useFetchTimeline<
  TData = Awaited<ReturnType<typeof fetchTimeline>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchTimelineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchTimeline>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchTimelineQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for available lab tests.

Returns a list of lab tests that can be ordered based on the
provided search criteria. Results include AOE question schemas
when applicable.
 * @summary Search Lab Tests
 */
export const searchLabTests = (
  searchLabTestsRequestT: SearchLabTestsRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SearchLabTestsResponseT>> => {
  return axios.default.post(
    `/greenfield/care/labs/search`,
    searchLabTestsRequestT,
    options,
  );
};

export const getSearchLabTestsMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchLabTests>>,
    TError,
    { data: SearchLabTestsRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchLabTests>>,
  TError,
  { data: SearchLabTestsRequestT },
  TContext
> => {
  const mutationKey = ["searchLabTests"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchLabTests>>,
    { data: SearchLabTestsRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return searchLabTests(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchLabTestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchLabTests>>
>;
export type SearchLabTestsMutationBody = SearchLabTestsRequestT;
export type SearchLabTestsMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Search Lab Tests
 */
export const useSearchLabTests = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchLabTests>>,
      TError,
      { data: SearchLabTestsRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchLabTests>>,
  TError,
  { data: SearchLabTestsRequestT },
  TContext
> => {
  const mutationOptions = getSearchLabTestsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Submit a new lab order for a patient.

Creates an order for the specified lab test with the provided
AOE answers and order options. The order is submitted to the
lab testing provider (Vital) and persisted locally.
 * @summary Submit Lab Order
 */
export const submitLabOrder = (
  userId: string,
  submitLabOrderRequestT: SubmitLabOrderRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SubmitLabOrderResponseT>> => {
  return axios.default.post(
    `/greenfield/care/${userId}/labs/orders`,
    submitLabOrderRequestT,
    options,
  );
};

export const getSubmitLabOrderMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitLabOrder>>,
    TError,
    { userId: string; data: SubmitLabOrderRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitLabOrder>>,
  TError,
  { userId: string; data: SubmitLabOrderRequestT },
  TContext
> => {
  const mutationKey = ["submitLabOrder"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitLabOrder>>,
    { userId: string; data: SubmitLabOrderRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return submitLabOrder(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitLabOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitLabOrder>>
>;
export type SubmitLabOrderMutationBody = SubmitLabOrderRequestT;
export type SubmitLabOrderMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Submit Lab Order
 */
export const useSubmitLabOrder = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitLabOrder>>,
      TError,
      { userId: string; data: SubmitLabOrderRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitLabOrder>>,
  TError,
  { userId: string; data: SubmitLabOrderRequestT },
  TContext
> => {
  const mutationOptions = getSubmitLabOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Fetch lab orders for a patient.

Returns a paginated list of lab orders for the specified patient,
synced with the lab testing provider (Vital).
 * @summary Fetch Lab Orders
 */
export const fetchLabOrders = (
  userId: string,
  params?: FetchLabOrdersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchLabOrdersResponseT>> => {
  return axios.default.get(`/greenfield/care/${userId}/labs/orders`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getFetchLabOrdersQueryKey = (
  userId?: string,
  params?: FetchLabOrdersParams,
) => {
  return [
    `/greenfield/care/${userId}/labs/orders`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFetchLabOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchLabOrders>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchLabOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchLabOrders>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchLabOrdersQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchLabOrders>>> = ({
    signal,
  }) => fetchLabOrders(userId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchLabOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchLabOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchLabOrders>>
>;
export type FetchLabOrdersQueryError = AxiosError<HTTPValidationError>;

export function useFetchLabOrders<
  TData = Awaited<ReturnType<typeof fetchLabOrders>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params: undefined | FetchLabOrdersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchLabOrders>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchLabOrders>>,
          TError,
          Awaited<ReturnType<typeof fetchLabOrders>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchLabOrders<
  TData = Awaited<ReturnType<typeof fetchLabOrders>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchLabOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchLabOrders>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchLabOrders>>,
          TError,
          Awaited<ReturnType<typeof fetchLabOrders>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchLabOrders<
  TData = Awaited<ReturnType<typeof fetchLabOrders>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchLabOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchLabOrders>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Lab Orders
 */

export function useFetchLabOrders<
  TData = Awaited<ReturnType<typeof fetchLabOrders>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  params?: FetchLabOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchLabOrders>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchLabOrdersQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for available biomarkers.

Returns a paginated list of biomarkers that can be used to create
custom lab tests. Supports filtering by name and lab ID.
 * @summary Search Biomarkers
 */
export const searchBiomarkers = (
  searchBiomarkersRequestT: SearchBiomarkersRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SearchBiomarkersResponseT>> => {
  return axios.default.post(
    `/greenfield/care/labs/biomarkers/search`,
    searchBiomarkersRequestT,
    options,
  );
};

export const getSearchBiomarkersMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchBiomarkers>>,
    TError,
    { data: SearchBiomarkersRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchBiomarkers>>,
  TError,
  { data: SearchBiomarkersRequestT },
  TContext
> => {
  const mutationKey = ["searchBiomarkers"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchBiomarkers>>,
    { data: SearchBiomarkersRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return searchBiomarkers(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchBiomarkersMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchBiomarkers>>
>;
export type SearchBiomarkersMutationBody = SearchBiomarkersRequestT;
export type SearchBiomarkersMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Search Biomarkers
 */
export const useSearchBiomarkers = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchBiomarkers>>,
      TError,
      { data: SearchBiomarkersRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchBiomarkers>>,
  TError,
  { data: SearchBiomarkersRequestT },
  TContext
> => {
  const mutationOptions = getSearchBiomarkersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Create a new custom lab test.

Creates a lab test with the specified biomarkers. The test can then
be ordered for patients. Only registered clinicians can create tests.
 * @summary Create Lab Test
 */
export const createLabTest = (
  createLabTestRequestT: CreateLabTestRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CreateLabTestResponseT>> => {
  return axios.default.post(
    `/greenfield/care/labs/tests`,
    createLabTestRequestT,
    options,
  );
};

export const getCreateLabTestMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLabTest>>,
    TError,
    { data: CreateLabTestRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLabTest>>,
  TError,
  { data: CreateLabTestRequestT },
  TContext
> => {
  const mutationKey = ["createLabTest"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLabTest>>,
    { data: CreateLabTestRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return createLabTest(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLabTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLabTest>>
>;
export type CreateLabTestMutationBody = CreateLabTestRequestT;
export type CreateLabTestMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Create Lab Test
 */
export const useCreateLabTest = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createLabTest>>,
      TError,
      { data: CreateLabTestRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createLabTest>>,
  TError,
  { data: CreateLabTestRequestT },
  TContext
> => {
  const mutationOptions = getCreateLabTestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Search ICD-10-CM codes by keyword (BM25) or semantic similarity (embedding).

Set `mode` to "bm25" for exact keyword matching (default) or "embedding"
for natural-language / synonym search (e.g. "heart attack" finds
"acute myocardial infarction").
 * @summary Search Icd10
 */
export const searchIcd10 = (
  searchICD10RequestT: SearchICD10RequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SearchICD10ResponseT>> => {
  return axios.default.post(
    `/greenfield/care/labs/icd10/search`,
    searchICD10RequestT,
    options,
  );
};

export const getSearchIcd10MutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchIcd10>>,
    TError,
    { data: SearchICD10RequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchIcd10>>,
  TError,
  { data: SearchICD10RequestT },
  TContext
> => {
  const mutationKey = ["searchIcd10"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchIcd10>>,
    { data: SearchICD10RequestT }
  > = (props) => {
    const { data } = props ?? {};

    return searchIcd10(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchIcd10MutationResult = NonNullable<
  Awaited<ReturnType<typeof searchIcd10>>
>;
export type SearchIcd10MutationBody = SearchICD10RequestT;
export type SearchIcd10MutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Search Icd10
 */
export const useSearchIcd10 = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchIcd10>>,
      TError,
      { data: SearchICD10RequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchIcd10>>,
  TError,
  { data: SearchICD10RequestT },
  TContext
> => {
  const mutationOptions = getSearchIcd10MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Resolve specific ICD-10-CM codes by their code strings.

Given a list of ICD-10 codes (e.g. ["E11.9", "I10"]), returns
the full code objects with descriptions.  Returns 404 if any
requested code does not exist.
 * @summary Resolve Icd10
 */
export const resolveIcd10 = (
  resolveICD10RequestT: ResolveICD10RequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ResolveICD10ResponseT>> => {
  return axios.default.post(
    `/greenfield/care/labs/icd10/resolve`,
    resolveICD10RequestT,
    options,
  );
};

export const getResolveIcd10MutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveIcd10>>,
    TError,
    { data: ResolveICD10RequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveIcd10>>,
  TError,
  { data: ResolveICD10RequestT },
  TContext
> => {
  const mutationKey = ["resolveIcd10"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveIcd10>>,
    { data: ResolveICD10RequestT }
  > = (props) => {
    const { data } = props ?? {};

    return resolveIcd10(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveIcd10MutationResult = NonNullable<
  Awaited<ReturnType<typeof resolveIcd10>>
>;
export type ResolveIcd10MutationBody = ResolveICD10RequestT;
export type ResolveIcd10MutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Resolve Icd10
 */
export const useResolveIcd10 = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resolveIcd10>>,
      TError,
      { data: ResolveICD10RequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resolveIcd10>>,
  TError,
  { data: ResolveICD10RequestT },
  TContext
> => {
  const mutationOptions = getResolveIcd10MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Shelf Store
 */
export const shelfStore = (
  patientId: string,
  storeArgsT: StoreArgsT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.default.post(
    `/greenfield/care/${patientId}/shelf/store`,
    storeArgsT,
    options,
  );
};

export const getShelfStoreMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shelfStore>>,
    TError,
    { patientId: string; data: StoreArgsT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shelfStore>>,
  TError,
  { patientId: string; data: StoreArgsT },
  TContext
> => {
  const mutationKey = ["shelfStore"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shelfStore>>,
    { patientId: string; data: StoreArgsT }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return shelfStore(patientId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShelfStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof shelfStore>>
>;
export type ShelfStoreMutationBody = StoreArgsT;
export type ShelfStoreMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Shelf Store
 */
export const useShelfStore = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof shelfStore>>,
      TError,
      { patientId: string; data: StoreArgsT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof shelfStore>>,
  TError,
  { patientId: string; data: StoreArgsT },
  TContext
> => {
  const mutationOptions = getShelfStoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Shelf Load
 */
export const shelfLoad = (
  patientId: string,
  params: ShelfLoadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LoadResultT>> => {
  return axios.default.get(`/greenfield/care/${patientId}/shelf/load`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getShelfLoadQueryKey = (
  patientId?: string,
  params?: ShelfLoadParams,
) => {
  return [
    `/greenfield/care/${patientId}/shelf/load`,
    ...(params ? [params] : []),
  ] as const;
};

export const getShelfLoadQueryOptions = <
  TData = Awaited<ReturnType<typeof shelfLoad>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  params: ShelfLoadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof shelfLoad>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getShelfLoadQueryKey(patientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof shelfLoad>>> = ({
    signal,
  }) => shelfLoad(patientId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!patientId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof shelfLoad>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ShelfLoadQueryResult = NonNullable<
  Awaited<ReturnType<typeof shelfLoad>>
>;
export type ShelfLoadQueryError = AxiosError<HTTPValidationError>;

export function useShelfLoad<
  TData = Awaited<ReturnType<typeof shelfLoad>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  params: ShelfLoadParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof shelfLoad>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shelfLoad>>,
          TError,
          Awaited<ReturnType<typeof shelfLoad>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useShelfLoad<
  TData = Awaited<ReturnType<typeof shelfLoad>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  params: ShelfLoadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof shelfLoad>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shelfLoad>>,
          TError,
          Awaited<ReturnType<typeof shelfLoad>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useShelfLoad<
  TData = Awaited<ReturnType<typeof shelfLoad>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  params: ShelfLoadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof shelfLoad>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Shelf Load
 */

export function useShelfLoad<
  TData = Awaited<ReturnType<typeof shelfLoad>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  params: ShelfLoadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof shelfLoad>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getShelfLoadQueryOptions(patientId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Shelf List
 */
export const shelfList = (
  patientId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ListResultT>> => {
  return axios.default.get(`/greenfield/care/${patientId}/shelf/list`, options);
};

export const getShelfListQueryKey = (patientId?: string) => {
  return [`/greenfield/care/${patientId}/shelf/list`] as const;
};

export const getShelfListQueryOptions = <
  TData = Awaited<ReturnType<typeof shelfList>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof shelfList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getShelfListQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof shelfList>>> = ({
    signal,
  }) => shelfList(patientId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!patientId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof shelfList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ShelfListQueryResult = NonNullable<
  Awaited<ReturnType<typeof shelfList>>
>;
export type ShelfListQueryError = AxiosError<HTTPValidationError>;

export function useShelfList<
  TData = Awaited<ReturnType<typeof shelfList>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof shelfList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shelfList>>,
          TError,
          Awaited<ReturnType<typeof shelfList>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useShelfList<
  TData = Awaited<ReturnType<typeof shelfList>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof shelfList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shelfList>>,
          TError,
          Awaited<ReturnType<typeof shelfList>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useShelfList<
  TData = Awaited<ReturnType<typeof shelfList>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof shelfList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Shelf List
 */

export function useShelfList<
  TData = Awaited<ReturnType<typeof shelfList>>,
  TError = AxiosError<HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof shelfList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getShelfListQueryOptions(patientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetch all active viewers for a patient, excluding the requesting clinician.
 * @summary Fetch Viewers For Patient
 */
export const fetchViewersForPatient = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchViewersForPatientResponseT>> => {
  return axios.default.get(`/greenfield/care/${userId}/viewers`, options);
};

export const getFetchViewersForPatientQueryKey = (userId?: string) => {
  return [`/greenfield/care/${userId}/viewers`] as const;
};

export const getFetchViewersForPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchViewersForPatient>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchViewersForPatient>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchViewersForPatientQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchViewersForPatient>>
  > = ({ signal }) =>
    fetchViewersForPatient(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchViewersForPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchViewersForPatientQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchViewersForPatient>>
>;
export type FetchViewersForPatientQueryError = AxiosError<HTTPValidationError>;

export function useFetchViewersForPatient<
  TData = Awaited<ReturnType<typeof fetchViewersForPatient>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchViewersForPatient>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchViewersForPatient>>,
          TError,
          Awaited<ReturnType<typeof fetchViewersForPatient>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchViewersForPatient<
  TData = Awaited<ReturnType<typeof fetchViewersForPatient>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchViewersForPatient>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchViewersForPatient>>,
          TError,
          Awaited<ReturnType<typeof fetchViewersForPatient>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchViewersForPatient<
  TData = Awaited<ReturnType<typeof fetchViewersForPatient>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchViewersForPatient>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Viewers For Patient
 */

export function useFetchViewersForPatient<
  TData = Awaited<ReturnType<typeof fetchViewersForPatient>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchViewersForPatient>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchViewersForPatientQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Check which clinical workflows are available for a patient.

Returns availability of lab ordering (requires insurance info) and
prescription writing (requires an existing DoseSpot patient record).
 * @summary Fetch Workflows Available
 */
export const fetchWorkflowsAvailable = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkflowsAvailableT>> => {
  return axios.default.get(
    `/greenfield/care/${userId}/workflows-available`,
    options,
  );
};

export const getFetchWorkflowsAvailableQueryKey = (userId?: string) => {
  return [`/greenfield/care/${userId}/workflows-available`] as const;
};

export const getFetchWorkflowsAvailableQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchWorkflowsAvailableQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchWorkflowsAvailable>>
  > = ({ signal }) =>
    fetchWorkflowsAvailable(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchWorkflowsAvailableQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchWorkflowsAvailable>>
>;
export type FetchWorkflowsAvailableQueryError = AxiosError<HTTPValidationError>;

export function useFetchWorkflowsAvailable<
  TData = Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
          TError,
          Awaited<ReturnType<typeof fetchWorkflowsAvailable>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchWorkflowsAvailable<
  TData = Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
          TError,
          Awaited<ReturnType<typeof fetchWorkflowsAvailable>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchWorkflowsAvailable<
  TData = Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Workflows Available
 */

export function useFetchWorkflowsAvailable<
  TData = Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchWorkflowsAvailable>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchWorkflowsAvailableQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Apply an ordered list of modifications to a patient's proposed actions.

Modifications can add, update, or remove (archive) actions. They are
applied sequentially so earlier mutations are visible to later ones.
 * @summary Apply Plan Modifications
 */
export const applyPlanModifications = (
  userId: string,
  applyPlanModificationsRequestT: ApplyPlanModificationsRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApplyPlanModificationsResponseT>> => {
  return axios.default.post(
    `/greenfield/care/${userId}/proposed-actions/apply-modifications`,
    applyPlanModificationsRequestT,
    options,
  );
};

export const getApplyPlanModificationsMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyPlanModifications>>,
    TError,
    { userId: string; data: ApplyPlanModificationsRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyPlanModifications>>,
  TError,
  { userId: string; data: ApplyPlanModificationsRequestT },
  TContext
> => {
  const mutationKey = ["applyPlanModifications"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyPlanModifications>>,
    { userId: string; data: ApplyPlanModificationsRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return applyPlanModifications(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyPlanModificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyPlanModifications>>
>;
export type ApplyPlanModificationsMutationBody = ApplyPlanModificationsRequestT;
export type ApplyPlanModificationsMutationError =
  AxiosError<HTTPValidationError>;

/**
 * @summary Apply Plan Modifications
 */
export const useApplyPlanModifications = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof applyPlanModifications>>,
      TError,
      { userId: string; data: ApplyPlanModificationsRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof applyPlanModifications>>,
  TError,
  { userId: string; data: ApplyPlanModificationsRequestT },
  TContext
> => {
  const mutationOptions = getApplyPlanModificationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Swap the current payload of a proposed action with one of its alternatives.

The previous payload is moved into the alternatives list.
 * @summary Switch To Alternative
 */
export const switchToAlternative = (
  userId: string,
  switchToAlternativeRequestT: SwitchToAlternativeRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SwitchToAlternativeResponseT>> => {
  return axios.default.post(
    `/greenfield/care/${userId}/proposed-actions/switch-alternative`,
    switchToAlternativeRequestT,
    options,
  );
};

export const getSwitchToAlternativeMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof switchToAlternative>>,
    TError,
    { userId: string; data: SwitchToAlternativeRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof switchToAlternative>>,
  TError,
  { userId: string; data: SwitchToAlternativeRequestT },
  TContext
> => {
  const mutationKey = ["switchToAlternative"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof switchToAlternative>>,
    { userId: string; data: SwitchToAlternativeRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return switchToAlternative(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SwitchToAlternativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof switchToAlternative>>
>;
export type SwitchToAlternativeMutationBody = SwitchToAlternativeRequestT;
export type SwitchToAlternativeMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Switch To Alternative
 */
export const useSwitchToAlternative = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof switchToAlternative>>,
      TError,
      { userId: string; data: SwitchToAlternativeRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof switchToAlternative>>,
  TError,
  { userId: string; data: SwitchToAlternativeRequestT },
  TContext
> => {
  const mutationOptions = getSwitchToAlternativeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Mark an approved proposed action as successfully executed.

Checks that all dependency actions have succeeded before allowing
execution. Creates a run record and sets todo_status to done.
 * @summary Mark Executed
 */
export const markExecuted = (
  userId: string,
  markExecutedRequestT: MarkExecutedRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MarkExecutedResponseT>> => {
  return axios.default.post(
    `/greenfield/care/${userId}/proposed-actions/mark-executed`,
    markExecutedRequestT,
    options,
  );
};

export const getMarkExecutedMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markExecuted>>,
    TError,
    { userId: string; data: MarkExecutedRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markExecuted>>,
  TError,
  { userId: string; data: MarkExecutedRequestT },
  TContext
> => {
  const mutationKey = ["markExecuted"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markExecuted>>,
    { userId: string; data: MarkExecutedRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return markExecuted(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkExecutedMutationResult = NonNullable<
  Awaited<ReturnType<typeof markExecuted>>
>;
export type MarkExecutedMutationBody = MarkExecutedRequestT;
export type MarkExecutedMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Mark Executed
 */
export const useMarkExecuted = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markExecuted>>,
      TError,
      { userId: string; data: MarkExecutedRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markExecuted>>,
  TError,
  { userId: string; data: MarkExecutedRequestT },
  TContext
> => {
  const mutationOptions = getMarkExecutedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Reject the original proposed action but record that the clinician
executed a revised version (e.g. changed the prescription or lab order
before confirming).
 * @summary Reject With Revision
 */
export const rejectWithRevision = (
  userId: string,
  rejectWithRevisionRequestT: RejectWithRevisionRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RejectWithRevisionResponseT>> => {
  return axios.default.post(
    `/greenfield/care/${userId}/proposed-actions/reject-with-revision`,
    rejectWithRevisionRequestT,
    options,
  );
};

export const getRejectWithRevisionMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectWithRevision>>,
    TError,
    { userId: string; data: RejectWithRevisionRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectWithRevision>>,
  TError,
  { userId: string; data: RejectWithRevisionRequestT },
  TContext
> => {
  const mutationKey = ["rejectWithRevision"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectWithRevision>>,
    { userId: string; data: RejectWithRevisionRequestT }
  > = (props) => {
    const { userId, data } = props ?? {};

    return rejectWithRevision(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectWithRevisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectWithRevision>>
>;
export type RejectWithRevisionMutationBody = RejectWithRevisionRequestT;
export type RejectWithRevisionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Reject With Revision
 */
export const useRejectWithRevision = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectWithRevision>>,
      TError,
      { userId: string; data: RejectWithRevisionRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rejectWithRevision>>,
  TError,
  { userId: string; data: RejectWithRevisionRequestT },
  TContext
> => {
  const mutationOptions = getRejectWithRevisionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Return karma points earned by the logged-in clinician.

If ``days`` is provided, only events within the last N days are counted.
Otherwise returns the all-time total.
 * @summary Get Karma Total
 */
export const getKarmaTotal = (
  params?: GetKarmaTotalParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<KarmaTotalResponseT>> => {
  return axios.default.get(`/greenfield/care/clinician-activity/karma/total`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetKarmaTotalQueryKey = (params?: GetKarmaTotalParams) => {
  return [
    `/greenfield/care/clinician-activity/karma/total`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetKarmaTotalQueryOptions = <
  TData = Awaited<ReturnType<typeof getKarmaTotal>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetKarmaTotalParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getKarmaTotal>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetKarmaTotalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getKarmaTotal>>> = ({
    signal,
  }) => getKarmaTotal(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getKarmaTotal>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetKarmaTotalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKarmaTotal>>
>;
export type GetKarmaTotalQueryError = AxiosError<HTTPValidationError>;

export function useGetKarmaTotal<
  TData = Awaited<ReturnType<typeof getKarmaTotal>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | GetKarmaTotalParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getKarmaTotal>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKarmaTotal>>,
          TError,
          Awaited<ReturnType<typeof getKarmaTotal>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetKarmaTotal<
  TData = Awaited<ReturnType<typeof getKarmaTotal>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetKarmaTotalParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getKarmaTotal>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKarmaTotal>>,
          TError,
          Awaited<ReturnType<typeof getKarmaTotal>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetKarmaTotal<
  TData = Awaited<ReturnType<typeof getKarmaTotal>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetKarmaTotalParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getKarmaTotal>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Karma Total
 */

export function useGetKarmaTotal<
  TData = Awaited<ReturnType<typeof getKarmaTotal>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetKarmaTotalParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getKarmaTotal>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetKarmaTotalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return karma points grouped into time buckets for charting.
 * @summary Get Karma Chart
 */
export const getKarmaChart = (
  params?: GetKarmaChartParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<KarmaChartResponseT>> => {
  return axios.default.get(`/greenfield/care/clinician-activity/karma/chart`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetKarmaChartQueryKey = (params?: GetKarmaChartParams) => {
  return [
    `/greenfield/care/clinician-activity/karma/chart`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetKarmaChartQueryOptions = <
  TData = Awaited<ReturnType<typeof getKarmaChart>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetKarmaChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getKarmaChart>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetKarmaChartQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getKarmaChart>>> = ({
    signal,
  }) => getKarmaChart(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getKarmaChart>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetKarmaChartQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKarmaChart>>
>;
export type GetKarmaChartQueryError = AxiosError<HTTPValidationError>;

export function useGetKarmaChart<
  TData = Awaited<ReturnType<typeof getKarmaChart>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | GetKarmaChartParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getKarmaChart>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKarmaChart>>,
          TError,
          Awaited<ReturnType<typeof getKarmaChart>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetKarmaChart<
  TData = Awaited<ReturnType<typeof getKarmaChart>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetKarmaChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getKarmaChart>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKarmaChart>>,
          TError,
          Awaited<ReturnType<typeof getKarmaChart>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetKarmaChart<
  TData = Awaited<ReturnType<typeof getKarmaChart>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetKarmaChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getKarmaChart>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Karma Chart
 */

export function useGetKarmaChart<
  TData = Awaited<ReturnType<typeof getKarmaChart>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetKarmaChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getKarmaChart>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetKarmaChartQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return recent clinician activity events (transactions) for the logged-in clinician.
 * @summary Get Clinician Activity Events
 */
export const getClinicianActivityEvents = (
  params?: GetClinicianActivityEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ClinicianActivityEventsResponseT>> => {
  return axios.default.get(`/greenfield/care/clinician-activity/events`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetClinicianActivityEventsQueryKey = (
  params?: GetClinicianActivityEventsParams,
) => {
  return [
    `/greenfield/care/clinician-activity/events`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClinicianActivityEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClinicianActivityEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetClinicianActivityEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianActivityEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClinicianActivityEventsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClinicianActivityEvents>>
  > = ({ signal }) =>
    getClinicianActivityEvents(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClinicianActivityEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClinicianActivityEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClinicianActivityEvents>>
>;
export type GetClinicianActivityEventsQueryError =
  AxiosError<HTTPValidationError>;

export function useGetClinicianActivityEvents<
  TData = Awaited<ReturnType<typeof getClinicianActivityEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | GetClinicianActivityEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianActivityEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicianActivityEvents>>,
          TError,
          Awaited<ReturnType<typeof getClinicianActivityEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicianActivityEvents<
  TData = Awaited<ReturnType<typeof getClinicianActivityEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetClinicianActivityEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianActivityEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicianActivityEvents>>,
          TError,
          Awaited<ReturnType<typeof getClinicianActivityEvents>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicianActivityEvents<
  TData = Awaited<ReturnType<typeof getClinicianActivityEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetClinicianActivityEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianActivityEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Clinician Activity Events
 */

export function useGetClinicianActivityEvents<
  TData = Awaited<ReturnType<typeof getClinicianActivityEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetClinicianActivityEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianActivityEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClinicianActivityEventsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return karma offers for every open request on a patient.
 * @summary Get Patient Karma Offers
 */
export const getPatientKarmaOffers = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PatientKarmaOffersResponseT>> => {
  return axios.default.get(`/greenfield/care/${userId}/karma-offers`, options);
};

export const getGetPatientKarmaOffersQueryKey = (userId?: string) => {
  return [`/greenfield/care/${userId}/karma-offers`] as const;
};

export const getGetPatientKarmaOffersQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientKarmaOffers>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientKarmaOffers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientKarmaOffersQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientKarmaOffers>>
  > = ({ signal }) =>
    getPatientKarmaOffers(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientKarmaOffers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientKarmaOffersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientKarmaOffers>>
>;
export type GetPatientKarmaOffersQueryError = AxiosError<HTTPValidationError>;

export function useGetPatientKarmaOffers<
  TData = Awaited<ReturnType<typeof getPatientKarmaOffers>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientKarmaOffers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientKarmaOffers>>,
          TError,
          Awaited<ReturnType<typeof getPatientKarmaOffers>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientKarmaOffers<
  TData = Awaited<ReturnType<typeof getPatientKarmaOffers>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientKarmaOffers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientKarmaOffers>>,
          TError,
          Awaited<ReturnType<typeof getPatientKarmaOffers>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientKarmaOffers<
  TData = Awaited<ReturnType<typeof getPatientKarmaOffers>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientKarmaOffers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient Karma Offers
 */

export function useGetPatientKarmaOffers<
  TData = Awaited<ReturnType<typeof getPatientKarmaOffers>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientKarmaOffers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientKarmaOffersQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return the current bank link status for the logged-in clinician.
 * @summary Get Bank Link
 */
export const getBankLink = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BankLinkT>> => {
  return axios.default.get(
    `/greenfield/care/clinician-activity/bank-link`,
    options,
  );
};

export const getGetBankLinkQueryKey = () => {
  return [`/greenfield/care/clinician-activity/bank-link`] as const;
};

export const getGetBankLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof getBankLink>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getBankLink>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBankLinkQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankLink>>> = ({
    signal,
  }) => getBankLink({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBankLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBankLinkQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBankLink>>
>;
export type GetBankLinkQueryError = AxiosError<HTTPValidationError>;

export function useGetBankLink<
  TData = Awaited<ReturnType<typeof getBankLink>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBankLink>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankLink>>,
          TError,
          Awaited<ReturnType<typeof getBankLink>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBankLink<
  TData = Awaited<ReturnType<typeof getBankLink>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBankLink>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankLink>>,
          TError,
          Awaited<ReturnType<typeof getBankLink>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBankLink<
  TData = Awaited<ReturnType<typeof getBankLink>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBankLink>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bank Link
 */

export function useGetBankLink<
  TData = Awaited<ReturnType<typeof getBankLink>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBankLink>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBankLinkQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Register the clinician's bank account with Mercury and store the link.
 * @summary Link Bank Account
 */
export const linkBankAccount = (
  linkBankAccountRequestT: LinkBankAccountRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BankLinkT>> => {
  return axios.default.post(
    `/greenfield/care/clinician-activity/bank-link`,
    linkBankAccountRequestT,
    options,
  );
};

export const getLinkBankAccountMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkBankAccount>>,
    TError,
    { data: LinkBankAccountRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof linkBankAccount>>,
  TError,
  { data: LinkBankAccountRequestT },
  TContext
> => {
  const mutationKey = ["linkBankAccount"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof linkBankAccount>>,
    { data: LinkBankAccountRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return linkBankAccount(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LinkBankAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof linkBankAccount>>
>;
export type LinkBankAccountMutationBody = LinkBankAccountRequestT;
export type LinkBankAccountMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Link Bank Account
 */
export const useLinkBankAccount = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof linkBankAccount>>,
      TError,
      { data: LinkBankAccountRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof linkBankAccount>>,
  TError,
  { data: LinkBankAccountRequestT },
  TContext
> => {
  const mutationOptions = getLinkBankAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deactivate the clinician's bank link.
 * @summary Remove Bank Link
 */
export const removeBankLink = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.delete(
    `/greenfield/care/clinician-activity/bank-link`,
    options,
  );
};

export const getRemoveBankLinkMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeBankLink>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeBankLink>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["removeBankLink"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeBankLink>>,
    void
  > = () => {
    return removeBankLink(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveBankLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeBankLink>>
>;

export type RemoveBankLinkMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Remove Bank Link
 */
export const useRemoveBankLink = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeBankLink>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeBankLink>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRemoveBankLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Return all clinician bank links (admin view).
 * @summary List All Bank Links
 */
export const listAllBankLinks = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AllBankLinksResponseT>> => {
  return axios.default.get(
    `/greenfield/care/clinician-activity/admin/bank-links`,
    options,
  );
};

export const getListAllBankLinksQueryKey = () => {
  return [`/greenfield/care/clinician-activity/admin/bank-links`] as const;
};

export const getListAllBankLinksQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllBankLinks>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listAllBankLinks>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllBankLinksQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAllBankLinks>>
  > = ({ signal }) => listAllBankLinks({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllBankLinks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAllBankLinksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllBankLinks>>
>;
export type ListAllBankLinksQueryError = AxiosError<HTTPValidationError>;

export function useListAllBankLinks<
  TData = Awaited<ReturnType<typeof listAllBankLinks>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllBankLinks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllBankLinks>>,
          TError,
          Awaited<ReturnType<typeof listAllBankLinks>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAllBankLinks<
  TData = Awaited<ReturnType<typeof listAllBankLinks>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllBankLinks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllBankLinks>>,
          TError,
          Awaited<ReturnType<typeof listAllBankLinks>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAllBankLinks<
  TData = Awaited<ReturnType<typeof listAllBankLinks>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllBankLinks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List All Bank Links
 */

export function useListAllBankLinks<
  TData = Awaited<ReturnType<typeof listAllBankLinks>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllBankLinks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAllBankLinksQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Assign or update a Mercury recipient ID for a clinician (admin).
 * @summary Assign Recipient Id
 */
export const assignRecipientId = (
  clinicianId: string,
  assignRecipientIdRequestT: AssignRecipientIdRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ClinicianBankLinkInfoT>> => {
  return axios.default.put(
    `/greenfield/care/clinician-activity/admin/bank-link/${clinicianId}`,
    assignRecipientIdRequestT,
    options,
  );
};

export const getAssignRecipientIdMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignRecipientId>>,
    TError,
    { clinicianId: string; data: AssignRecipientIdRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignRecipientId>>,
  TError,
  { clinicianId: string; data: AssignRecipientIdRequestT },
  TContext
> => {
  const mutationKey = ["assignRecipientId"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignRecipientId>>,
    { clinicianId: string; data: AssignRecipientIdRequestT }
  > = (props) => {
    const { clinicianId, data } = props ?? {};

    return assignRecipientId(clinicianId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignRecipientIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignRecipientId>>
>;
export type AssignRecipientIdMutationBody = AssignRecipientIdRequestT;
export type AssignRecipientIdMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Assign Recipient Id
 */
export const useAssignRecipientId = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignRecipientId>>,
      TError,
      { clinicianId: string; data: AssignRecipientIdRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof assignRecipientId>>,
  TError,
  { clinicianId: string; data: AssignRecipientIdRequestT },
  TContext
> => {
  const mutationOptions = getAssignRecipientIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Return proposed and confirmed banking details for a clinician.
 * @summary Fetch Banking Details
 */
export const fetchBankingDetails = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchBankingDetailsResponseT>> => {
  return axios.default.get(
    `/greenfield/care/clinician-activity/banking-details/${userId}`,
    options,
  );
};

export const getFetchBankingDetailsQueryKey = (userId?: string) => {
  return [
    `/greenfield/care/clinician-activity/banking-details/${userId}`,
  ] as const;
};

export const getFetchBankingDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchBankingDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchBankingDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchBankingDetailsQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchBankingDetails>>
  > = ({ signal }) => fetchBankingDetails(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchBankingDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchBankingDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchBankingDetails>>
>;
export type FetchBankingDetailsQueryError = AxiosError<HTTPValidationError>;

export function useFetchBankingDetails<
  TData = Awaited<ReturnType<typeof fetchBankingDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchBankingDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchBankingDetails>>,
          TError,
          Awaited<ReturnType<typeof fetchBankingDetails>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchBankingDetails<
  TData = Awaited<ReturnType<typeof fetchBankingDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchBankingDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchBankingDetails>>,
          TError,
          Awaited<ReturnType<typeof fetchBankingDetails>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchBankingDetails<
  TData = Awaited<ReturnType<typeof fetchBankingDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchBankingDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Banking Details
 */

export function useFetchBankingDetails<
  TData = Awaited<ReturnType<typeof fetchBankingDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchBankingDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchBankingDetailsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update the authenticated clinician's self-reported banking details.
 * @summary Update Banking Details
 */
export const updateBankingDetails = (
  updateBankingDetailsRequestT: UpdateBankingDetailsRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchBankingDetailsResponseT>> => {
  return axios.default.put(
    `/greenfield/care/clinician-activity/banking-details`,
    updateBankingDetailsRequestT,
    options,
  );
};

export const getUpdateBankingDetailsMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBankingDetails>>,
    TError,
    { data: UpdateBankingDetailsRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBankingDetails>>,
  TError,
  { data: UpdateBankingDetailsRequestT },
  TContext
> => {
  const mutationKey = ["updateBankingDetails"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBankingDetails>>,
    { data: UpdateBankingDetailsRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return updateBankingDetails(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBankingDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBankingDetails>>
>;
export type UpdateBankingDetailsMutationBody = UpdateBankingDetailsRequestT;
export type UpdateBankingDetailsMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Banking Details
 */
export const useUpdateBankingDetails = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBankingDetails>>,
      TError,
      { data: UpdateBankingDetailsRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBankingDetails>>,
  TError,
  { data: UpdateBankingDetailsRequestT },
  TContext
> => {
  const mutationOptions = getUpdateBankingDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Return one row per clinician for the admin payout dashboard.
 * @summary List Clinician Payout Dashboard
 */
export const listClinicianPayoutDashboard = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ClinicianPayoutDashboardResponseT>> => {
  return axios.default.get(
    `/greenfield/care/clinician-activity/admin/payouts`,
    options,
  );
};

export const getListClinicianPayoutDashboardQueryKey = () => {
  return [`/greenfield/care/clinician-activity/admin/payouts`] as const;
};

export const getListClinicianPayoutDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListClinicianPayoutDashboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listClinicianPayoutDashboard>>
  > = ({ signal }) => listClinicianPayoutDashboard({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListClinicianPayoutDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClinicianPayoutDashboard>>
>;
export type ListClinicianPayoutDashboardQueryError =
  AxiosError<HTTPValidationError>;

export function useListClinicianPayoutDashboard<
  TData = Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
          TError,
          Awaited<ReturnType<typeof listClinicianPayoutDashboard>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListClinicianPayoutDashboard<
  TData = Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
          TError,
          Awaited<ReturnType<typeof listClinicianPayoutDashboard>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListClinicianPayoutDashboard<
  TData = Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Clinician Payout Dashboard
 */

export function useListClinicianPayoutDashboard<
  TData = Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClinicianPayoutDashboard>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListClinicianPayoutDashboardQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return the full karma payout ledger for a single clinician.

Used by the "previous transactions" modal on the admin dashboard.
 * @summary List Clinician Payout History
 */
export const listClinicianPayoutHistory = (
  clinicianId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<KarmaPayoutHistoryResponseT>> => {
  return axios.default.get(
    `/greenfield/care/clinician-activity/admin/payouts/${clinicianId}/history`,
    options,
  );
};

export const getListClinicianPayoutHistoryQueryKey = (clinicianId?: string) => {
  return [
    `/greenfield/care/clinician-activity/admin/payouts/${clinicianId}/history`,
  ] as const;
};

export const getListClinicianPayoutHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
  TError = AxiosError<HTTPValidationError>,
>(
  clinicianId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListClinicianPayoutHistoryQueryKey(clinicianId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listClinicianPayoutHistory>>
  > = ({ signal }) =>
    listClinicianPayoutHistory(clinicianId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!clinicianId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListClinicianPayoutHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClinicianPayoutHistory>>
>;
export type ListClinicianPayoutHistoryQueryError =
  AxiosError<HTTPValidationError>;

export function useListClinicianPayoutHistory<
  TData = Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
  TError = AxiosError<HTTPValidationError>,
>(
  clinicianId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
          TError,
          Awaited<ReturnType<typeof listClinicianPayoutHistory>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListClinicianPayoutHistory<
  TData = Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
  TError = AxiosError<HTTPValidationError>,
>(
  clinicianId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
          TError,
          Awaited<ReturnType<typeof listClinicianPayoutHistory>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListClinicianPayoutHistory<
  TData = Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
  TError = AxiosError<HTTPValidationError>,
>(
  clinicianId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Clinician Payout History
 */

export function useListClinicianPayoutHistory<
  TData = Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
  TError = AxiosError<HTTPValidationError>,
>(
  clinicianId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClinicianPayoutHistory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListClinicianPayoutHistoryQueryOptions(
    clinicianId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return dossier-backed banking details for one clinician.

Resolves the best ``BankingDetailsDetailT`` the dossier has deduced
for the clinician -- preferring Mercury-confirmed clues over
self-reported proposals. The routing number, account type, holder
name and a masked last-4 of the account number are always returned.
The full account number is only returned when the caller passes
``?reveal=true`` so reveals are distinguishable in the audit log.
 * @summary Get Clinician Bank Details
 */
export const getClinicianBankDetails = (
  clinicianId: string,
  params?: GetClinicianBankDetailsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ClinicianBankDetailsResponseT>> => {
  return axios.default.get(
    `/greenfield/care/clinician-activity/admin/payouts/${clinicianId}/bank-details`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetClinicianBankDetailsQueryKey = (
  clinicianId?: string,
  params?: GetClinicianBankDetailsParams,
) => {
  return [
    `/greenfield/care/clinician-activity/admin/payouts/${clinicianId}/bank-details`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClinicianBankDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClinicianBankDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  clinicianId: string,
  params?: GetClinicianBankDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianBankDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClinicianBankDetailsQueryKey(clinicianId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClinicianBankDetails>>
  > = ({ signal }) =>
    getClinicianBankDetails(clinicianId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!clinicianId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClinicianBankDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClinicianBankDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClinicianBankDetails>>
>;
export type GetClinicianBankDetailsQueryError = AxiosError<HTTPValidationError>;

export function useGetClinicianBankDetails<
  TData = Awaited<ReturnType<typeof getClinicianBankDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  clinicianId: string,
  params: undefined | GetClinicianBankDetailsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianBankDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicianBankDetails>>,
          TError,
          Awaited<ReturnType<typeof getClinicianBankDetails>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicianBankDetails<
  TData = Awaited<ReturnType<typeof getClinicianBankDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  clinicianId: string,
  params?: GetClinicianBankDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianBankDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicianBankDetails>>,
          TError,
          Awaited<ReturnType<typeof getClinicianBankDetails>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClinicianBankDetails<
  TData = Awaited<ReturnType<typeof getClinicianBankDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  clinicianId: string,
  params?: GetClinicianBankDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianBankDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Clinician Bank Details
 */

export function useGetClinicianBankDetails<
  TData = Awaited<ReturnType<typeof getClinicianBankDetails>>,
  TError = AxiosError<HTTPValidationError>,
>(
  clinicianId: string,
  params?: GetClinicianBankDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClinicianBankDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClinicianBankDetailsQueryOptions(
    clinicianId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Trigger the monthly karma payout sweep immediately.

Idempotent per ``(clinician, month)``: if the sweep has already run for the
current period, Mercury rejects the duplicate idempotency key and nothing
is double-paid. Safe for admins to retry.
 * @summary Run Payout Sweep
 */
export const runPayoutSweep = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RunPayoutSweepResponseT>> => {
  return axios.default.post(
    `/greenfield/care/clinician-activity/admin/payouts/sweep`,
    undefined,
    options,
  );
};

export const getRunPayoutSweepMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runPayoutSweep>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runPayoutSweep>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["runPayoutSweep"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runPayoutSweep>>,
    void
  > = () => {
    return runPayoutSweep(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunPayoutSweepMutationResult = NonNullable<
  Awaited<ReturnType<typeof runPayoutSweep>>
>;

export type RunPayoutSweepMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Run Payout Sweep
 */
export const useRunPayoutSweep = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runPayoutSweep>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runPayoutSweep>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRunPayoutSweepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Search for stock insurance payers whose names match *filter*.

Pass an empty *filter* with a ``null`` *limit* to retrieve all known
payers.  Pass a non-empty *filter* for real-time typeahead search.

Backed by a TurboPuffer store that is populated by the payer indexer
pipeline (Stedi → Junction resolution → BM25 index).
 * @summary Search Stock Payers
 */
export const searchStockPayers = (
  searchStockPayersArgsT: SearchStockPayersArgsT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SearchStockPayersResultT>> => {
  return axios.default.post(
    `/greenfield/onboarding/insurance/payers/search`,
    searchStockPayersArgsT,
    options,
  );
};

export const getSearchStockPayersMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchStockPayers>>,
    TError,
    { data: SearchStockPayersArgsT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchStockPayers>>,
  TError,
  { data: SearchStockPayersArgsT },
  TContext
> => {
  const mutationKey = ["searchStockPayers"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchStockPayers>>,
    { data: SearchStockPayersArgsT }
  > = (props) => {
    const { data } = props ?? {};

    return searchStockPayers(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchStockPayersMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchStockPayers>>
>;
export type SearchStockPayersMutationBody = SearchStockPayersArgsT;
export type SearchStockPayersMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Search Stock Payers
 */
export const useSearchStockPayers = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchStockPayers>>,
      TError,
      { data: SearchStockPayersArgsT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchStockPayers>>,
  TError,
  { data: SearchStockPayersArgsT },
  TContext
> => {
  const mutationOptions = getSearchStockPayersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List Surveys
 */
export const listSurveys = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ListSurveysReplyT>> => {
  return axios.default.get(`/greenfield/surveys`, options);
};

export const getListSurveysQueryKey = () => {
  return [`/greenfield/surveys`] as const;
};

export const getListSurveysQueryOptions = <
  TData = Awaited<ReturnType<typeof listSurveys>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listSurveys>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSurveysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSurveys>>> = ({
    signal,
  }) => listSurveys({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSurveys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSurveysQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSurveys>>
>;
export type ListSurveysQueryError = AxiosError<HTTPValidationError>;

export function useListSurveys<
  TData = Awaited<ReturnType<typeof listSurveys>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSurveys>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSurveys>>,
          TError,
          Awaited<ReturnType<typeof listSurveys>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSurveys<
  TData = Awaited<ReturnType<typeof listSurveys>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSurveys>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSurveys>>,
          TError,
          Awaited<ReturnType<typeof listSurveys>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSurveys<
  TData = Awaited<ReturnType<typeof listSurveys>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSurveys>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Surveys
 */

export function useListSurveys<
  TData = Awaited<ReturnType<typeof listSurveys>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSurveys>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSurveysQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Survey
 */
export const getSurvey = (
  surveyId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetSurvey200>> => {
  return axios.default.get(`/greenfield/surveys/${surveyId}`, options);
};

export const getGetSurveyQueryKey = (surveyId?: string) => {
  return [`/greenfield/surveys/${surveyId}`] as const;
};

export const getGetSurveyQueryOptions = <
  TData = Awaited<ReturnType<typeof getSurvey>>,
  TError = AxiosError<HTTPValidationError>,
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSurveyQueryKey(surveyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurvey>>> = ({
    signal,
  }) => getSurvey(surveyId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!surveyId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetSurveyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSurvey>>
>;
export type GetSurveyQueryError = AxiosError<HTTPValidationError>;

export function useGetSurvey<
  TData = Awaited<ReturnType<typeof getSurvey>>,
  TError = AxiosError<HTTPValidationError>,
>(
  surveyId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurvey>>,
          TError,
          Awaited<ReturnType<typeof getSurvey>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSurvey<
  TData = Awaited<ReturnType<typeof getSurvey>>,
  TError = AxiosError<HTTPValidationError>,
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurvey>>,
          TError,
          Awaited<ReturnType<typeof getSurvey>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSurvey<
  TData = Awaited<ReturnType<typeof getSurvey>>,
  TError = AxiosError<HTTPValidationError>,
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Survey
 */

export function useGetSurvey<
  TData = Awaited<ReturnType<typeof getSurvey>>,
  TError = AxiosError<HTTPValidationError>,
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSurveyQueryOptions(surveyId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Submit Answers
 */
export const submitAnswers = (
  surveyId: string,
  submitAnswersRequestT: SubmitAnswersRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SubmitAnswers200>> => {
  return axios.default.post(
    `/greenfield/surveys/${surveyId}/submissions`,
    submitAnswersRequestT,
    options,
  );
};

export const getSubmitAnswersMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitAnswers>>,
    TError,
    { surveyId: string; data: SubmitAnswersRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitAnswers>>,
  TError,
  { surveyId: string; data: SubmitAnswersRequestT },
  TContext
> => {
  const mutationKey = ["submitAnswers"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitAnswers>>,
    { surveyId: string; data: SubmitAnswersRequestT }
  > = (props) => {
    const { surveyId, data } = props ?? {};

    return submitAnswers(surveyId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitAnswersMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitAnswers>>
>;
export type SubmitAnswersMutationBody = SubmitAnswersRequestT;
export type SubmitAnswersMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Submit Answers
 */
export const useSubmitAnswers = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitAnswers>>,
      TError,
      { surveyId: string; data: SubmitAnswersRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitAnswers>>,
  TError,
  { surveyId: string; data: SubmitAnswersRequestT },
  TContext
> => {
  const mutationOptions = getSubmitAnswersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Archive Survey
 */
export const archiveSurvey = (
  surveyId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ArchiveSurvey200>> => {
  return axios.default.post(
    `/greenfield/surveys/${surveyId}/archive`,
    undefined,
    options,
  );
};

export const getArchiveSurveyMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveSurvey>>,
    TError,
    { surveyId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveSurvey>>,
  TError,
  { surveyId: string },
  TContext
> => {
  const mutationKey = ["archiveSurvey"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveSurvey>>,
    { surveyId: string }
  > = (props) => {
    const { surveyId } = props ?? {};

    return archiveSurvey(surveyId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveSurveyMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveSurvey>>
>;

export type ArchiveSurveyMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Archive Survey
 */
export const useArchiveSurvey = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveSurvey>>,
      TError,
      { surveyId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof archiveSurvey>>,
  TError,
  { surveyId: string },
  TContext
> => {
  const mutationOptions = getArchiveSurveyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create Own Phr Survey
 */
export const createOwnPhrSurvey = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CreateOwnPhrSurvey200>> => {
  return axios.default.post(
    `/greenfield/surveys/phr/create`,
    undefined,
    options,
  );
};

export const getCreateOwnPhrSurveyMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOwnPhrSurvey>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOwnPhrSurvey>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["createOwnPhrSurvey"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOwnPhrSurvey>>,
    void
  > = () => {
    return createOwnPhrSurvey(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOwnPhrSurveyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOwnPhrSurvey>>
>;

export type CreateOwnPhrSurveyMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Create Own Phr Survey
 */
export const useCreateOwnPhrSurvey = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOwnPhrSurvey>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOwnPhrSurvey>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getCreateOwnPhrSurveyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Fetch all available search sources for testing.
 * @summary Fetch Available Sources
 */
export const fetchAvailableSources = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FetchAvailableSourcesResponseT>> => {
  return axios.default.get(`/greenfield/unified_search/sources`, options);
};

export const getFetchAvailableSourcesQueryKey = () => {
  return [`/greenfield/unified_search/sources`] as const;
};

export const getFetchAvailableSourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchAvailableSources>>,
  TError = AxiosError<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchAvailableSources>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFetchAvailableSourcesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchAvailableSources>>
  > = ({ signal }) => fetchAvailableSources({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchAvailableSources>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchAvailableSourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchAvailableSources>>
>;
export type FetchAvailableSourcesQueryError = AxiosError<HTTPValidationError>;

export function useFetchAvailableSources<
  TData = Awaited<ReturnType<typeof fetchAvailableSources>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchAvailableSources>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchAvailableSources>>,
          TError,
          Awaited<ReturnType<typeof fetchAvailableSources>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchAvailableSources<
  TData = Awaited<ReturnType<typeof fetchAvailableSources>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchAvailableSources>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchAvailableSources>>,
          TError,
          Awaited<ReturnType<typeof fetchAvailableSources>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchAvailableSources<
  TData = Awaited<ReturnType<typeof fetchAvailableSources>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchAvailableSources>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetch Available Sources
 */

export function useFetchAvailableSources<
  TData = Awaited<ReturnType<typeof fetchAvailableSources>>,
  TError = AxiosError<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchAvailableSources>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchAvailableSourcesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Perform a search across selected sources.
 * @summary Perform Search
 */
export const performSearch = (
  unifiedSearchRequestT: UnifiedSearchRequestT,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UnifiedSearchResponseT>> => {
  return axios.default.post(
    `/greenfield/unified_search/search`,
    unifiedSearchRequestT,
    options,
  );
};

export const getPerformSearchMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof performSearch>>,
    TError,
    { data: UnifiedSearchRequestT },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof performSearch>>,
  TError,
  { data: UnifiedSearchRequestT },
  TContext
> => {
  const mutationKey = ["performSearch"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof performSearch>>,
    { data: UnifiedSearchRequestT }
  > = (props) => {
    const { data } = props ?? {};

    return performSearch(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PerformSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof performSearch>>
>;
export type PerformSearchMutationBody = UnifiedSearchRequestT;
export type PerformSearchMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Perform Search
 */
export const usePerformSearch = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof performSearch>>,
      TError,
      { data: UnifiedSearchRequestT },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof performSearch>>,
  TError,
  { data: UnifiedSearchRequestT },
  TContext
> => {
  const mutationOptions = getPerformSearchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
